(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("angular"));
	else if(typeof define === 'function' && define.amd)
		define(["angular"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("angular")) : factory(root["angular"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE_angular__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/angularjs/index.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./icons/add-lg.svg":
/*!**************************!*\
  !*** ./icons/add-lg.svg ***!
  \**************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon-lg\" viewBox=\"0 0 24 24\"><path fill=\"none\" d=\"M0 0h24v24H0z\"/><path d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z\"/></svg>"

/***/ }),

/***/ "./icons/add-with-circle.svg":
/*!***********************************!*\
  !*** ./icons/add-with-circle.svg ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon cu-icon-fill-stroke\" viewBox=\"0 0 16 16\"><circle stroke=\"currentColor\" fill=\"none\" stroke-width=\"2\" cx=\"8\" cy=\"8\" r=\"7\"/><path d=\"M8.25 4.75h-.5v3h-3v.5h3v3h.5v-3h3v-.5h-3v-3z\"/></svg>"

/***/ }),

/***/ "./icons/add.svg":
/*!***********************!*\
  !*** ./icons/add.svg ***!
  \***********************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 13 13\"><g fill-rule=\"evenodd\"><circle cx=\"6.5\" cy=\"6.5\" r=\"6.5\"/><path d=\"M6.5 4.063v4.875M4.063 6.5h4.875\" stroke=\"#FFF\" stroke-width=\"2\" stroke-linecap=\"square\"/></g></svg>"

/***/ }),

/***/ "./icons/alarm.svg":
/*!*************************!*\
  !*** ./icons/alarm.svg ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><g fill-rule=\"evenodd\"><path d=\"M7 10h2v2H7v-2zm0-6h2v5H7V4z\"/><path d=\"M12.243 12.243a6 6 0 1 0-8.486-8.486 6 6 0 0 0 8.486 8.486zm-9.9 1.414A8 8 0 1 1 13.657 2.343 8 8 0 0 1 2.343 13.657z\" fill-rule=\"nonzero\"/></g></svg>"

/***/ }),

/***/ "./icons/app-switcher.svg":
/*!********************************!*\
  !*** ./icons/app-switcher.svg ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M0 0h4v4H0zm6 0h4v4H6zm6 0h4v4h-4zM0 6h4v4H0zm6 0h4v4H6zm6 0h4v4h-4zM0 12h4v4H0zm6 0h4v4H6zm6 0h4v4h-4z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/at.svg":
/*!**********************!*\
  !*** ./icons/at.svg ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M8,0 C3.57874194,0 0,3.57803226 0,8 C0,12.4212581 3.57803226,16 8,16 C9.55335484,16 11.0755484,15.543871 12.368,14.7024839 C12.7552581,14.4503871 12.8397742,13.919 12.5470968,13.5614516 L12.2188065,13.1603871 C11.9713548,12.8580968 11.5356129,12.7840323 11.2067742,12.9949355 C10.2554839,13.6050645 9.13916129,13.9354839 8,13.9354839 C4.72716129,13.9354839 2.06451613,11.2728387 2.06451613,8 C2.06451613,4.72716129 4.72716129,2.06451613 8,2.06451613 C11.2302903,2.06451613 13.9354839,3.92319355 13.9354839,7.22580645 C13.9354839,8.47696774 13.2550645,9.79812903 12.0590323,9.92558065 C11.4993871,9.91093548 11.5135484,9.51083871 11.6243226,8.95706452 L12.3802258,5.05029032 C12.4726774,4.57258065 12.1067097,4.12903226 11.6201613,4.12903226 L10.1691613,4.12903226 C9.94736037,4.12902742 9.76089289,4.29551821 9.73587097,4.51590323 L9.73554839,4.51887097 C9.26145161,3.94141935 8.43077419,3.81645161 7.801,3.81645161 C5.39519355,3.81645161 3.35483871,5.824 3.35483871,8.70225806 C3.35483871,10.8088065 4.54145161,12.1174194 6.4516129,12.1174194 C7.32206452,12.1174194 8.30222581,11.613 8.87067742,10.880871 C9.17783871,11.981 10.1807742,11.9809677 11.1516452,11.9809677 C14.6648065,11.9809677 16,9.67090323 16,7.22580645 C16,2.82751613 12.4523548,0 8,0 Z M7.30064516,9.82032258 C6.58293548,9.82032258 6.13709677,9.31635484 6.13709677,8.50512903 C6.13709677,7.05374194 7.12996774,6.15903226 8.0283871,6.15903226 C8.74748387,6.15903226 9.17680645,6.65067742 9.17680645,7.47419355 C9.17680645,8.92777419 8.08406452,9.82032258 7.30064516,9.82032258 Z\"/></svg>"

/***/ }),

/***/ "./icons/bar-graph.svg":
/*!*****************************!*\
  !*** ./icons/bar-graph.svg ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"1 1 13 13\"><path d=\"M2 5h2v8H2V5zm6 1h2v7H8V6zm3 3h2v4h-2V9zM5 2h2v11H5V2z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/beautify.svg":
/*!****************************!*\
  !*** ./icons/beautify.svg ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M3.178 15.767L.25 12.837a.744.744 0 010-1.055L11.767.265a.744.744 0 011.055 0l2.929 2.929a.744.744 0 010 1.055L4.233 15.767a.75.75 0 01-1.055 0zM9.494 5.002l1.52 1.52 2.798-2.799-1.52-1.52-2.798 2.8zM4.354 1.27l-.363.74-.816.12a.18.18 0 00-.1.304l.592.576-.14.813a.179.179 0 00.258.19l.729-.387.728.383a.179.179 0 00.258-.19l-.14-.812.592-.576a.18.18 0 00-.1-.305l-.815-.118-.365-.741c-.062-.128-.252-.128-.317.003zM7.397.626l-.243.492-.544.08a.12.12 0 00-.066.203l.392.383-.093.541a.12.12 0 00.174.125l.486-.255.486.255a.12.12 0 00.174-.125l-.094-.541.393-.383a.118.118 0 00-.066-.203l-.544-.077-.243-.492a.116.116 0 00-.212-.003zm-5.977 0l-.242.492-.545.08a.119.119 0 00-.065.203l.392.383-.094.541a.12.12 0 00.175.125l.485-.255.486.255a.12.12 0 00.174-.125l-.093-.541.392-.383a.118.118 0 00-.065-.203l-.545-.077L1.63.629a.116.116 0 00-.21-.003zm12.95 6.957l-.243.492-.545.078a.118.118 0 00-.065.202l.392.383-.093.541a.12.12 0 00.174.125l.486-.255.485.255a.12.12 0 00.175-.125l-.094-.541.392-.383a.118.118 0 00-.065-.202l-.545-.078-.242-.492a.118.118 0 00-.212 0z\"/></svg>"

/***/ }),

/***/ "./icons/bell.svg":
/*!************************!*\
  !*** ./icons/bell.svg ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M14.294 10.342c-.531-.525-1.08-1.067-1.08-3.628a5.222 5.222 0 0 0-4.39-5.149 1 1 0 1 0-1.65 0 5.222 5.222 0 0 0-4.388 5.15c0 2.56-.549 3.102-1.08 3.627C.203 11.826 1.304 14 3.091 14H6a2 2 0 0 0 4 0h2.909c1.787 0 2.888-2.174 1.385-3.658zM8 14.75a.75.75 0 0 1-.75-.75h1.5a.75.75 0 0 1-.75.75zm4.91-2.25H3.09a.59.59 0 0 1-.416-1.006c.893-.893 1.612-1.741 1.612-4.78A3.718 3.718 0 0 1 8 3a3.718 3.718 0 0 1 3.714 3.714c0 3.052.726 3.893 1.612 4.78a.59.59 0 0 1-.417 1.006z\"/></svg>"

/***/ }),

/***/ "./icons/bullhorn.svg":
/*!****************************!*\
  !*** ./icons/bullhorn.svg ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" width=\"16\" height=\"16\" viewBox=\"0 0 24 22\"><path d=\"M20,0.33333333 C21.47275,0.33333333 22.6666667,1.52725 22.6666667,3 L22.6666667,3 L22.6666667,7.78091667 C23.4433333,8.05558333 24,8.796 24,9.6666667 C24,10.5373333 23.4433333,11.27775 22.6666667,11.5524167 L22.6666667,11.5524167 L22.6666667,16.3333333 C22.6666667,17.8060833 21.47275,19 20,19 C17.4412917,16.7950417 14.4334583,13.9952917 9.54045833,13.6937917 C8.20304167,14.1373333 7.67270833,15.6968333 8.35225,16.725125 C8.44819686,16.8694138 8.46458396,17.0524633 8.39579167,17.2115 C7.96491667,18.2093333 8.44941667,18.9961667 9.22058333,19.74725 C9.73883333,20.252 9.57575,21.11825 8.90716667,21.394625 C7.84808333,21.832375 5.86579167,21.728125 4.99995833,21.18 C4.80333333,21.0555417 4.65745833,20.865 4.58654167,20.6433333 C3.90591667,18.5157917 3.02170833,16.3604167 3.802625,13.6666667 L3.802625,13.6666667 L2,13.6666667 C0.895416667,13.6666667 0,12.77125 0,11.6666667 L0,11.6666667 L0,7.66666667 C0,6.56208333 0.895416667,5.66666667 2,5.66666667 L2,5.66666667 L8.66666667,5.66666667 C14.0820417,5.66666667 17.2922917,2.66666667 20,0.33333333 Z M20,3.83933333 C17.724625,5.7135 14.7902917,7.71183333 10.6666667,8.21358333 L10.6666667,8.21358333 L10.6666667,11.1197083 C14.7902917,11.6214583 17.724625,13.6198333 20,15.4939583 L20,15.4939583 L20,3.83933333 Z\"/></svg>"

/***/ }),

/***/ "./icons/calendar.svg":
/*!****************************!*\
  !*** ./icons/calendar.svg ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 14 15\"><path d=\"M2 13h9.994C12 13 12 8 12 8H2v5zM4.001 0S6 .003 6 .009V2h2L8.001.015V0S10 .003 10 .009V2h1.994C13.103 2 14 2.898 14 4.006v8.996A2.001 2.001 0 0111.994 15H2.006A1.997 1.997 0 010 13.002V4.006C0 2.886.898 2 2.006 2H4l.001-2.001zm6 4.004L10 5H8v-.998H5.995L6 5H4V4H2.006C1.996 4 2 7 2 7h10V4.005l-.189-.001-1.81-.002z\"/></svg>"

/***/ }),

/***/ "./icons/checkmark.svg":
/*!*****************************!*\
  !*** ./icons/checkmark.svg ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M6.094 10.18L3.268 7.354 1.854 8.768l4.242 4.242 1.414-1.414-.001-.002 5.826-5.826-1.414-1.414-5.827 5.826z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/chevron-down.svg":
/*!********************************!*\
  !*** ./icons/chevron-down.svg ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"-3 -5 16 16\"><path d=\"M1.357.65a.5.5 0 1 0-.714.7l3.915 4a.5.5 0 0 0 .707.007l4.085-4a.5.5 0 0 0-.7-.714l-3.727 3.65L1.357.65z\"/></svg>"

/***/ }),

/***/ "./icons/chevron-left.svg":
/*!********************************!*\
  !*** ./icons/chevron-left.svg ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"-5 -3 16 16\"><path d=\"M5.35 1.357a.5.5 0 1 0-.7-.714l-4 3.915a.5.5 0 0 0-.007.707l4 4.085a.5.5 0 0 0 .714-.7l-3.65-3.727L5.35 1.357z\"/></svg>"

/***/ }),

/***/ "./icons/chevron-right.svg":
/*!*********************************!*\
  !*** ./icons/chevron-right.svg ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"-5 -3 16 16\"><path d=\"M.65 8.643a.5.5 0 1 0 .7.714l4-3.915a.5.5 0 0 0 .007-.707l-4-4.085a.5.5 0 1 0-.714.7l3.65 3.727L.65 8.643z\"/></svg>"

/***/ }),

/***/ "./icons/chevron-up.svg":
/*!******************************!*\
  !*** ./icons/chevron-up.svg ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"-3 -5 16 16\"><path d=\"M5 1.707l3.646 3.647a.5.5 0 1 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 .708.708L5 1.707z\"/></svg>"

/***/ }),

/***/ "./icons/circle-checkmark-filled.svg":
/*!*******************************************!*\
  !*** ./icons/circle-checkmark-filled.svg ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M2.343 13.657A8 8 0 1 1 13.657 2.343 8 8 0 0 1 2.343 13.657zm4.715-5.064L5.004 6.54 3.59 7.953l3.468 3.469 5.215-5.215-1.414-1.414-3.8 3.8z\"/></svg>"

/***/ }),

/***/ "./icons/circle-checkmark.svg":
/*!************************************!*\
  !*** ./icons/circle-checkmark.svg ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M7.058 8.593L5.004 6.539 3.59 7.953l3.468 3.469 5.215-5.215-1.414-1.414z\"/><path d=\"M12.243 12.243a6 6 0 1 0-8.486-8.486 6 6 0 0 0 8.486 8.486zm-9.9 1.414A8 8 0 1 1 13.657 2.343 8 8 0 0 1 2.343 13.657z\"/></svg>"

/***/ }),

/***/ "./icons/close-lg.svg":
/*!****************************!*\
  !*** ./icons/close-lg.svg ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon-lg\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.985 10.571L4.915 3.5 3.5 4.914l7.071 7.071L3.5 19.056l1.414 1.415 7.071-7.072 7.071 7.072 1.415-1.415-7.072-7.07 7.072-7.072L19.056 3.5l-7.07 7.071z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/close.svg":
/*!*************************!*\
  !*** ./icons/close.svg ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M8.01 7.303L2.707 2 2 2.707 7.303 8.01 2 13.314l.707.707L8.01 8.718l5.304 5.303.707-.707L8.718 8.01l5.303-5.303L13.314 2 8.01 7.303z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/collapse.svg":
/*!****************************!*\
  !*** ./icons/collapse.svg ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M2 7h12v2H2V7\"/></svg>"

/***/ }),

/***/ "./icons/comments.svg":
/*!****************************!*\
  !*** ./icons/comments.svg ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"1 1 14 14\"><path d=\"M8.492 11.959c1.86-.768 3.168-1.66 3.92-2.675.442-.59.686-1.221.733-1.896a2.809 2.809 0 0 0-.256-1.448 4.078 4.078 0 0 0-.99-1.32 6.267 6.267 0 0 0-3.675-1.431h-.442a6.29 6.29 0 0 0-1.855.273 5.518 5.518 0 0 0-1.553.739c-.442.31-.8.69-1.075 1.14-.276.45-.425.926-.448 1.43-.086.954.186 1.788.814 2.5.357.404.79.715 1.303.932a4.182 4.182 0 0 0 1.65.325c.536.062.909.136 1.118.22.209.087.372.19.488.315.179.264.268.563.268.896m4.304-8.235A5.614 5.614 0 0 1 14.11 5.52c.295.655.423 1.3.384 1.937a4.65 4.65 0 0 1-.425 1.727 5.754 5.754 0 0 1-.866 1.343c-.334.38-.735.745-1.204 1.094a12.52 12.52 0 0 1-2.518 1.454c-.551.24-.941.397-1.17.47-.228.074-.346.11-.354.11h-.175a.444.444 0 0 1-.255-.07.222.222 0 0 1-.105-.196.407.407 0 0 1-.198-.221.81.81 0 0 1-.07-.314v-.896c-.007 0-.08-.016-.215-.047a1.848 1.848 0 0 0-.413-.046 5.3 5.3 0 0 1-2.157-.448 4.58 4.58 0 0 1-1.693-1.25 4.687 4.687 0 0 1-1.163-3.46c.047-.663.26-1.304.64-1.925.38-.62.874-1.143 1.483-1.57.609-.426 1.322-.748 2.14-.965a7.51 7.51 0 0 1 2.542-.221 7.702 7.702 0 0 1 2.43.506 7.126 7.126 0 0 1 2.048 1.192\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/copy.svg":
/*!************************!*\
  !*** ./icons/copy.svg ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M10 14v1.25a.75.75 0 01-.75.75H.75a.75.75 0 01-.75-.75V3.75A.75.75 0 01.75 3H3v9.25c0 .965.785 1.75 1.75 1.75H10zm0-10.75V0H4.75A.75.75 0 004 .75v11.5c0 .414.336.75.75.75h8.5a.75.75 0 00.75-.75V4h-3.25a.752.752 0 01-.75-.75zm3.78-.97L11.72.22a.75.75 0 00-.53-.22H11v3h3v-.19a.75.75 0 00-.22-.53z\"/></svg>"

/***/ }),

/***/ "./icons/cross-post.svg":
/*!******************************!*\
  !*** ./icons/cross-post.svg ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 14\"><path d=\"M15.75 10.213a.749.749 0 010 1.059l-2.496 2.495c-.468.468-1.277.14-1.277-.53V11.99h-1.834a.374.374 0 01-.273-.119L7.669 9.514 9.332 7.73l1.647 1.764h.998V8.248c0-.668.809-.998 1.277-.53l2.496 2.495zM.374 4.505h2.62L4.64 6.269l1.664-1.783-2.2-2.357a.374.374 0 00-.274-.12H.374A.374.374 0 000 2.385v1.747c0 .206.168.374.374.374zm11.603 0v1.247c0 .67.81.997 1.277.53l2.496-2.495a.749.749 0 000-1.059L13.254.234a.748.748 0 00-1.277.529V2.01h-1.834a.374.374 0 00-.273.119L2.994 9.495H.374A.374.374 0 000 9.87v1.747c0 .207.168.374.374.374H3.83a.374.374 0 00.273-.119l6.876-7.366h.998z\"/></svg>"

/***/ }),

/***/ "./icons/delete.svg":
/*!**************************!*\
  !*** ./icons/delete.svg ***!
  \**************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M3.3 4h10.4v9.333A2.667 2.667 0 0 1 11.033 16H5.967A2.667 2.667 0 0 1 3.3 13.333V4zm2.6-2.667V0h5.2v1.333H15v1.334H2V1.333h3.9z\"/></svg>"

/***/ }),

/***/ "./icons/desktop.svg":
/*!***************************!*\
  !*** ./icons/desktop.svg ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 576 512\"><path d=\"M528 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h192l-16 48h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72l-16-48h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-16 352H64V64h448v288z\"/></svg>"

/***/ }),

/***/ "./icons/distribute-circle.svg":
/*!*************************************!*\
  !*** ./icons/distribute-circle.svg ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 16 16\" class=\"cu-icon\"><path d=\"M3.913 13.002c0 .053-.032.079-.095.079 1.263.978 2.656 1.467 4.182 1.467a6.38 6.38 0 003.258-.875 6.596 6.596 0 002.4-2.383 6.348 6.348 0 00.89-3.29 6.262 6.262 0 00-.915-3.298 6.629 6.629 0 00-2.446-2.382 6.54 6.54 0 00-3.282-.868 6.41 6.41 0 00-3.258.868 6.51 6.51 0 00-2.399 2.382A6.39 6.39 0 001.358 8c0 1.462.488 2.824 1.466 4.087L8.82 6.091H6.36c-.422 0-.632-.211-.632-.631 0-.305.105-.521.315-.647a.636.636 0 01.316-.079h4.181l.268.079c.17.084.29.205.363.363.064.063.095.157.095.284v4.086c0 .221-.063.397-.189.529-.127.131-.3.197-.52.197a.693.693 0 01-.537-.221.72.72 0 01-.206-.505V7.085l-5.9 5.917zM4.876.631A7.85 7.85 0 017.984 0a7.8 7.8 0 013.101.631 8.203 8.203 0 012.556 1.696 7.968 7.968 0 011.72 2.549c.426.989.64 2.03.64 3.124a7.813 7.813 0 01-.64 3.124c-.426.989-1 1.839-1.72 2.549a8.203 8.203 0 01-2.556 1.696A7.762 7.762 0 018 16c-2.083 0-3.96-.789-5.633-2.367a8.061 8.061 0 01-1.76-2.603A7.854 7.854 0 010 7.968c0-1.073.21-2.103.631-3.092a7.99 7.99 0 011.696-2.549A7.979 7.979 0 014.877.631z\"/></svg>"

/***/ }),

/***/ "./icons/distribute.svg":
/*!******************************!*\
  !*** ./icons/distribute.svg ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M10.392 5H3.8V3h10v10h-2V6.42l-7.386 7.387L3 12.392 10.392 5z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/double-chevron-right.svg":
/*!****************************************!*\
  !*** ./icons/double-chevron-right.svg ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M8.012 8.68l-5.44 5.44a.956.956 0 01-1.356 0l-.904-.904a.956.956 0 010-1.356l3.856-3.856L.312 4.148a.956.956 0 010-1.356l.9-.912a.956.956 0 011.356 0l5.44 5.44c.38.376.38.984.004 1.36zm7.68-1.36l-5.44-5.44a.956.956 0 00-1.356 0l-.904.904a.956.956 0 000 1.356l3.856 3.856-3.856 3.856a.956.956 0 000 1.356l.904.904a.956.956 0 001.356 0l5.44-5.44a.951.951 0 000-1.352z\"/></svg>"

/***/ }),

/***/ "./icons/download.svg":
/*!****************************!*\
  !*** ./icons/download.svg ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M9 8.692l1.864-1.864 1.414 1.415-4.242 4.242-4.243-4.242 1.414-1.415L7 8.621V2h2v6.692zM0 9h2s.006 5 .002 5c0 0 11.998.002 11.998-.01V9h2v4.99A2 2 0 0 1 13.998 16H2.002A2.01 2.01 0 0 1 0 13.99V9z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/edit.svg":
/*!************************!*\
  !*** ./icons/edit.svg ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M0 12.548L9.668 2.88l3.453 3.452L3.453 16H0v-3.452zM11.05 1.5L12.143.404a1.383 1.383 0 0 1 1.954 0l1.499 1.5c.54.54.54 1.414 0 1.953l-1.095 1.095L11.049 1.5z\"/></svg>"

/***/ }),

/***/ "./icons/embed.svg":
/*!*************************!*\
  !*** ./icons/embed.svg ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 20 10\"><path d=\"M11.147 1l-1.94 8.731\" stroke=\"currentColor\" stroke-width=\"2\"/><path fill=\"currentColor\" transform=\"rotate(90 16.707 5.06)\" d=\"M20 8.121l1.414-1.414L16.707 2 12 6.707l1.414 1.414 3.293-3.293z\"/><path fill=\"currentColor\" d=\"M6.768 8.354L5.354 9.768.646 5.06 5.354.354l1.414 1.414L3.475 5.06z\"/></svg>"

/***/ }),

/***/ "./icons/envelope.svg":
/*!****************************!*\
  !*** ./icons/envelope.svg ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M15.697 5.963a.188.188 0 0 1 .303.146V12.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5V6.112c0-.156.178-.243.303-.146.7.543 1.628 1.234 4.816 3.55.66.48 1.772 1.493 2.881 1.487 1.116.01 2.25-1.025 2.884-1.487 3.188-2.316 4.113-3.01 4.813-3.553zM8 10c.725.012 1.769-.912 2.294-1.294 4.147-3.01 4.462-3.272 5.418-4.022a.748.748 0 0 0 .288-.59V3.5A1.5 1.5 0 0 0 14.5 2h-13A1.5 1.5 0 0 0 0 3.5v.594a.75.75 0 0 0 .287.59c.957.747 1.272 1.013 5.42 4.022C6.23 9.088 7.274 10.012 8 10z\"/></svg>"

/***/ }),

/***/ "./icons/error.svg":
/*!*************************!*\
  !*** ./icons/error.svg ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M2.34314575,13.6568542 C-0.781048583,10.5326599 -0.781048583,5.46734008 2.34314575,2.34314575 C5.46734008,-0.781048584 10.5326599,-0.781048584 13.6568542,2.34314575 C16.7810486,5.46734008 16.7810486,10.5326599 13.6568542,13.6568542 C10.5326599,16.7810486 5.46734008,16.7810486 2.34314575,13.6568542 Z M12.2426407,12.2426407 C14.5857864,9.89949494 14.5857864,6.10050506 12.2426407,3.75735931 C9.89949494,1.41421356 6.10050506,1.41421356 3.75735931,3.75735931 C1.41421356,6.10050506 1.41421356,9.89949494 3.75735931,12.2426407 C6.10050506,14.5857864 9.89949494,14.5857864 12.2426407,12.2426407 Z M9.41421356,8 L11.5355339,10.1213203 L10.1213203,11.5355339 L8,9.41421356 L5.87867966,11.5355339 L4.46446609,10.1213203 L6.58578644,8 L4.46446609,5.87867966 L5.87867966,4.46446609 L8,6.58578644 L10.1213203,4.46446609 L11.5355339,5.87867966 L9.41421356,8 Z\"/></svg>"

/***/ }),

/***/ "./icons/eye-solid.svg":
/*!*****************************!*\
  !*** ./icons/eye-solid.svg ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 576 512\"><path fill=\"currentColor\" d=\"M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 000 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 000-29.19zM288 400a144 144 0 11144-144 143.93 143.93 0 01-144 144zm0-240a95.31 95.31 0 00-25.31 3.79 47.85 47.85 0 01-66.9 66.9A95.78 95.78 0 10288 160z\"/></svg>"

/***/ }),

/***/ "./icons/facebook.svg":
/*!****************************!*\
  !*** ./icons/facebook.svg ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M15.11667 0H.88333C.39533 0 0 .39533 0 .88333v14.234C0 15.60467.39533 16 .88333 16h7.66334V9.804H6.46133V7.38933h2.08534V5.60867c0-2.06667 1.262-3.192 3.106-3.192.88333 0 1.642.066 1.86333.09533v2.16l-1.27867.00067c-1.00266 0-1.19666.47666-1.19666 1.17533V7.39H13.432l-.31133 2.41467h-2.08V16H15.118c.48667 0 .882-.39533.882-.88333V.88333C16 .39533 15.60467 0 15.11667 0z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/fb-comment.svg":
/*!******************************!*\
  !*** ./icons/fb-comment.svg ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M14.66 2.667c0-.734-.593-1.334-1.327-1.334H2.667c-.734 0-1.334.6-1.334 1.334v8c0 .733.6 1.333 1.334 1.333H12l2.667 2.667-.007-12z\"/></svg>"

/***/ }),

/***/ "./icons/fb-gallery.svg":
/*!******************************!*\
  !*** ./icons/fb-gallery.svg ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M4 1v12h12V1H4zm11 1v5.724L12.209 9S8.87 5.081 7.81 5.081c-.625 0-1.325.64-1.811 1.191V2h9zm-5 3.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0zM3.136 4v10.12H13V16H1V4h2.136z\"/></svg>"

/***/ }),

/***/ "./icons/fb-share.svg":
/*!****************************!*\
  !*** ./icons/fb-share.svg ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 12\"><path fill-rule=\"evenodd\" d=\"M9.6 8.572v3.555L16 6.053 9.6 0v3.453C3.38 4.327.9 8.653 0 13c2.22-3.047 5.16-4.428 9.6-4.428z\"/></svg>"

/***/ }),

/***/ "./icons/fb-thumbs-up.svg":
/*!********************************!*\
  !*** ./icons/fb-thumbs-up.svg ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 15\"><path fill-rule=\"evenodd\" d=\"M.667 14h2.666V6H.667v8zm14.666-7.333c0-.734-.6-1.334-1.333-1.334H9.793l.634-3.046.02-.214c0-.273-.114-.526-.294-.706l-.706-.7L5.06 5.06c-.247.24-.393.573-.393.94v6.667C4.667 13.4 5.267 14 6 14h6c.553 0 1.027-.333 1.227-.813l2.013-4.7c.06-.154.093-.314.093-.487V6.667z\"/></svg>"

/***/ }),

/***/ "./icons/file-xl.svg":
/*!***************************!*\
  !*** ./icons/file-xl.svg ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon-xl\" viewBox=\"0 0 24 30\"><path d=\"M18.229 12.336H6.272v-.5h11.957v.25zm0 1.836H6.272v-.5h11.957v.25zm0 1.837H6.272v-.5h11.957v.25z\"/><path d=\"M21.11 17.029l-.016-9.347h-.005l-2.446-2.357-2.128-2.05c-.036-.037-.073-.079-.108-.112-.065-.062-.13-.121-.204-.198L9.79 2.92l-6.414-.045v23.5h17.75l-.015-9.346zM18.295 5.686l2.02 1.946h-3.461a.748.748 0 0 1-.75-.75l.002-1.958.002-1.346 2.187 2.108zM12.25 25.875H3.875v-22.5h11.729v3.507a1.249 1.249 0 0 0 1.25 1.25h3.723l.023 8.655.025 9.088H12.25z\"/></svg>"

/***/ }),

/***/ "./icons/file.svg":
/*!************************!*\
  !*** ./icons/file.svg ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"4 0 24 32\"><path d=\"M22 15.5v1.75c0 .413-.337.75-.75.75h-10.5a.752.752 0 01-.75-.75V15.5c0-.412.338-.75.75-.75h10.5c.413 0 .75.338.75.75zm-.75 4.5h-10.5a.752.752 0 00-.75.75v1.75c0 .413.338.75.75.75h10.5c.413 0 .75-.337.75-.75v-1.75a.752.752 0 00-.75-.75zM28 8.244V29a3 3 0 01-3 3H7a3 3 0 01-3-3V3a3 3 0 013-3h12.756a3 3 0 012.119.881l5.244 5.244A2.99 2.99 0 0128 8.244zm-8-5V8h4.756L20 3.244zM25 29V11h-6.5c-.831 0-1.5-.669-1.5-1.5V3H7v26h18z\"/></svg>"

/***/ }),

/***/ "./icons/filters.svg":
/*!***************************!*\
  !*** ./icons/filters.svg ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" d=\"M9.17 9H2.003a.999.999 0 1 1 0-2h7.169a3.001 3.001 0 1 1 0 2zM6.83 2h7.168a.999.999 0 1 1 0 2H6.829a3.001 3.001 0 1 1 0-2zm0 10h7.168a.999.999 0 1 1 0 2H6.829a3.001 3.001 0 1 1 0-2zM4 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM4 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm8 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z\"/></svg>"

/***/ }),

/***/ "./icons/graph-trending-up-lg.svg":
/*!****************************************!*\
  !*** ./icons/graph-trending-up-lg.svg ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon-lg\" viewBox=\"2 7 26 16\"><path d=\"M20 7.5l2.863 2.863-6.1 6.1-5-5L2.5 20.738 4.263 22.5l7.5-7.5 5 5 7.874-7.863L27.5 15V7.5z\"/></svg>"

/***/ }),

/***/ "./icons/graph-trending-up.svg":
/*!*************************************!*\
  !*** ./icons/graph-trending-up.svg ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 24 24\"><path d=\"M20.024 6h-5.25c-1.003 0-1.504 1.214-.796 1.922l1.542 1.542-3.375 3.417-2.606-2.606a.557.557 0 00-.793 0l-5.578 5.522a.562.562 0 00-.01.792l1.337 1.378a.56.56 0 00.801.005l3.849-3.849 2.601 2.602c.22.22.577.22.797 0l5.119-5.119 1.566 1.566c.707.708 1.921.206 1.921-.797v-5.25c0-.623-.501-1.125-1.125-1.125z\"/></svg>"

/***/ }),

/***/ "./icons/grid-details.svg":
/*!********************************!*\
  !*** ./icons/grid-details.svg ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M1 1h6v6H1V1zm0 8h6v2H1V9zm0 4h6v2H1v-2zM9 1h6v6H9V1zm0 8h6v2H9V9zm0 4h6v2H9v-2z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/grid.svg":
/*!************************!*\
  !*** ./icons/grid.svg ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M1 1h6v6H1V1zm8 0h6v6H9V1zM1 9h6v6H1V9zm8 0h6v6H9V9z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/hamburger.svg":
/*!*****************************!*\
  !*** ./icons/hamburger.svg ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 14 10\"><path d=\"M14 8v2H0V8h14zm0-4v2H0V4h14zm0-4v2H0V0h14z\"/></svg>"

/***/ }),

/***/ "./icons/hashtag.svg":
/*!***************************!*\
  !*** ./icons/hashtag.svg ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><g fill-rule=\"evenodd\"><path d=\"M5.373 2h1.5L5.5 14H4z\"/><path d=\"M3.049 5h9.98l-.191 1.5h-9.98zm-.573 5h9.98l-.19 1.5h-9.98z\"/><path d=\"M9.873 2h1.5L10 14H8.5z\"/></g></svg>"

/***/ }),

/***/ "./icons/help-lg.svg":
/*!***************************!*\
  !*** ./icons/help-lg.svg ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon-lg\" viewBox=\"0 0 24 24\"><path d=\"M0 0h24v24H0z\" fill=\"none\"/><path d=\"M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12zm11.627.268l.675-.676A2.314 2.314 0 0 0 15 9.939C15 8.315 13.658 7 12 7S9 8.315 9 9.939h1.5c0-.808.675-1.47 1.5-1.47s1.5.662 1.5 1.47c0 .404-.165.771-.443 1.036l-.93.925a2.927 2.927 0 0 0-.877 2.08v.367h1.5c0-1.102.338-1.543.877-2.08zm-2.377 5.018h1.5v-1.47h-1.5v1.47z\"/></svg>"

/***/ }),

/***/ "./icons/help-sm.svg":
/*!***************************!*\
  !*** ./icons/help-sm.svg ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon-sm\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"svg-fill-color-1\" fill-rule=\"evenodd\" d=\"M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm-1.195-3.814c0 .556.427.931 1.066.931.662 0 1.084-.375 1.084-.931 0-.569-.428-.944-1.084-.944-.639 0-1.066.375-1.066.944zM5.38 6.258h1.517c.006-.598.37-1.06 1.073-1.06.533 0 1.037.269 1.037.907 0 .534-.352.786-.903 1.155-.673.45-1.095 1.031-1.03 1.922l.01.31h1.478V9.2c0-.638.263-.82.949-1.3.568-.393 1.172-.85 1.172-1.881 0-1.46-1.22-2.168-2.62-2.168-1.359 0-2.742.668-2.683 2.408z\"/></svg>"

/***/ }),

/***/ "./icons/history-lg.svg":
/*!******************************!*\
  !*** ./icons/history-lg.svg ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon-lg\" viewBox=\"1 3 27 24\"><path d=\"M16.25 3.75C10.037 3.75 5 8.787 5 15H1.25l4.862 4.863.088.175L11.25 15H7.5a8.744 8.744 0 0 1 8.75-8.75A8.744 8.744 0 0 1 25 15a8.744 8.744 0 0 1-8.75 8.75 8.68 8.68 0 0 1-6.175-2.575L8.3 22.95a11.193 11.193 0 0 0 7.95 3.3c6.212 0 11.25-5.038 11.25-11.25 0-6.213-5.038-11.25-11.25-11.25zM15 10v6.25l5.35 3.175.9-1.512-4.375-2.6V10H15z\"/></svg>"

/***/ }),

/***/ "./icons/ig-comment.svg":
/*!******************************!*\
  !*** ./icons/ig-comment.svg ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 16 16\" class=\"cu-icon\"><path d=\"M8.002 0C3.584 0 0 3.325 0 7.43c0 1.76.659 3.375 1.759 4.65-.242.832-.614 1.168-1.03 1.54-.31.275-.895.703-.684 1.543.142.55.58.882 1.058.832 1.603-.164 3.09-.686 4.362-1.518a8.59 8.59 0 0 0 2.534.382c4.42 0 8.001-3.322 8.001-7.43C16.003 3.326 12.422 0 8.002 0zm0 13.35c-.903 0-1.817-.235-2.704-.578-.897.68-2.186 1.516-3.742 1.801.89-.857 1.578-2.2 1.7-3.157C2.198 10.487 1.5 9.098 1.5 7.43c0-2.533 2.232-5.93 6.502-5.93S14.5 4.897 14.5 7.43c0 2.536-2.228 5.92-6.498 5.92z\"/></svg>"

/***/ }),

/***/ "./icons/ig-heart.svg":
/*!****************************!*\
  !*** ./icons/ig-heart.svg ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 16 16\" class=\"cu-icon\"><path d=\"M7.07 14.648L2.076 9.745C1.86 9.545 0 7.761 0 5.54 0 2.791 1.721.97 4.606.97 5.861.97 7.048 1.662 8 2.48c.948-.818 2.14-1.51 3.394-1.51C14.173.97 16 2.683 16 5.54c0 1.576-.964 3.137-2.064 4.203l-.012.013-4.994 4.893c-.515.51-1.345.51-1.86 0zM3.088 8.7L8 13.524l4.903-4.809c.827-.818 1.642-2.009 1.642-3.176 0-2.027-1.157-3.115-3.151-3.115-1.43 0-2.812 1.494-3.394 2.073-.515-.515-1.94-2.073-3.394-2.073-1.997 0-3.151 1.088-3.151 3.115 0 1.13.809 2.391 1.633 3.161z\"/></svg>"

/***/ }),

/***/ "./icons/ig-save.svg":
/*!***************************!*\
  !*** ./icons/ig-save.svg ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 14 16\" class=\"cu-icon\"><path d=\"M14 0v16l-7-6-7 6V0h14zm-1.5 1.5h-11v11.238L7 8.024l5.5 4.715V1.5z\"/></svg>"

/***/ }),

/***/ "./icons/ig-send.svg":
/*!***************************!*\
  !*** ./icons/ig-send.svg ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 16 16\" class=\"cu-icon\"><path d=\"M15.29 1.09l.05.05a1 1 0 0 1 .19 1.07l-4.17 12.91a1 1 0 0 1-.47.57 1.15 1.15 0 0 1-1.55-.43L7 9.37 1.12 7a1.16 1.16 0 0 1-.43-1.51A1.1 1.1 0 0 1 1.26 5L14.17.85a1 1 0 0 1 1.12.24zm-2.24 3.6L8.7 9l1.43 4.36 2.92-8.67zm-1.36-1.36L3 6.26l4.34 1.42 4.35-4.35z\"/></svg>"

/***/ }),

/***/ "./icons/ig-story-swipe.svg":
/*!**********************************!*\
  !*** ./icons/ig-story-swipe.svg ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 28 28\"><path d=\"M14 0c7.7 0 14 6.3 14 14s-6.3 14-14 14S0 21.7 0 14 6.3 0 14 0zm-.6 10.2l-7.1 5.6c-.3.3-.3.7 0 1 .3.3.9.3 1.3 0l6.5-5.1 6.5 5.1c.3.3.9.3 1.3 0 .3-.3.3-.7 0-1l-7.1-5.6c-.5-.3-1.1-.3-1.4 0z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/ig-tv.svg":
/*!*************************!*\
  !*** ./icons/ig-tv.svg ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 14 16\"><path d=\"M12.948 3.278a3.956 3.956 0 00-2.802-1.17h-1.77l.825-.93a.695.695 0 10-1.04-.92L6.98 1.591 5.794.264a.695.695 0 00-1.039.921l.825.93H3.96c-1.052 0-2.06.418-2.803 1.163A3.917 3.917 0 000 6.053v6.004a3.917 3.917 0 001.156 2.774A3.956 3.956 0 003.96 16h6.187a3.961 3.961 0 003.958-3.938V6.053a3.917 3.917 0 00-1.156-2.775zm-2.232 6.358l-3.378.975a.698.698 0 01-.93-.687l.043-.855-2.829.729a.695.695 0 11-.348-1.346l3.742-.968a.695.695 0 01.869.705l-.042.829 2.49-.717a.695.695 0 01.383 1.335z\"/></svg>"

/***/ }),

/***/ "./icons/index.ts":
/*!************************!*\
  !*** ./icons/index.ts ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2020 by Curalate, Inc.
//
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var add_lg_svg_1 = __importDefault(__webpack_require__(/*! ./add-lg.svg */ "./icons/add-lg.svg"));
var add_with_circle_svg_1 = __importDefault(__webpack_require__(/*! ./add-with-circle.svg */ "./icons/add-with-circle.svg"));
var add_svg_1 = __importDefault(__webpack_require__(/*! ./add.svg */ "./icons/add.svg"));
var alarm_svg_1 = __importDefault(__webpack_require__(/*! ./alarm.svg */ "./icons/alarm.svg"));
var app_switcher_svg_1 = __importDefault(__webpack_require__(/*! ./app-switcher.svg */ "./icons/app-switcher.svg"));
var at_svg_1 = __importDefault(__webpack_require__(/*! ./at.svg */ "./icons/at.svg"));
var bar_graph_svg_1 = __importDefault(__webpack_require__(/*! ./bar-graph.svg */ "./icons/bar-graph.svg"));
var beautify_svg_1 = __importDefault(__webpack_require__(/*! ./beautify.svg */ "./icons/beautify.svg"));
var bell_svg_1 = __importDefault(__webpack_require__(/*! ./bell.svg */ "./icons/bell.svg"));
var bullhorn_svg_1 = __importDefault(__webpack_require__(/*! ./bullhorn.svg */ "./icons/bullhorn.svg"));
var calendar_svg_1 = __importDefault(__webpack_require__(/*! ./calendar.svg */ "./icons/calendar.svg"));
var checkmark_svg_1 = __importDefault(__webpack_require__(/*! ./checkmark.svg */ "./icons/checkmark.svg"));
var chevron_down_svg_1 = __importDefault(__webpack_require__(/*! ./chevron-down.svg */ "./icons/chevron-down.svg"));
var chevron_left_svg_1 = __importDefault(__webpack_require__(/*! ./chevron-left.svg */ "./icons/chevron-left.svg"));
var chevron_right_svg_1 = __importDefault(__webpack_require__(/*! ./chevron-right.svg */ "./icons/chevron-right.svg"));
var chevron_up_svg_1 = __importDefault(__webpack_require__(/*! ./chevron-up.svg */ "./icons/chevron-up.svg"));
var circle_checkmark_filled_svg_1 = __importDefault(__webpack_require__(/*! ./circle-checkmark-filled.svg */ "./icons/circle-checkmark-filled.svg"));
var circle_checkmark_svg_1 = __importDefault(__webpack_require__(/*! ./circle-checkmark.svg */ "./icons/circle-checkmark.svg"));
var close_lg_svg_1 = __importDefault(__webpack_require__(/*! ./close-lg.svg */ "./icons/close-lg.svg"));
var close_svg_1 = __importDefault(__webpack_require__(/*! ./close.svg */ "./icons/close.svg"));
var collapse_svg_1 = __importDefault(__webpack_require__(/*! ./collapse.svg */ "./icons/collapse.svg"));
var comments_svg_1 = __importDefault(__webpack_require__(/*! ./comments.svg */ "./icons/comments.svg"));
var copy_svg_1 = __importDefault(__webpack_require__(/*! ./copy.svg */ "./icons/copy.svg"));
var cross_post_svg_1 = __importDefault(__webpack_require__(/*! ./cross-post.svg */ "./icons/cross-post.svg"));
var delete_svg_1 = __importDefault(__webpack_require__(/*! ./delete.svg */ "./icons/delete.svg"));
var desktop_svg_1 = __importDefault(__webpack_require__(/*! ./desktop.svg */ "./icons/desktop.svg"));
var distribute_circle_svg_1 = __importDefault(__webpack_require__(/*! ./distribute-circle.svg */ "./icons/distribute-circle.svg"));
var distribute_svg_1 = __importDefault(__webpack_require__(/*! ./distribute.svg */ "./icons/distribute.svg"));
var double_chevron_right_svg_1 = __importDefault(__webpack_require__(/*! ./double-chevron-right.svg */ "./icons/double-chevron-right.svg"));
var download_svg_1 = __importDefault(__webpack_require__(/*! ./download.svg */ "./icons/download.svg"));
var edit_svg_1 = __importDefault(__webpack_require__(/*! ./edit.svg */ "./icons/edit.svg"));
var embed_svg_1 = __importDefault(__webpack_require__(/*! ./embed.svg */ "./icons/embed.svg"));
var envelope_svg_1 = __importDefault(__webpack_require__(/*! ./envelope.svg */ "./icons/envelope.svg"));
var error_svg_1 = __importDefault(__webpack_require__(/*! ./error.svg */ "./icons/error.svg"));
var eye_solid_svg_1 = __importDefault(__webpack_require__(/*! ./eye-solid.svg */ "./icons/eye-solid.svg"));
var facebook_svg_1 = __importDefault(__webpack_require__(/*! ./facebook.svg */ "./icons/facebook.svg"));
var fb_comment_svg_1 = __importDefault(__webpack_require__(/*! ./fb-comment.svg */ "./icons/fb-comment.svg"));
var fb_gallery_svg_1 = __importDefault(__webpack_require__(/*! ./fb-gallery.svg */ "./icons/fb-gallery.svg"));
var fb_share_svg_1 = __importDefault(__webpack_require__(/*! ./fb-share.svg */ "./icons/fb-share.svg"));
var fb_thumbs_up_svg_1 = __importDefault(__webpack_require__(/*! ./fb-thumbs-up.svg */ "./icons/fb-thumbs-up.svg"));
var file_svg_1 = __importDefault(__webpack_require__(/*! ./file.svg */ "./icons/file.svg"));
var file_xl_svg_1 = __importDefault(__webpack_require__(/*! ./file-xl.svg */ "./icons/file-xl.svg"));
var filters_svg_1 = __importDefault(__webpack_require__(/*! ./filters.svg */ "./icons/filters.svg"));
var graph_trending_up_lg_svg_1 = __importDefault(__webpack_require__(/*! ./graph-trending-up-lg.svg */ "./icons/graph-trending-up-lg.svg"));
var graph_trending_up_svg_1 = __importDefault(__webpack_require__(/*! ./graph-trending-up.svg */ "./icons/graph-trending-up.svg"));
var grid_details_svg_1 = __importDefault(__webpack_require__(/*! ./grid-details.svg */ "./icons/grid-details.svg"));
var grid_svg_1 = __importDefault(__webpack_require__(/*! ./grid.svg */ "./icons/grid.svg"));
var hamburger_svg_1 = __importDefault(__webpack_require__(/*! ./hamburger.svg */ "./icons/hamburger.svg"));
var hashtag_svg_1 = __importDefault(__webpack_require__(/*! ./hashtag.svg */ "./icons/hashtag.svg"));
var help_lg_svg_1 = __importDefault(__webpack_require__(/*! ./help-lg.svg */ "./icons/help-lg.svg"));
var help_sm_svg_1 = __importDefault(__webpack_require__(/*! ./help-sm.svg */ "./icons/help-sm.svg"));
var history_lg_svg_1 = __importDefault(__webpack_require__(/*! ./history-lg.svg */ "./icons/history-lg.svg"));
var ig_comment_svg_1 = __importDefault(__webpack_require__(/*! ./ig-comment.svg */ "./icons/ig-comment.svg"));
var ig_heart_svg_1 = __importDefault(__webpack_require__(/*! ./ig-heart.svg */ "./icons/ig-heart.svg"));
var ig_save_svg_1 = __importDefault(__webpack_require__(/*! ./ig-save.svg */ "./icons/ig-save.svg"));
var ig_send_svg_1 = __importDefault(__webpack_require__(/*! ./ig-send.svg */ "./icons/ig-send.svg"));
var ig_story_swipe_svg_1 = __importDefault(__webpack_require__(/*! ./ig-story-swipe.svg */ "./icons/ig-story-swipe.svg"));
var ig_tv_svg_1 = __importDefault(__webpack_require__(/*! ./ig-tv.svg */ "./icons/ig-tv.svg"));
var info_svg_1 = __importDefault(__webpack_require__(/*! ./info.svg */ "./icons/info.svg"));
var instagram_gallery_svg_1 = __importDefault(__webpack_require__(/*! ./instagram-gallery.svg */ "./icons/instagram-gallery.svg"));
var instagram_story_svg_1 = __importDefault(__webpack_require__(/*! ./instagram-story.svg */ "./icons/instagram-story.svg"));
var instagram_video_svg_1 = __importDefault(__webpack_require__(/*! ./instagram-video.svg */ "./icons/instagram-video.svg"));
var instagram_svg_1 = __importDefault(__webpack_require__(/*! ./instagram.svg */ "./icons/instagram.svg"));
var kebab_svg_1 = __importDefault(__webpack_require__(/*! ./kebab.svg */ "./icons/kebab.svg"));
var lightbulb_svg_1 = __importDefault(__webpack_require__(/*! ./lightbulb.svg */ "./icons/lightbulb.svg"));
var likes_svg_1 = __importDefault(__webpack_require__(/*! ./likes.svg */ "./icons/likes.svg"));
var link_svg_1 = __importDefault(__webpack_require__(/*! ./link.svg */ "./icons/link.svg"));
var linkout_svg_1 = __importDefault(__webpack_require__(/*! ./linkout.svg */ "./icons/linkout.svg"));
var location_svg_1 = __importDefault(__webpack_require__(/*! ./location.svg */ "./icons/location.svg"));
var media_published_svg_1 = __importDefault(__webpack_require__(/*! ./media-published.svg */ "./icons/media-published.svg"));
var mobile_svg_1 = __importDefault(__webpack_require__(/*! ./mobile.svg */ "./icons/mobile.svg"));
var more_svg_1 = __importDefault(__webpack_require__(/*! ./more.svg */ "./icons/more.svg"));
var multiple_users_svg_1 = __importDefault(__webpack_require__(/*! ./multiple-users.svg */ "./icons/multiple-users.svg"));
var new_feature_lg_svg_1 = __importDefault(__webpack_require__(/*! ./new-feature-lg.svg */ "./icons/new-feature-lg.svg"));
var new_svg_1 = __importDefault(__webpack_require__(/*! ./new.svg */ "./icons/new.svg"));
var notifications_lg_svg_1 = __importDefault(__webpack_require__(/*! ./notifications-lg.svg */ "./icons/notifications-lg.svg"));
var notifications_svg_1 = __importDefault(__webpack_require__(/*! ./notifications.svg */ "./icons/notifications.svg"));
var pin_circle_svg_1 = __importDefault(__webpack_require__(/*! ./pin-circle.svg */ "./icons/pin-circle.svg"));
var pin_svg_1 = __importDefault(__webpack_require__(/*! ./pin.svg */ "./icons/pin.svg"));
var pinterest_svg_1 = __importDefault(__webpack_require__(/*! ./pinterest.svg */ "./icons/pinterest.svg"));
var pinterest_export_svg_1 = __importDefault(__webpack_require__(/*! ./pinterest-export.svg */ "./icons/pinterest-export.svg"));
var pinterest_more_svg_1 = __importDefault(__webpack_require__(/*! ./pinterest-more.svg */ "./icons/pinterest-more.svg"));
var product_bag_svg_1 = __importDefault(__webpack_require__(/*! ./product-bag.svg */ "./icons/product-bag.svg"));
var product_svg_1 = __importDefault(__webpack_require__(/*! ./product.svg */ "./icons/product.svg"));
var reach_svg_1 = __importDefault(__webpack_require__(/*! ./reach.svg */ "./icons/reach.svg"));
var requestrights_approved_svg_1 = __importDefault(__webpack_require__(/*! ./requestrights-approved.svg */ "./icons/requestrights-approved.svg"));
var requestrights_pending_svg_1 = __importDefault(__webpack_require__(/*! ./requestrights-pending.svg */ "./icons/requestrights-pending.svg"));
var requestrights_rejected_svg_1 = __importDefault(__webpack_require__(/*! ./requestrights-rejected.svg */ "./icons/requestrights-rejected.svg"));
var search_svg_1 = __importDefault(__webpack_require__(/*! ./search.svg */ "./icons/search.svg"));
var settings_svg_1 = __importDefault(__webpack_require__(/*! ./settings.svg */ "./icons/settings.svg"));
var smile_svg_1 = __importDefault(__webpack_require__(/*! ./smile.svg */ "./icons/smile.svg"));
var sparkles_svg_1 = __importDefault(__webpack_require__(/*! ./sparkles.svg */ "./icons/sparkles.svg"));
var spinner_svg_1 = __importDefault(__webpack_require__(/*! ./spinner.svg */ "./icons/spinner.svg"));
var sticker_svg_1 = __importDefault(__webpack_require__(/*! ./sticker.svg */ "./icons/sticker.svg"));
var sync_alt_svg_1 = __importDefault(__webpack_require__(/*! ./sync-alt.svg */ "./icons/sync-alt.svg"));
var tag_svg_1 = __importDefault(__webpack_require__(/*! ./tag.svg */ "./icons/tag.svg"));
var text_svg_1 = __importDefault(__webpack_require__(/*! ./text.svg */ "./icons/text.svg"));
var trending_down_svg_1 = __importDefault(__webpack_require__(/*! ./trending-down.svg */ "./icons/trending-down.svg"));
var trending_up_svg_1 = __importDefault(__webpack_require__(/*! ./trending-up.svg */ "./icons/trending-up.svg"));
var twitter_comment_svg_1 = __importDefault(__webpack_require__(/*! ./twitter-comment.svg */ "./icons/twitter-comment.svg"));
var twitter_like_svg_1 = __importDefault(__webpack_require__(/*! ./twitter-like.svg */ "./icons/twitter-like.svg"));
var twitter_retweet_svg_1 = __importDefault(__webpack_require__(/*! ./twitter-retweet.svg */ "./icons/twitter-retweet.svg"));
var twitter_share_svg_1 = __importDefault(__webpack_require__(/*! ./twitter-share.svg */ "./icons/twitter-share.svg"));
var twitter_square_svg_1 = __importDefault(__webpack_require__(/*! ./twitter-square.svg */ "./icons/twitter-square.svg"));
var twitter_svg_1 = __importDefault(__webpack_require__(/*! ./twitter.svg */ "./icons/twitter.svg"));
var undo_svg_1 = __importDefault(__webpack_require__(/*! ./undo.svg */ "./icons/undo.svg"));
var upload_svg_1 = __importDefault(__webpack_require__(/*! ./upload.svg */ "./icons/upload.svg"));
var user_svg_1 = __importDefault(__webpack_require__(/*! ./user.svg */ "./icons/user.svg"));
var verified_svg_1 = __importDefault(__webpack_require__(/*! ./verified.svg */ "./icons/verified.svg"));
var zoom_svg_1 = __importDefault(__webpack_require__(/*! ./zoom.svg */ "./icons/zoom.svg"));
var icons = {
    'add': add_svg_1.default,
    'add-lg': add_lg_svg_1.default,
    'add-with-circle': add_with_circle_svg_1.default,
    'alarm': alarm_svg_1.default,
    'app-switcher': app_switcher_svg_1.default,
    'at': at_svg_1.default,
    'bar-graph': bar_graph_svg_1.default,
    'bell': bell_svg_1.default,
    'beautify': beautify_svg_1.default,
    'bullhorn': bullhorn_svg_1.default,
    'calendar': calendar_svg_1.default,
    'checkmark': checkmark_svg_1.default,
    'chevron-down': chevron_down_svg_1.default,
    'chevron-left': chevron_left_svg_1.default,
    'chevron-right': chevron_right_svg_1.default,
    'chevron-up': chevron_up_svg_1.default,
    'circle-checkmark': circle_checkmark_svg_1.default,
    'circle-checkmark-filled': circle_checkmark_filled_svg_1.default,
    'close': close_svg_1.default,
    'close-lg': close_lg_svg_1.default,
    'collapse': collapse_svg_1.default,
    'comments': comments_svg_1.default,
    'copy': copy_svg_1.default,
    'cross-post': cross_post_svg_1.default,
    'delete': delete_svg_1.default,
    'desktop': desktop_svg_1.default,
    'distribute': distribute_svg_1.default,
    'distribute-circle': distribute_circle_svg_1.default,
    'double-chevron-right': double_chevron_right_svg_1.default,
    'download': download_svg_1.default,
    'edit': edit_svg_1.default,
    'embed': embed_svg_1.default,
    'envelope': envelope_svg_1.default,
    'error': error_svg_1.default,
    'eye-solid': eye_solid_svg_1.default,
    'facebook': facebook_svg_1.default,
    'fb-comment': fb_comment_svg_1.default,
    'fb-gallery': fb_gallery_svg_1.default,
    'fb-share': fb_share_svg_1.default,
    'fb-thumbs-up': fb_thumbs_up_svg_1.default,
    'file': file_svg_1.default,
    'file-xl': file_xl_svg_1.default,
    'filters': filters_svg_1.default,
    'graph-trending-up': graph_trending_up_svg_1.default,
    'graph-trending-up-lg': graph_trending_up_lg_svg_1.default,
    'grid': grid_svg_1.default,
    'grid-details': grid_details_svg_1.default,
    'hamburger': hamburger_svg_1.default,
    'hashtag': hashtag_svg_1.default,
    'help-lg': help_lg_svg_1.default,
    'help-sm': help_sm_svg_1.default,
    'history-lg': history_lg_svg_1.default,
    'ig-comment': ig_comment_svg_1.default,
    'ig-heart': ig_heart_svg_1.default,
    'ig-save': ig_save_svg_1.default,
    'ig-send': ig_send_svg_1.default,
    'ig-story-swipe': ig_story_swipe_svg_1.default,
    'ig-tv': ig_tv_svg_1.default,
    'info': info_svg_1.default,
    'instagram': instagram_svg_1.default,
    'instagram-gallery': instagram_gallery_svg_1.default,
    'instagram-story': instagram_story_svg_1.default,
    'instagram-video': instagram_video_svg_1.default,
    'kebab': kebab_svg_1.default,
    'lightbulb': lightbulb_svg_1.default,
    'likes': likes_svg_1.default,
    'link': link_svg_1.default,
    'linkout': linkout_svg_1.default,
    'location': location_svg_1.default,
    'media-published': media_published_svg_1.default,
    'mobile': mobile_svg_1.default,
    'more': more_svg_1.default,
    'multiple-users': multiple_users_svg_1.default,
    'new': new_svg_1.default,
    'new-feature-lg': new_feature_lg_svg_1.default,
    'notifications': notifications_svg_1.default,
    'notifications-lg': notifications_lg_svg_1.default,
    'pin': pin_svg_1.default,
    'pin-circle': pin_circle_svg_1.default,
    'pinterest': pinterest_svg_1.default,
    'pinterest-export': pinterest_export_svg_1.default,
    'pinterest-more': pinterest_more_svg_1.default,
    'product': product_svg_1.default,
    'product-bag': product_bag_svg_1.default,
    'reach': reach_svg_1.default,
    'request-rights-approved': requestrights_approved_svg_1.default,
    'request-rights-pending': requestrights_pending_svg_1.default,
    'request-rights-rejected': requestrights_rejected_svg_1.default,
    'search': search_svg_1.default,
    'settings': settings_svg_1.default,
    'smile': smile_svg_1.default,
    'sparkles': sparkles_svg_1.default,
    'spinner': spinner_svg_1.default,
    'sticker': sticker_svg_1.default,
    'sync-alt': sync_alt_svg_1.default,
    'tag': tag_svg_1.default,
    'text': text_svg_1.default,
    'trending-down': trending_down_svg_1.default,
    'trending-up': trending_up_svg_1.default,
    'twitter': twitter_svg_1.default,
    'twitter-comment': twitter_comment_svg_1.default,
    'twitter-like': twitter_like_svg_1.default,
    'twitter-retweet': twitter_retweet_svg_1.default,
    'twitter-share': twitter_share_svg_1.default,
    'twitter-square': twitter_square_svg_1.default,
    'undo': undo_svg_1.default,
    'upload': upload_svg_1.default,
    'user': user_svg_1.default,
    'verified': verified_svg_1.default,
    'zoom': zoom_svg_1.default,
};
exports.default = icons;


/***/ }),

/***/ "./icons/info.svg":
/*!************************!*\
  !*** ./icons/info.svg ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 14 14\"><path d=\"M7 0C3.136 0 0 3.136 0 7s3.136 7 7 7 7-3.136 7-7-3.136-7-7-7zm.7 10.5H6.3V6.3h1.4v4.2zm0-5.6H6.3V3.5h1.4v1.4z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/instagram-gallery.svg":
/*!*************************************!*\
  !*** ./icons/instagram-gallery.svg ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><g fill-rule=\"evenodd\"><path d=\"M14,3 C15.1045695,3 16,3.8954305 16,5 L16,14 C16,15.1045695 15.1045695,16 14,16 L5,16 C3.8954305,16 3,15.1045695 3,14 L12,14 C13.1045695,14 14,13.1045695 14,12 L14,3 Z\"/><rect width=\"13\" height=\"13\" rx=\"2\"/></g></svg>"

/***/ }),

/***/ "./icons/instagram-story.svg":
/*!***********************************!*\
  !*** ./icons/instagram-story.svg ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M9,7 L9,4 L7,4 L7,7 L4,7 L4,9 L7,9 L7,12 L9,12 L9,9 L12,9 L12,7 L9,7 Z M1.39106014,3.49082242 C0.489972223,4.80928646 0,6.36934072 0,8 C0,8.55228475 0.44771525,9 1,9 C1.55228475,9 2,8.55228475 2,8 C2,6.7752654 2.36664056,5.6078948 3.04226921,4.61932082 C3.35389543,4.16335202 3.23688266,3.54109331 2.78091387,3.22946709 C2.32494508,2.91784086 1.70268637,3.03485363 1.39106014,3.49082242 Z M0.876131905,11.6433773 C1.89121865,13.62469 3.6955939,15.1067197 5.84684555,15.7066471 C6.37883117,15.8550039 6.93035767,15.5440113 7.07871446,15.0120257 C7.22707125,14.48004 6.91607863,13.9285135 6.384093,13.7801567 C4.77260986,13.3307565 3.41766646,12.2178692 2.65612092,10.7314348 C2.40429496,10.2399044 1.80168557,10.0455856 1.31015517,10.2974115 C0.818624777,10.5492375 0.624305941,11.1518469 0.876131905,11.6433773 Z M9.59594955,15.8405927 C13.2984571,15.0904967 16,11.8231983 16,8 C16,3.581722 12.418278,0 8,0 C6.94640872,0 5.91956207,0.204289489 4.96419013,0.596398246 C4.4532639,0.806095262 4.20906938,1.39027582 4.4187664,1.90120205 C4.62846342,2.41212827 5.21264398,2.65632279 5.7235702,2.44662577 C6.43901345,2.15298981 7.20800589,2 8,2 C11.3137085,2 14,4.6862915 14,8 C14,10.8671259 11.9732252,13.3183467 9.19883432,13.8804143 C8.65754599,13.9900747 8.30764238,14.5177728 8.41730272,15.0590611 C8.52696306,15.6003495 9.05466122,15.9502531 9.59594955,15.8405927 Z\"/></svg>"

/***/ }),

/***/ "./icons/instagram-video.svg":
/*!***********************************!*\
  !*** ./icons/instagram-video.svg ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M15.458 3.7c-.151 0-.302.063-.451.187l-2.144 1.785c-.345.286-.604.848-.604 1.307v1.946c0 .459.26 1.02.604 1.307l2.144 1.785c.15.124.3.187.451.187v-.002c.17 0 .325-.084.424-.233a.805.805 0 0 0 .118-.45V4.384c0-.472-.272-.683-.542-.683zM10.202 2c.734 0 1.331.621 1.331 1.385v9.23c0 .764-.597 1.385-1.33 1.385H1.33C.597 14 0 13.379 0 12.615v-9.23C0 2.62.597 2 1.33 2h8.872zm-4.481 9.991c2.144 0 3.882-1.808 3.882-4.039 0-2.23-1.738-4.039-3.882-4.039s-3.882 1.809-3.882 4.04c0 2.23 1.738 4.038 3.882 4.038zm0-1.275c-1.467 0-2.656-1.238-2.656-2.764 0-1.526 1.189-2.763 2.656-2.763s2.656 1.237 2.656 2.763c0 1.526-1.19 2.764-2.656 2.764z\"/></svg>"

/***/ }),

/***/ "./icons/instagram.svg":
/*!*****************************!*\
  !*** ./icons/instagram.svg ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><g fill-rule=\"evenodd\"><path d=\"M8 1.444c2.135 0 2.388.008 3.232.046.78.036 1.203.166 1.485.275.373.146.64.319.92.599.28.28.452.546.597.92.11.281.24.705.276 1.484.038.844.046 1.097.046 3.232 0 2.135-.008 2.388-.046 3.232-.036.78-.166 1.203-.276 1.485a2.48 2.48 0 0 1-.598.92 2.47 2.47 0 0 1-.92.597c-.281.11-.705.24-1.484.276-.844.038-1.096.046-3.232.046s-2.388-.008-3.232-.046c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.478 2.478 0 0 1-.597-.92c-.11-.281-.24-.705-.276-1.484-.038-.844-.046-1.097-.046-3.232 0-2.135.008-2.388.046-3.232.036-.78.166-1.203.276-1.485a2.48 2.48 0 0 1 .598-.92c.28-.28.546-.452.92-.598.281-.109.705-.24 1.484-.275.844-.038 1.097-.046 3.232-.046M8 .003c-2.172 0-2.444.009-3.297.048C3.85.089 3.27.225 2.76.422a3.92 3.92 0 0 0-1.416.923A3.92 3.92 0 0 0 .422 2.76C.225 3.27.089 3.85.051 4.702.01 5.556.003 5.828.003 8s.009 2.444.048 3.297c.038.852.174 1.433.371 1.942.205.526.478.972.923 1.416.444.445.89.718 1.416.923.51.197 1.09.333 1.942.371.853.04 1.125.048 3.297.048s2.444-.009 3.297-.048c.852-.038 1.433-.174 1.942-.371a3.92 3.92 0 0 0 1.416-.923 3.92 3.92 0 0 0 .923-1.416c.197-.51.333-1.09.371-1.942.04-.853.048-1.125.048-3.297s-.009-2.444-.048-3.297c-.038-.852-.174-1.433-.371-1.942a3.92 3.92 0 0 0-.923-1.416A3.92 3.92 0 0 0 13.24.422c-.51-.197-1.09-.333-1.942-.371C10.444.01 10.172.003 8 .003\"/><path d=\"M8 3.893a4.107 4.107 0 1 0 0 8.214 4.107 4.107 0 0 0 0-8.214zm0 6.773a2.666 2.666 0 1 1 0-5.332 2.666 2.666 0 0 1 0 5.332zm5.229-6.936a.96.96 0 1 1-1.92.001.96.96 0 0 1 1.92 0\"/></g></svg>"

/***/ }),

/***/ "./icons/kebab.svg":
/*!*************************!*\
  !*** ./icons/kebab.svg ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon cu-icon-stroke\" viewBox=\"0 0 16 16\"><path d=\"M8,4.5 C8.82842712,4.5 9.5,3.82842712 9.5,3 C9.5,2.17157288 8.82842712,1.5 8,1.5 C7.17157288,1.5 6.5,2.17157288 6.5,3 C6.5,3.82842712 7.17157288,4.5 8,4.5 Z M8,9.5 C8.82842712,9.5 9.5,8.82842712 9.5,8 C9.5,7.17157288 8.82842712,6.5 8,6.5 C7.17157288,6.5 6.5,7.17157288 6.5,8 C6.5,8.82842712 7.17157288,9.5 8,9.5 Z M8,14.5 C8.82842712,14.5 9.5,13.8284271 9.5,13 C9.5,12.1715729 8.82842712,11.5 8,11.5 C7.17157288,11.5 6.5,12.1715729 6.5,13 C6.5,13.8284271 7.17157288,14.5 8,14.5 Z\"/></svg>"

/***/ }),

/***/ "./icons/lightbulb.svg":
/*!*****************************!*\
  !*** ./icons/lightbulb.svg ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M8 3.817c2.348.003 4.25 1.94 4.252 4.33.002.968-.32 1.91-.911 2.669a13.25 13.25 0 0 1-.33.405l-.017.02c-.408.489-.866 1.037-1.02 1.608a2.32 2.32 0 0 0-.038.536v.334a.543.543 0 0 1-.538.548H6.579a.543.543 0 0 1-.538-.548v-.33a2.757 2.757 0 0 0-.037-.58c-.155-.574-.568-1.062-.967-1.534l-.008-.008c-.13-.154-.254-.3-.37-.452a4.324 4.324 0 0 1-.91-2.669c.003-2.39 1.905-4.327 4.252-4.33zm2.389 6.274h-.001a3.09 3.09 0 0 0 .65-1.907c0-1.709-1.36-3.094-3.039-3.094-1.678 0-3.039 1.385-3.039 3.094a3.088 3.088 0 0 0 .65 1.906c.099.127.21.257.326.396l.007.008c.415.491.93 1.098 1.14 1.88.05.203.073.411.072.62h1.67a2.378 2.378 0 0 1 .071-.588c.209-.77.726-1.389 1.181-1.934l.021-.025c.106-.127.206-.246.29-.356zm-.991 4.726a.58.58 0 0 1 .574.585.58.58 0 0 1-.574.584H6.579a.58.58 0 0 1-.574-.584.58.58 0 0 1 .574-.585h2.819zm6.028-7.255a.58.58 0 0 1 .574.584.58.58 0 0 1-.574.585H13.57a.58.58 0 0 1-.574-.585.58.58 0 0 1 .574-.584h1.856zm-12.457.584a.563.563 0 0 1-.538.585H.574A.58.58 0 0 1 0 8.146a.58.58 0 0 1 .574-.584h1.857c.307.01.548.272.538.584zM4.446 4.53a.55.55 0 0 1-.786.026L2.346 3.219a.592.592 0 0 1 0-.827.567.567 0 0 1 .813 0L4.47 3.728a.573.573 0 0 1-.025.803zm3.555-1.507a.561.561 0 0 1-.574-.548V.585A.58.58 0 0 1 8 0a.58.58 0 0 1 .574.584v1.891A.561.561 0 0 1 8 3.023zm3.558 1.5a.574.574 0 0 1-.022-.8l1.313-1.338a.567.567 0 0 1 .801.01c.22.225.225.587.01.817l-1.313 1.337a.551.551 0 0 1-.789-.026z\"/></svg>"

/***/ }),

/***/ "./icons/likes.svg":
/*!*************************!*\
  !*** ./icons/likes.svg ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"1 1 14 14\"><path d=\"M5.304 3.323c-.85 0-1.509.31-1.973.927-.353.476-.529 1.124-.529 1.945 0 .37.13.8.387 1.289.258.49.574.96.948 1.41.374.449.888.998 1.541 1.646A25.854 25.854 0 0 0 8 12.558a26.017 26.017 0 0 0 3.864-3.665c.374-.45.69-.92.948-1.409.258-.49.387-.92.387-1.29 0-.952-.267-1.702-.8-2.25-.395-.413-.963-.62-1.702-.62a2.5 2.5 0 0 0-1.438.442c-.434.296-.652.664-.652 1.105 0 .194-.06.344-.18.45A.62.62 0 0 1 8 5.48a.619.619 0 0 1-.425-.16c-.12-.105-.18-.268-.18-.489 0-.22-.059-.43-.175-.628a1.466 1.466 0 0 0-.419-.47c-.533-.273-1.032-.41-1.496-.41M8 14c-.197 0-.33-.036-.399-.106-.73-.503-1.617-1.235-2.657-2.196C3.37 10.233 2.325 8.871 1.81 7.61a4.187 4.187 0 0 1-.31-1.6c0-.564.107-1.122.322-1.673.215-.552.503-.991.864-1.317A3.742 3.742 0 0 1 5.304 2c.55 0 1.062.097 1.535.291.473.194.86.472 1.16.834a2.93 2.93 0 0 1 1.162-.834A3.89 3.89 0 0 1 10.65 2c.52 0 1.003.086 1.45.259.447.17.852.423 1.213.753.36.33.649.772.864 1.324.215.55.322 1.095.322 1.633s-.077 1.024-.232 1.456a5.965 5.965 0 0 1-.638 1.263c-.271.41-.57.82-.897 1.23-.326.41-.68.8-1.057 1.17-1.313 1.287-2.405 2.222-3.276 2.806-.07.07-.202.106-.4.106\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/link.svg":
/*!************************!*\
  !*** ./icons/link.svg ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M14.07 2.227c1.24 1.304 1.24 3.425 0 4.728l-2.283 2.4a3.108 3.108 0 0 1-2.246.978 3.115 3.115 0 0 1-2.253-.978l-.238-.25a3.366 3.366 0 0 1-.324-.399.714.714 0 0 1 .145-.965.637.637 0 0 1 .918.152c.058.082.122.161.192.235l.237.25a1.817 1.817 0 0 0 1.621.547 1.821 1.821 0 0 0 1.017-.548l2.284-2.4a2.034 2.034 0 0 0 0-2.772l-.238-.25a1.804 1.804 0 0 0-2.638 0l-1.428 1.5a.635.635 0 0 1-.93 0 .716.716 0 0 1 0-.978l1.428-1.5a3.076 3.076 0 0 1 4.498 0l.238.25zm-6.906 9.318a.635.635 0 0 1 .93 0 .716.716 0 0 1 0 .978l-1.427 1.5A3.092 3.092 0 0 1 4.418 15a3.093 3.093 0 0 1-2.249-.978l-.238-.25c-.6-.63-.93-1.47-.931-2.363 0-.893.33-1.732.931-2.364l2.284-2.4a3.108 3.108 0 0 1 1.734-.935 3.092 3.092 0 0 1 2.763.936l.238.25c.118.124.227.258.324.398a.715.715 0 0 1-.145.965.637.637 0 0 1-.918-.152 1.943 1.943 0 0 0-.191-.234l-.238-.25a1.818 1.818 0 0 0-1.62-.548 1.823 1.823 0 0 0-1.017.548l-2.284 2.4a2 2 0 0 0-.546 1.386c0 .524.194 1.016.547 1.386l.237.25c.728.764 1.91.764 2.638 0l1.427-1.5z\"/></svg>"

/***/ }),

/***/ "./icons/linkout.svg":
/*!***************************!*\
  !*** ./icons/linkout.svg ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M12.923 2H11V1h4v4h-1V3.077L8.538 8.538 7.462 7.462 12.923 2zM1 2h7v2H3v9h9V8h2v7H1V2z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/location.svg":
/*!****************************!*\
  !*** ./icons/location.svg ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"1 1 14 14\"><path d=\"M8.005 2.996a2.97 2.97 0 0 0-2.186.916 3 3 0 0 0-.91 2.192c0 .542.305 1.412.916 2.612a45.823 45.823 0 0 0 2.18 3.785 34.961 34.961 0 0 0 2.141-3.676c.637-1.264.955-2.171.955-2.721a3 3 0 0 0-.91-2.192 2.97 2.97 0 0 0-2.186-.916m.348 11.427a.827.827 0 0 1-.316.077c-.312 0-.525-.099-.638-.297a4.052 4.052 0 0 0-.24-.367 38.25 38.25 0 0 1-.534-.806c-.206-.318-.53-.839-.968-1.561a30.396 30.396 0 0 1-1.096-1.941 16.665 16.665 0 0 1-.8-1.838C3.52 7.037 3.4 6.508 3.4 6.104c0-.825.208-1.59.625-2.296a4.693 4.693 0 0 1 1.69-1.683 4.44 4.44 0 0 1 2.29-.625c.817 0 1.58.208 2.29.625.71.417 1.273.978 1.69 1.683.417.706.625 1.471.625 2.296 0 .404-.12.933-.361 1.586a19.672 19.672 0 0 1-1.662 3.395 67.288 67.288 0 0 1-1.505 2.403c-.305.451-.473.707-.503.767-.03.06-.105.116-.226.168\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/media-published.svg":
/*!***********************************!*\
  !*** ./icons/media-published.svg ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M14.61 9.759c.096 0 .189.037.256.103l1.028.99a.34.34 0 010 .494l-4.728 4.55a.369.369 0 01-.514 0l-2.546-2.452a.34.34 0 010-.494l1.03-.99a.368.368 0 01.513 0l1.26 1.213 3.444-3.311a.368.368 0 01.257-.103zM12.45 2a1.3 1.3 0 011.3 1.3v5.704h-1.734L9.908 7.057a.4.4 0 00-.554.011l-3.666 3.67-1.449-1.464a.4.4 0 00-.565-.003L1.75 11.174v3.059h5.51v1.747H1.3a1.3 1.3 0 01-1.3-1.3V3.3A1.3 1.3 0 011.3 2h11.15zM3.063 4.403a1.53 1.53 0 101.53 1.529 1.53 1.53 0 00-1.53-1.53z\"/></svg>"

/***/ }),

/***/ "./icons/mobile.svg":
/*!**************************!*\
  !*** ./icons/mobile.svg ***!
  \**************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 320 512\"><path d=\"M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm112-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v312z\"/></svg>"

/***/ }),

/***/ "./icons/more.svg":
/*!************************!*\
  !*** ./icons/more.svg ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path transform=\"rotate(90 8 8)\" fill-rule=\"evenodd\" d=\"M8 5a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 5a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 5a2 2 0 1 1 0-4 2 2 0 0 1 0 4z\"/></svg>"

/***/ }),

/***/ "./icons/multiple-users.svg":
/*!**********************************!*\
  !*** ./icons/multiple-users.svg ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M11 14l-.046-3C10.77 9.996 10.037 9.13 9 8.59A5.427 5.427 0 0 1 11.5 8c2.267 0 4.142 1.304 4.454 3L16 14h-5zM4.5 8c2.267 0 4.142 1.304 4.454 3L9 14H0l.046-3C.358 9.304 2.233 8 4.5 8zm7-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm-7 0a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z\"/></svg>"

/***/ }),

/***/ "./icons/new-feature-lg.svg":
/*!**********************************!*\
  !*** ./icons/new-feature-lg.svg ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon-lg\" viewBox=\"0 0 20 18\"><path d=\"M19.167 9l-2.034-2.317.284-3.066-3.009-.684-1.575-2.65L10 1.5 7.167.283l-1.575 2.65-3.009.675.284 3.067L.833 9l2.034 2.317-.284 3.075 3.009.683 1.575 2.65L10 16.5l2.833 1.217 1.575-2.65 3.009-.684-.284-3.066L19.167 9zm-8.334 4.167H9.167V11.5h1.666v1.667zm0-3.334H9.167v-5h1.666v5z\"/></svg>"

/***/ }),

/***/ "./icons/new.svg":
/*!***********************!*\
  !*** ./icons/new.svg ***!
  \***********************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M9 7h5v2H9v5H7V9H2V7h5V2h2v5z\"/></svg>"

/***/ }),

/***/ "./icons/notifications-lg.svg":
/*!************************************!*\
  !*** ./icons/notifications-lg.svg ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon-lg\" viewBox=\"0 0 24 24\"><path fill=\"none\" d=\"M0 0h24v24H0z\"/><path d=\"M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zm0 16a1.264 1.264 0 0 0 1.15-.75c.063-.148.094-.308.094-.48h-2.5A1.25 1.25 0 0 0 12 18zm3.75-6.77c0-1.888-1.025-3.47-2.813-3.888v-.419A.93.93 0 0 0 12 6a.93.93 0 0 0-.938.923v.419C9.27 7.76 8.25 9.335 8.25 11.23v3.077L7 15.538v.616h10v-.616l-1.25-1.23V11.23z\"/></svg>"

/***/ }),

/***/ "./icons/notifications.svg":
/*!*********************************!*\
  !*** ./icons/notifications.svg ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M8 0c4.416 0 8 3.584 8 8s-3.584 8-8 8-8-3.584-8-8 3.584-8 8-8zm0 12.8a1.011 1.011 0 0 0 .92-.6.975.975 0 0 0 .075-.385h-2A1 1 0 0 0 8 12.8zm3-5.415c0-1.512-.82-2.777-2.25-3.112v-.335A.743.743 0 0 0 8 3.2c-.415 0-.75.33-.75.738v.335C5.815 4.608 5 5.868 5 7.385v2.461l-1 .985v.492h8v-.492l-1-.985V7.385z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/pin-circle.svg":
/*!******************************!*\
  !*** ./icons/pin-circle.svg ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 22 22\" class=\"cu-icon\"><path d=\"M11 22C4.925 22 0 17.075 0 11S4.925 0 11 0s11 4.925 11 11-4.925 11-11 11zm1.993-16.267l1.483-.742V4.25H7.525v.741l1.483.742a.869.869 0 01.255.614v2.478a.865.865 0 01-.475.77c-1.263.64-1.263 1.673-1.263 2.475h2.703v4.905l.773.775.772-.775V12.07h2.703c0-.79 0-1.833-1.205-2.455-.278-.145-.533-.474-.533-.79V6.347a.87.87 0 01.255-.614z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/pin.svg":
/*!***********************!*\
  !*** ./icons/pin.svg ***!
  \***********************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 9 16\"><path d=\"M6.48 1.758l1.758-.88V0H0v.879l1.758.879c.193.193.302.454.302.727v2.938c0 .384-.22.738-.563.911C0 7.094 0 8.318 0 9.268h3.204v5.814l.915.918.916-.918V9.268h3.203c0-.935 0-2.172-1.428-2.91-.33-.17-.631-.562-.631-.935V2.485c0-.273.108-.534.301-.727\"/></svg>"

/***/ }),

/***/ "./icons/pinterest-export.svg":
/*!************************************!*\
  !*** ./icons/pinterest-export.svg ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 .371h15.629V16H0z\"/><path d=\"M13.676 9.117c.716 0 1.302.586 1.302 1.303v3.907c0 .716-.586 1.302-1.302 1.302H1.954A1.306 1.306 0 01.65 14.327V10.42c0-.717.586-1.303 1.303-1.303.716 0 1.302.586 1.302 1.303v2.604h9.117V10.42c0-.717.586-1.303 1.303-1.303zm-7.932-3.36a1.299 1.299 0 01-1.843 0 1.297 1.297 0 01-.007-1.837L7.808 0l3.92 3.914c.508.508.515 1.335.007 1.843a1.299 1.299 0 01-1.843 0l-.781-.775v4.024a1.302 1.302 0 11-2.605 0V4.988l-.762.769z\" fill=\"#868B8F\" fill-rule=\"nonzero\"/></g></svg>"

/***/ }),

/***/ "./icons/pinterest-more.svg":
/*!**********************************!*\
  !*** ./icons/pinterest-more.svg ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h15.629v15.629H0z\"/><path d=\"M7.815 5.861A1.951 1.951 0 005.86 7.815c0 1.08.873 1.953 1.954 1.953a1.951 1.951 0 001.953-1.953A1.951 1.951 0 007.815 5.86m-5.861 0c1.08 0 1.953.873 1.953 1.954a1.951 1.951 0 01-1.953 1.953A1.951 1.951 0 010 7.815C0 6.734.873 5.86 1.954 5.86zm11.722 0c1.08 0 1.953.873 1.953 1.954a1.951 1.951 0 01-1.953 1.953 1.951 1.951 0 01-1.954-1.953c0-1.081.873-1.954 1.954-1.954z\" fill=\"#868B8F\" fill-rule=\"nonzero\"/></g></svg>"

/***/ }),

/***/ "./icons/pinterest.svg":
/*!*****************************!*\
  !*** ./icons/pinterest.svg ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M5.70439 16c.7406-1.20555.82301-1.91279 1.35961-4.038.369.702 1.323 1.08 2.079 1.08 3.186 0 4.617-3.105 4.617-5.904 0-2.979-2.574-4.923-5.4-4.923-3.078 0-6.12 2.052-6.12 5.373C2.24 9.7 3.428 10.9 4.148 10.9c.297 0 .468-.828.468-1.062 0-.279-.711-.873-.711-2.034 0-2.412 1.836-4.122 4.212-4.122 2.043 0 3.555 1.161 3.555 3.294 0 1.593-.639 4.581-2.709 4.581-.747 0-1.386-.54-1.386-1.314 0-1.134.792-2.232.792-3.402 0-1.986-2.817-1.626-2.817.774 0 .504.063 1.062.288 1.521-.414 1.782-1.26 4.437-1.26 6.273 0 .19784.00986.39459.025.591H1c-.55228 0-1-.44772-1-1V1c0-.55228.44772-1 1-1h14c.55228 0 1 .44772 1 1v14c0 .55228-.44772 1-1 1H5.70439z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/product-bag.svg":
/*!*******************************!*\
  !*** ./icons/product-bag.svg ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M0,13.523 L0,13.412 L0.9,5.46 C0.957716756,5.30539871 1.05208275,5.16710964 1.175,5.057 C1.2857946,4.9450435 1.43554503,4.88019941 1.593,4.876 L4.181,4.876 L4.181,3.676 C4.181,2.676 4.549,1.815 5.286,1.089 C5.99972701,0.384970368 6.8573339,0.0213624129 7.85790873,-6.21724894e-15 L8.04617933,-6.21724894e-15 C9.0476661,0.0213624129 9.90527299,0.384970368 10.619,1.089 C11.355,1.815 11.724,2.677 11.724,3.677 L11.724,4.876 L14.311,4.876 C14.511,4.876 14.677,4.936 14.808,5.056 C14.9296286,5.15545068 15.0019139,5.30294184 15.006,5.46 L16,13.412 C16,14.117 15.76,14.709 15.282,15.188 C14.8508443,15.6277153 14.2682843,15.883294 13.6562361,15.905 L2.41487078,15.905 C1.75469001,15.8880022 1.19173309,15.6542992 0.726,15.203 C0.242,14.735 0,14.175 0,13.523 Z M13.412,14.517 C13.843,14.517 14.159,14.359 14.359,14.044 C14.4628523,13.8901695 14.5179148,13.7086025 14.5170221,13.523 L13.712,6.265 L11.724,6.265 L11.724,8.947 C11.730508,9.13315445 11.6593429,9.31363762 11.5275366,9.44525425 C11.3957303,9.57687089 11.2151449,9.64777608 11.029,9.641 C10.8431106,9.64719215 10.6629683,9.57606485 10.5314517,9.44454828 C10.3999351,9.3130317 10.3288079,9.13288942 10.335,8.947 L10.335,6.265 L5.57,6.265 L5.57,8.852 C5.57558389,9.03780616 5.50429463,9.21769072 5.37294518,9.34922943 C5.24159573,9.48076815 5.06181401,9.55231635 4.876,9.547 C4.69001504,9.55259737 4.50996821,9.48117333 4.37839744,9.34960256 C4.24682667,9.21803179 4.17540263,9.03798496 4.181,8.852 L4.181,6.17 L2.193,6.17 L1.388,13.523 C1.388,13.817 1.494,14.057 1.704,14.241 C1.914,14.425 2.177,14.517 2.494,14.517 L13.412,14.517 Z M5.57,3.677 L5.57,4.876 L10.335,4.876 L10.335,3.676 C10.335,3.035 10.101,2.493 9.633,2.052 C9.1829414,1.61717174 8.57871772,1.37871918 7.953,1.389 C7.3,1.389 6.74,1.609 6.273,2.052 C5.81572421,2.46725173 5.55955042,3.05940309 5.57,3.677 Z\"/></svg>"

/***/ }),

/***/ "./icons/product.svg":
/*!***************************!*\
  !*** ./icons/product.svg ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M8 0c2.032 0 3.716 1.503 4.145 3.5H13a2 2 0 012 2V14a2 2 0 01-2 2H3a2 2 0 01-2-2V5.5a2 2 0 012-2h.855C4.284 1.503 5.968 0 8 0zM4.75 5a.75.75 0 100 1.5.75.75 0 000-1.5zm6.5 0a.75.75 0 100 1.5.75.75 0 000-1.5zM8 1.5c-1.19 0-2.215.83-2.594 2h5.188c-.38-1.17-1.404-2-2.594-2z\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/reach.svg":
/*!*************************!*\
  !*** ./icons/reach.svg ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" d=\"M15.517 6.927a1.649 1.649 0 0 0-2.692.542h-3.72l1.917-3.19a1.648 1.648 0 1 0-.15-3.23 1.65 1.65 0 0 0-.922 2.587L8 6.88 6.053 3.639a1.65 1.65 0 1 0-2.925-1.387 1.652 1.652 0 0 0 1.854 2.03L6.896 7.47H3.18a1.65 1.65 0 1 0-.001 1.25h3.717l-1.914 3.185a1.652 1.652 0 0 0-1.854 2.031 1.65 1.65 0 1 0 2.925-1.387L8 9.307l1.95 3.244a1.65 1.65 0 0 0 .922 2.586 1.648 1.648 0 1 0 .15-3.23L9.106 8.719h3.719a1.649 1.649 0 1 0 2.692-1.792\"/></svg>"

/***/ }),

/***/ "./icons/requestrights-approved.svg":
/*!******************************************!*\
  !*** ./icons/requestrights-approved.svg ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"-1 0 1126 1008\" class=\"cu-icon\"><path d=\"M975 155q77 66 115 151 74 162-3 319-33 69-82 119.5t-109.5 95-118 74T667 965q-90 37-123 43h-10q-9 0-18-9-14-7-14-29v-28q0-3 1-10 7-56-1.5-64.5T427 853q-100-7-184.5-45.5T98 703Q-7 583 0 413q5-90 55-170t129-135 186-83.5T589.5 4t213 46.5T975 155zM577 928q196-72 324-178 189-156 153-343-22-117-121-201Q797 85 586 70h-37q-126 0-233 45.5T143 242Q47 360 76 510q18 91 79 156 49 56 123 89.5T436 792q91 0 122 38 30 30 19 98zm131-595q10-11 23.5-10t23.5 15q10 10 10 23t-10 23L539 600q-9 9-23 9t-24-9L370 478q-10-10-10-23t10.5-23.5T394 421t23 10l99 99z\"/></svg>"

/***/ }),

/***/ "./icons/requestrights-pending.svg":
/*!*****************************************!*\
  !*** ./icons/requestrights-pending.svg ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"-1 -5 1125 1008\"><path d=\"M300 445.5q0-27.5 19.5-46.5t39.5-19 32 5 21 14q19 19 19 46.5T412 492t-46 19-46.5-19-19.5-46.5zm197 0q0-27.5 19-46.5t46.5-19 46.5 19 19 41.5-9 37.5q-19 33-51.5 33T516 492t-19-46.5zm197 0q0-27.5 19-46.5t39.5-19 32.5 5 21 14q19 19 19 46.5T806 492t-46.5 19-46.5-19-19-46.5zM975 155q77 66 115 151 66 145 11 287-81 207-383 351-82 39-170 67-3 1-4 2h-10q-9 0-18-10-14-7-14-28v-28q0-3 1-10 7-56-1.5-64.5T427 858q-100-7-184.5-45.5T98 708Q-7 588 0 417q7-91 55-170t133-139Q363-17 591 5q111 7 211.5 45.5T975 155zM577 928q196-72 324-178 189-156 153-343-22-117-121-201Q797 85 586 70h-37q-182 0-319 94-74 49-115 116-63 104-39 230 18 91 79 156 49 56 123 89.5T436 792q91 0 122 38 30 30 19 98z\"/></svg>"

/***/ }),

/***/ "./icons/requestrights-rejected.svg":
/*!******************************************!*\
  !*** ./icons/requestrights-rejected.svg ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"-1 0 1126 1008\"><path d=\"M975 155q77 66 115 151 74 162-3 319-33 69-82 119.5t-109.5 95-118 74T667 965q-90 37-123 43h-10q-9 0-18-9-14-7-14-29v-28q0-3 1-10 7-56-1.5-64.5T427 853q-100-7-184.5-45.5T98 703Q-7 583 0 413q5-90 55-170t129-135 186-83.5T589.5 4t213 46.5T975 155zM577 928q196-72 324-178 189-156 153-343-22-117-121-201Q797 85 586 70h-37q-126 0-233 45.5T143 242Q47 360 76 510q18 91 79 156 49 56 123 89.5T436 792q91 0 122 38 30 30 19 98zm140.5-646.5Q728 292 728 305t-11 23L609 436l108 108q11 10 11 23t-10 23-24 10-24-9L563 483 455 591q-10 9-24 9t-24-10-10-23 11-23l108-108-108-108q-11-10-11-23t10.5-23.5T431 271t24 10l108 113 107-113q11-10 24-10t23.5 10.5z\"/></svg>"

/***/ }),

/***/ "./icons/search.svg":
/*!**************************!*\
  !*** ./icons/search.svg ***!
  \**************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 13 13\"><path fill-rule=\"evenodd\" d=\"M12.774 11.72L8.854 7.8c.604-.79.943-1.81.943-2.9C9.797 2.185 7.612 0 4.9 0 2.185 0 0 2.186 0 4.9 0 7.61 2.186 9.796 4.9 9.796c1.09 0 2.07-.34 2.9-.942l3.92 3.92c.15.15.338.225.526.225.19 0 .377-.075.528-.226.3-.302.3-.754 0-1.055zM4.9 8.29c-1.886 0-3.393-1.507-3.393-3.39 0-1.886 1.507-3.393 3.392-3.393 1.883 0 3.39 1.507 3.39 3.392 0 1.883-1.507 3.39-3.39 3.39z\"/></svg>"

/***/ }),

/***/ "./icons/settings.svg":
/*!****************************!*\
  !*** ./icons/settings.svg ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path class=\"svg-fill-color-1\" d=\"M15.862 7.253s-.29-.109-1.13-.186c-1.028-.095-1.338-.48-1.68-.96h-.007a5.22 5.22 0 0 0-.138-.337l.004-.004c-.098-.58-.15-1.072.509-1.866.539-.649.667-.932.667-.932-.126-.32-.43-.625-.43-.625s-.305-.304-.625-.43c0 0-.283.128-.932.667-.794.66-1.286.607-1.867.51l-.004.003a5.274 5.274 0 0 0-.336-.138v-.007c-.48-.341-.865-.652-.96-1.68-.078-.84-.187-1.13-.187-1.13C8.43 0 8 0 8 0s-.43 0-.747.138c0 0-.109.29-.187 1.13-.095 1.028-.48 1.339-.96 1.68v.007a5.444 5.444 0 0 0-.336.138l-.004-.004c-.58.098-1.072.15-1.866-.509-.649-.539-.932-.667-.932-.667-.321.126-.625.43-.625.43s-.304.305-.43.625c0 0 .128.283.667.932.66.794.606 1.286.51 1.866l.003.004c-.05.11-.095.223-.138.337h-.007c-.341.48-.652.865-1.68.96-.84.077-1.13.187-1.13.187C0 7.57 0 8 0 8s0 .43.138.746c0 0 .29.11 1.13.187 1.028.095 1.338.48 1.68.96h.007c.043.114.088.227.138.337l-.004.004c.098.58.15 1.072-.509 1.866-.539.649-.667.932-.667.932.126.32.43.625.43.625s.304.304.625.43c0 0 .283-.128.932-.667.794-.66 1.286-.606 1.866-.51l.004-.003c.11.05.223.095.337.138v.007c.48.341.864.652.96 1.68.077.84.186 1.13.186 1.13C7.57 16 8 16 8 16s.43 0 .746-.138c0 0 .11-.29.187-1.13.095-1.028.48-1.338.96-1.68v-.007c.114-.043.226-.088.336-.138l.005.004c.58-.098 1.072-.15 1.866.509.649.539.932.668.932.668.32-.127.625-.431.625-.431s.304-.304.43-.625c0 0-.128-.283-.667-.932-.66-.794-.607-1.286-.51-1.866l-.003-.004c.05-.11.095-.223.138-.337h.007c.341-.48.652-.865 1.68-.96.84-.077 1.13-.187 1.13-.187C16 8.43 16 8 16 8s0-.43-.138-.747zM8 11.741A3.741 3.741 0 1 1 8 4.26a3.741 3.741 0 0 1 0 7.482z\"/></svg>"

/***/ }),

/***/ "./icons/smile.svg":
/*!*************************!*\
  !*** ./icons/smile.svg ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M8,0 C12.4182903,0 16,3.58170968 16,8 C16,12.4182903 12.4182903,16 8,16 C3.58170968,16 0,12.4182903 0,8 C0,3.58170968 3.58170968,0 8,0 Z M8,1.5483871 C4.43390323,1.5483871 1.5483871,4.43445161 1.5483871,8 C1.5483871,11.5660968 4.43445161,14.4516129 8,14.4516129 C11.5660968,14.4516129 14.4516129,11.5655484 14.4516129,8 C14.4516129,4.43390323 11.5655484,1.5483871 8,1.5483871 Z M3.7633871,10.265129 C3.15667742,9.44006452 4.40345161,8.52193548 5.01080645,9.34777419 C6.62816129,11.547129 9.37312903,11.5470323 10.9903871,9.34777419 C11.5972903,8.52264516 12.844871,9.43958065 12.2378065,10.265129 C9.9996129,13.3087097 5.99880645,13.3048387 3.7633871,10.265129 Z M5.33333333,4.66666667 C6.069713,4.66666667 6.66666667,5.26362033 6.66666667,6 C6.66666667,6.73637967 6.069713,7.33333333 5.33333333,7.33333333 C4.59695367,7.33333333 4,6.73637967 4,6 C4,5.26362033 4.59695367,4.66666667 5.33333333,4.66666667 Z M10.6666667,4.66666667 C11.4030463,4.66666667 12,5.26362033 12,6 C12,6.73637967 11.4030463,7.33333333 10.6666667,7.33333333 C9.930287,7.33333333 9.33333333,6.73637967 9.33333333,6 C9.33333333,5.26362033 9.930287,4.66666667 10.6666667,4.66666667 Z\"/></svg>"

/***/ }),

/***/ "./icons/sparkles.svg":
/*!****************************!*\
  !*** ./icons/sparkles.svg ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M15.362 2.974a.25.25 0 000-.448L13.77 1.73 12.974.138a.25.25 0 00-.448 0L11.73 1.73l-1.592.796a.25.25 0 000 .448l1.592.796.796 1.592a.25.25 0 00.448 0l.796-1.592 1.592-.796zm0 10.5a.25.25 0 000-.448l-1.592-.796-.796-1.592a.25.25 0 00-.448 0l-.796 1.592-1.592.796a.25.25 0 000 .448l1.592.796.796 1.592a.25.25 0 00.448 0l.796-1.592 1.592-.796zm-3.638-5.027a.5.5 0 000-.894l-3.518-1.76-1.759-3.517a.5.5 0 00-.894 0L3.794 5.794.276 7.553a.5.5 0 000 .894l3.518 1.76 1.759 3.517a.5.5 0 00.894 0l1.759-3.518 3.518-1.759z\"/></svg>"

/***/ }),

/***/ "./icons/spinner.svg":
/*!***************************!*\
  !*** ./icons/spinner.svg ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"10 10 80 80\"><circle cx=\"50\" cy=\"50\" fill=\"none\" r=\"30\" stroke=\"#a7ebe1\" stroke-width=\"8\"/><circle class=\"cu-spinner-spiral\" cx=\"50\" cy=\"50\" fill=\"none\" r=\"30\" stroke=\"#00c9b1\" stroke-width=\"8\" stroke-linecap=\"square\" transform=\"rotate(64.538 50 50)\"/></svg>"

/***/ }),

/***/ "./icons/sticker.svg":
/*!***************************!*\
  !*** ./icons/sticker.svg ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M11.307 0A4.699 4.699 0 0 1 16 4.693v4.438a.403.403 0 0 1-.118.286l-.004.004-6.653 6.464a.404.404 0 0 1-.281.115l-.014-.001L4.693 16A4.699 4.699 0 0 1 0 11.307V4.693A4.699 4.699 0 0 1 4.693 0h6.614zM10.5 1.616H5.501a3.89 3.89 0 0 0-3.885 3.885V10.5a3.89 3.89 0 0 0 3.885 3.885l3.038-.001v-.963a4.73 4.73 0 0 1 .26-1.536c-.39.105-.794.158-1.203.156a4.77 4.77 0 0 1-3.485-1.523.543.543 0 0 1-.135-.51.511.511 0 0 1 .355-.374.48.48 0 0 1 .483.143c1.352 1.362 3.377 1.541 4.906.539a4.68 4.68 0 0 1 3.514-1.588h1.149V5.501A3.89 3.89 0 0 0 10.5 1.616zM5.172 4.768a1.212 1.212 0 1 1 0 2.424 1.212 1.212 0 0 1 0-2.424zm5.656 0a1.212 1.212 0 1 1 0 2.424 1.212 1.212 0 0 1 0-2.424z\"/></svg>"

/***/ }),

/***/ "./icons/sync-alt.svg":
/*!****************************!*\
  !*** ./icons/sync-alt.svg ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M11.7 4.041a5.38 5.38 0 0 0-3.705-1.46 5.426 5.426 0 0 0-5.251 4.092.388.388 0 0 1-.376.295H.519a.387.387 0 0 1-.38-.458 8.002 8.002 0 0 1 13.387-4.294l1.152-1.152A.774.774 0 0 1 16 1.61v4.324a.774.774 0 0 1-.774.775H10.9a.774.774 0 0 1-.547-1.322L11.7 4.041zM.775 9.291H5.1c.69 0 1.035.833.547 1.321L4.3 11.959a5.38 5.38 0 0 0 3.706 1.46 5.426 5.426 0 0 0 5.251-4.092.388.388 0 0 1 .376-.295h1.849c.241 0 .425.22.38.458a8.002 8.002 0 0 1-13.387 4.294l-1.152 1.152A.774.774 0 0 1 0 14.39v-4.324c0-.428.347-.775.774-.775z\"/></svg>"

/***/ }),

/***/ "./icons/tag.svg":
/*!***********************!*\
  !*** ./icons/tag.svg ***!
  \***********************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><g fill-rule=\"evenodd\"><path d=\"M7.562 5.32a.947.947 0 0 0-.709-.305.989.989 0 0 0-.714.293.987.987 0 0 0-.293.714c0 .28.107.526.309.713L9.049 9.63a.914.914 0 0 0 .66.271.938.938 0 0 0 .671-.274.953.953 0 0 0 .29-.703.949.949 0 0 0-.309-.713L7.562 5.32zM5.666 7.248a.978.978 0 0 0-.709-.29.993.993 0 0 0-.714.294.983.983 0 0 0-.293.706c0 .269.094.507.278.706l2.91 2.909a.92.92 0 0 0 .668.27.924.924 0 0 0 .679-.29.977.977 0 0 0 .274-.701.979.979 0 0 0-.285-.706L5.666 7.248z\"/><path d=\"M13.948 2.381v4.893c0 .104-.028.321-.162.763a2.09 2.09 0 0 1-.484.852l-5.069 4.977a.317.317 0 0 1-.245.097.317.317 0 0 1-.244-.095L2.031 8.155a.407.407 0 0 1-.109-.289c0-.117.037-.21.117-.298l4.887-4.977c.06-.053.23-.175.64-.393a2.06 2.06 0 0 1 .97-.246h4.982a.43.43 0 0 1 .305.124c.085.08.125.177.125.305M15.443.938C14.96.315 14.311 0 13.518 0H8.535c-.322 0-.684.06-1.075.18-.813.235-1.47.604-1.95 1.095L.71 6.167A2.24 2.24 0 0 0 0 7.82c0 .64.24 1.197.713 1.66l5.618 5.707a2.304 2.304 0 0 0 1.702.728c.66 0 1.202-.215 1.613-.638l4.981-4.98c.348-.338.652-.809.9-1.395.247-.587.373-1.135.373-1.628V2.29c0-.5-.154-.956-.457-1.352\"/><path d=\"M11.611 2.993c-.329 0-.615.12-.85.354a1.163 1.163 0 0 0-.354.85c0 .33.12.615.354.85.235.235.521.354.85.354.33 0 .616-.119.851-.354.234-.235.353-.52.353-.85 0-.329-.119-.616-.353-.85a1.165 1.165 0 0 0-.85-.354\"/></g></svg>"

/***/ }),

/***/ "./icons/text.svg":
/*!************************!*\
  !*** ./icons/text.svg ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 -3 16 16\"><path d=\"M2.004 9.884l.708-2.397h3.086l.694 2.397h2.15L5.52 0H3.135L0 9.884h2.004zM5.41 5.887H3.107l1.11-3.867h.097L5.41 5.887zM12.095 10c1.09 0 1.7-.529 1.977-1.079h.09v.963H16V4.736c0-1.977-1.366-2.68-3.052-2.68-2.101 0-2.94 1.123-3.01 2.376h1.838c.084-.464.423-.797 1.138-.797.707 0 1.158.348 1.158 1.036v.666h-1.776c-1.706 0-2.628.92-2.628 2.31 0 1.462.992 2.353 2.427 2.353zm.652-1.52c-.596 0-1.144-.326-1.144-.985 0-.55.374-.942 1.144-.942h1.325v.775c0 .673-.603 1.151-1.325 1.151z\"/></svg>"

/***/ }),

/***/ "./icons/trending-down.svg":
/*!*********************************!*\
  !*** ./icons/trending-down.svg ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M14.52 6.788l.79.792a.852.852 0 010 1.208l-6.923 6.927a.852.852 0 01-1.208 0L.25 8.788a.852.852 0 010-1.208l.791-.792a.856.856 0 011.223.015l4.09 4.294V.855c0-.474.382-.855.856-.855h1.14c.474 0 .855.381.855.855v10.242l4.091-4.294a.85.85 0 011.222-.015z\"/></svg>"

/***/ }),

/***/ "./icons/trending-up.svg":
/*!*******************************!*\
  !*** ./icons/trending-up.svg ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M1.042 9.178l-.79-.791a.852.852 0 010-1.208L7.174.25a.852.852 0 011.208 0l6.924 6.924a.852.852 0 010 1.208l-.791.791a.856.856 0 01-1.222-.014L9.206 4.87v10.24a.853.853 0 01-.855.856h-1.14a.853.853 0 01-.856-.855V4.869l-4.09 4.294a.85.85 0 01-1.223.015z\"/></svg>"

/***/ }),

/***/ "./icons/twitter-comment.svg":
/*!***********************************!*\
  !*** ./icons/twitter-comment.svg ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h22v22H0z\"/><path d=\"M13 1H8.8A7.72 7.72 0 001 8.8a7.4 7.4 0 007.47 7.37V20a.77.77 0 00.12.4.73.73 0 00.63.35.77.77 0 00.4-.12c.26-.17 6.47-4.14 8.09-5.5a8.44 8.44 0 003-6.32A7.72 7.72 0 0013 1zm3.79 13c-1.14 1-4.86 3.41-6.77 4.65v-3.21a.75.75 0 00-.75-.75h-.4c-3.66 0-6.32-2.48-6.32-5.89A6.24 6.24 0 018.8 2.5H13a6.24 6.24 0 016.3 6.3 6.92 6.92 0 01-2.56 5.2h.05z\" fill=\"#8899A6\" fill-rule=\"nonzero\"/></g></svg>"

/***/ }),

/***/ "./icons/twitter-like.svg":
/*!********************************!*\
  !*** ./icons/twitter-like.svg ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h22v22H0z\"/><path d=\"M11 20.41c-2.59 0-10-6.78-10-13.16A5.74 5.74 0 016.35 1.5 5.86 5.86 0 0111 4.23a5.83 5.83 0 014.64-2.73 5.74 5.74 0 015.41 5.76c0 6.37-7.46 13.11-10 13.15H11zM6.35 3a4.2 4.2 0 00-3.9 4.26c0 5.74 7 11.59 8.55 11.65 1.55.06 8.55-5.91 8.55-11.65A4.2 4.2 0 0015.65 3c-2.53 0-3.94 2.94-3.95 3a.79.79 0 01-1.39 0S8.88 3 6.36 3h-.01z\" fill=\"#8899A6\" fill-rule=\"nonzero\"/></g></svg>"

/***/ }),

/***/ "./icons/twitter-retweet.svg":
/*!***********************************!*\
  !*** ./icons/twitter-retweet.svg ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h22v22H0z\"/><path d=\"M21.785 14.161a.695.695 0 00-.973 0l-2.037 2.02V6.897c0-1.876-1.54-3.397-3.441-3.397H9.966a.684.684 0 00-.688.68c0 .375.308.679.688.679h5.368a2.08 2.08 0 011.472.59c.39.383.611.904.61 1.448v9.284l-2.036-2.01a.695.695 0 00-.973 0 .673.673 0 000 .96l3.212 3.17c.128.129.303.2.486.199a.684.684 0 00.486-.2l3.212-3.17a.675.675 0 00-.018-.969zm-9.782 2.971H6.635c-1.14 0-2.064-.912-2.064-2.038V5.82l2.037 2.01a.695.695 0 00.972 0 .673.673 0 000-.96L4.37 3.7a.695.695 0 00-.973 0L.185 6.87a.673.673 0 00.017.944.695.695 0 00.955.017L3.194 5.82v9.275c0 1.876 1.54 3.397 3.441 3.397h5.368c.38 0 .688-.304.688-.68a.684.684 0 00-.688-.679z\" fill=\"#8899A6\" fill-rule=\"nonzero\"/></g></svg>"

/***/ }),

/***/ "./icons/twitter-share.svg":
/*!*********************************!*\
  !*** ./icons/twitter-share.svg ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h22v22H0z\"/><path d=\"M20.25 12.15a.75.75 0 01.75.75v5.65a2.29 2.29 0 01-2.29 2.29H3.29A2.29 2.29 0 011 18.55V12.9a.76.76 0 01.75-.75.76.76 0 01.75.75v5.65c0 .436.354.79.79.79h15.42a.79.79 0 00.79-.79V12.9a.75.75 0 01.75-.75zM10.47 1.37a.75.75 0 011.06 0l5 5a.75.75 0 01-1.06 1.06l-3.72-3.72V13.9a.75.75 0 11-1.5 0V3.71L6.53 7.43a.75.75 0 01-1.06-1.06z\" fill=\"#8899A6\" fill-rule=\"nonzero\"/></g></svg>"

/***/ }),

/***/ "./icons/twitter-square.svg":
/*!**********************************!*\
  !*** ./icons/twitter-square.svg ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\"><path d=\"M14.286 0H1.714C.768 0 0 .768 0 1.714v12.572C0 15.232.768 16 1.714 16h12.572c.946 0 1.714-.768 1.714-1.714V1.714C16 .768 15.232 0 14.286 0zm-1.747 5.671c.007.1.007.204.007.304 0 3.096-2.357 6.664-6.664 6.664a6.634 6.634 0 01-3.596-1.05c.189.022.371.029.564.029a4.696 4.696 0 002.907-1 2.345 2.345 0 01-2.19-1.625c.362.053.687.053 1.058-.043a2.343 2.343 0 01-1.875-2.3v-.029c.31.175.675.283 1.057.297a2.337 2.337 0 01-1.043-1.95c0-.436.115-.836.318-1.182a6.65 6.65 0 004.829 2.45c-.332-1.59.857-2.879 2.285-2.879.675 0 1.283.282 1.711.74a4.59 4.59 0 001.486-.565 2.34 2.34 0 01-1.029 1.29c.472-.05.929-.183 1.35-.365a4.93 4.93 0 01-1.175 1.214z\"/></svg>"

/***/ }),

/***/ "./icons/twitter.svg":
/*!***************************!*\
  !*** ./icons/twitter.svg ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon cu-icon-stroke\" viewBox=\"0 0 16 14\"><path d=\"M5.032 13.473c6.037 0 9.34-5.002 9.34-9.34 0-.142 0-.284-.01-.425A6.679 6.679 0 0 0 16 2.01a6.55 6.55 0 0 1-1.885.517A3.294 3.294 0 0 0 15.558.71a6.579 6.579 0 0 1-2.085.797A3.286 3.286 0 0 0 7.88 4.5a9.32 9.32 0 0 1-6.765-3.43A3.285 3.285 0 0 0 2.13 5.453a3.258 3.258 0 0 1-1.49-.41v.04a3.284 3.284 0 0 0 2.634 3.219c-.484.132-.99.15-1.483.056a3.286 3.286 0 0 0 3.067 2.28A6.587 6.587 0 0 1 0 11.998a9.293 9.293 0 0 0 5.032 1.472\" fill-rule=\"evenodd\"/></svg>"

/***/ }),

/***/ "./icons/undo.svg":
/*!************************!*\
  !*** ./icons/undo.svg ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" width=\"16\" height=\"16\"><path d=\"M4.857 8.081L6.798 6 8 7.143 4 11 0 7.143 1.202 6 3 7.928a6.5 6.5 0 1 1 4.348 6.207l.615-1.752A4.643 4.643 0 1 0 4.857 8v.081z\"/></svg>"

/***/ }),

/***/ "./icons/upload.svg":
/*!**************************!*\
  !*** ./icons/upload.svg ***!
  \**************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"evenodd\"><path d=\"M9.5,0 C6.812,0 4.41,1.673 3.448,4.14 C1.441,4.613 0,6.383 0,8.5 C0,10.981 2.019,13 4.5,13 C5.052,13 5.5,12.553 5.5,12 C5.5,11.447 5.052,11 4.5,11 C3.122,11 2,9.879 2,8.5 C2,7.201 2.984,6.137 4.289,6.026 C4.706,5.991 5.057,5.7 5.168,5.297 C5.707,3.356 7.488,2 9.5,2 C11.981,2 14,4.019 14,6.5 C14,8.423 12.779,10.134 10.962,10.757 C10.439,10.937 10.161,11.505 10.34,12.027 C10.52,12.55 11.088,12.826 11.61,12.649 C14.236,11.749 16,9.277 16,6.5 C16,2.916 13.084,0 9.5,0\"/><path d=\"M10.5352,7.293 L8.7072,5.464 C8.5192,5.277 8.2652,5.171 8.0002,5.171 C7.7352,5.171 7.4802,5.277 7.2932,5.464 L5.4642,7.293 C5.0742,7.684 5.0742,8.316 5.4642,8.707 C5.8552,9.098 6.4882,9.098 6.8782,8.707 L7.0002,8.585 L7.0002,15 C7.0002,15.553 7.4482,16 8.0002,16 C8.5522,16 9.0002,15.553 9.0002,15 L9.0002,8.586 L9.1212,8.707 C9.3162,8.902 9.5722,9 9.8282,9 C10.0842,9 10.3402,8.902 10.5352,8.707 C10.9262,8.317 10.9262,7.684 10.5352,7.293\"/></g></svg>"

/***/ }),

/***/ "./icons/user.svg":
/*!************************!*\
  !*** ./icons/user.svg ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 16 16\" class=\"cu-icon\"><path fill-rule=\"evenodd\" d=\"M8 9c3.023 0 5.523 1.087 5.94 2.5L14 14H2l.06-2.5C2.478 10.087 4.978 9 8 9zm0-1a3 3 0 1 1 0-6 3 3 0 0 1 0 6z\"/></svg>"

/***/ }),

/***/ "./icons/verified.svg":
/*!****************************!*\
  !*** ./icons/verified.svg ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M15.30347,8.35273037 C15.3174743,7.30258744 14.7390263,6.33402345 13.8078179,5.84838254 C13.9199868,5.536004 13.9764951,5.20637197 13.9747744,4.8744695 C13.9915717,4.15302647 13.7209898,3.45447793 13.2225918,2.93259519 C12.7241938,2.41071244 12.0388349,2.10827589 11.3173831,2.0918608 C11.0008479,2.09181528 10.6870796,2.1507943 10.3921657,2.26577384 C9.97843262,1.3124655 9.03833917,0.695652174 7.99912222,0.695652174 C6.95990527,0.695652174 6.01981182,1.3124655 5.60607874,2.26577384 C5.31116485,2.1507943 4.99739649,2.09181528 4.68086135,2.0918608 C3.95940953,2.10827589 3.27405068,2.41071244 2.77565265,2.93259519 C2.27725463,3.45447793 2.00667272,4.15302647 2.02347005,4.8744695 C2.02174932,5.20637197 2.07825767,5.536004 2.19042657,5.84838254 C1.29605227,6.3323566 0.727014462,7.25591703 0.696907182,8.27239616 C0.666799902,9.28887529 1.18017791,10.244496 2.04433961,10.7805565 C2.03741705,10.898716 2.03741705,11.0171795 2.04433961,11.1353391 C2.02754229,11.8567821 2.29812419,12.5553306 2.79652222,13.0772134 C3.29492024,13.5990961 3.98027909,13.9015327 4.70173092,13.9179478 C5.01826606,13.9179933 5.33203442,13.8590143 5.62694831,13.7440347 C6.04068139,14.6973431 6.98077484,15.3141564 8.01999179,15.3141564 C9.05920874,15.3141564 9.99930219,14.6973431 10.4130353,13.7440347 C10.7079492,13.8590143 11.0217175,13.9179933 11.3382527,13.9179478 C12.0597045,13.9015327 12.7450633,13.5990961 13.2434614,13.0772134 C13.7418594,12.5553306 14.0124413,11.8567821 13.995644,11.1353391 C14.0027592,11.0148643 14.0027592,10.8940747 13.995644,10.7735999 C14.8279742,10.253718 15.3249157,9.33384752 15.30347,8.35273037 Z M10.7052092,6.03620863 L7.68607874,10.5579478 C7.589239,10.701218 7.42770274,10.787197 7.2547744,10.787513 C7.14797127,10.790041 7.04315779,10.7583532 6.95564396,10.6970782 L6.8721657,10.6344695 L5.20260048,8.95099124 C5.08372326,8.74190815 5.12317818,8.47865265 5.29812736,8.31360625 C5.47307654,8.14855985 5.73818217,8.12449409 5.93999179,8.25533906 L7.17129613,9.47968689 L9.83564396,5.48664341 C9.99700716,5.2465196 10.3224767,5.18267152 10.5626005,5.34403471 C10.8027243,5.50539791 10.8665724,5.83086743 10.7052092,6.07099124 L10.7052092,6.03620863 Z\"/></svg>"

/***/ }),

/***/ "./icons/zoom.svg":
/*!************************!*\
  !*** ./icons/zoom.svg ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<svg class=\"cu-icon\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.003 0a7 7 0 015.769 10.965l2.952 2.986c.49.492.264 1.026-.227 1.518-.49.492-1 .767-1.49.275l-3.003-3.004a6.975 6.975 0 01-4.001 1.254A7 7 0 010 6.997 7 7 0 017.003 0zm.019 2.513A4.5 4.5 0 002.52 7.01a4.5 4.5 0 004.502 4.498 4.5 4.5 0 004.501-4.498 4.5 4.5 0 00-4.501-4.498z\"/><path d=\"M7.5 4a.5.5 0 01.5.5V6h1.5a.5.5 0 01.492.41L10 6.5v1a.5.5 0 01-.5.5H8v1.5a.5.5 0 01-.41.492L7.5 10h-1a.5.5 0 01-.5-.5V8H4.5a.5.5 0 01-.492-.41L4 7.5v-1a.5.5 0 01.5-.5H6V4.5a.5.5 0 01.41-.492L6.5 4z\"/></svg>"

/***/ }),

/***/ "./src/angularjs/components/alert/alert.js":
/*!*************************************************!*\
  !*** ./src/angularjs/components/alert/alert.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  var template = '<div class="cu-alert cu-text-body" ng-class="\'cu-alert-\' + $ctrl.type" role="alert">\n  <span class=\'cu-alert-icon\'><cu-icon name="{{ $ctrl.iconName }}"></cu-icon></span>\n  <span class=\'cu-alert-content\'>\n    <button ng-if="$ctrl.onDismiss" ng-click="$ctrl.onDismiss()" type="button" class="cu-close cu-button-invisible" aria-label="Close">\n      <cu-icon name="close"></cu-icon>\n    </button>\n    <ng-transclude></ng-tranclude>\n  </span>\n</div>';
  var unison = angular.module('unison');

  unison.component('cuAlert', {
    transclude: true,
    bindings: {
      onDismiss: '&?',
      type: '@'
    },
    template: template,
    controller: function controller() {
      this.iconName = {
        success: 'circle-checkmark',
        warning: 'alarm',
        error: 'error',
        info: 'lightbulb'
      }[this.type];
    }
  });
})();

/***/ }),

/***/ "./src/angularjs/components/calendar/calendar.html":
/*!*********************************************************!*\
  !*** ./src/angularjs/components/calendar/calendar.html ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<div class=\"cu-d-inline-flex cu-p-4 cu-pos-relative\">\n    <cu-calendar-viewport\n        class=\"cu-d-block cu-pos-relative\"\n        ng-style=\"{ height: (($ctrl.heightInWeeks * 32) + 77) + 'px', width: ($ctrl.numMonthsToShow * 236) + 'px' }\"\n    >\n        <div\n                class=\"cu-pos-absolute cu-calendar-reel\"\n                ng-style=\"{ left: (($ctrl.getVisibleMonth()) * -248) + 'px' }\"\n        >\n            <cu-calendar\n                    ng-repeat=\"calendar in $ctrl.calendars\"\n                    class=\"cu-pos-absolute cu-pr-4\"\n                    data-month=\"{{ calendar.month % 12 }}\"\n                    data-year=\"{{ calendar.year }}\"\n                    ng-style=\"{ transform: 'translateX(' + calendar.month * 248 + 'px)' }\"\n                    ct-calendar=\"{{ $index }}\"\n            >\n                <div class=\"cu-text-center cu-pb-4\">\n                    <b ct-calendar-title>{{ calendar.monthName }} {{ calendar.year }}</b>\n                </div>\n\n                <cu-calendar-square>S</cu-calendar-square\n                ><cu-calendar-square>M</cu-calendar-square\n                ><cu-calendar-square>T</cu-calendar-square\n                ><cu-calendar-square>W</cu-calendar-square\n                ><cu-calendar-square>T</cu-calendar-square\n                ><cu-calendar-square>F</cu-calendar-square\n                ><cu-calendar-square>S</cu-calendar-square>\n\n                <cu-calendar-square\n                      ng-repeat=\"day in calendar.days\"\n                      ng-class=\"{ 'cu-calendar-day': day.display }\"\n                      ng-disabled=\"day.disabled\"\n                      ng-mouseenter=\"$ctrl.onDayMouseenter(day)\"\n                      ng-mouseleave=\"$ctrl.onDayMouseleave(day)\"\n                      class=\"cu-text-center\"\n                >\n                    <cu-calendar-square-element class=\"cu-calendar-square\" day=\"day\"></cu-calendar-square-element>\n                </cu-calendar-square>\n            </cu-calendar>\n        </div>\n    </cu-calendar-viewport>\n\n    <button\n            class=\"cu-button-flat cu-button-icon cu-pos-absolute cu-calendar-month-back\"\n            ng-click=\"$ctrl.goBackMonth()\"\n            cu-hide-focusable=\"$ctrl.hideBackwardsMonthButton()\"\n            ct-calendar-back\n    ><cu-icon name=\"chevron-right\" class=\"cu-d-inline-block cu-rot-180\"></cu-icon></button>\n    <button\n            class=\"cu-button-flat cu-button-icon cu-pos-absolute cu-calendar-month-forward\"\n            ng-click=\"$ctrl.goForwardMonth()\"\n            cu-hide-focusable=\"$ctrl.hideForwardMonthButton()\"\n            ct-calendar-forward\n    ><cu-icon name=\"chevron-right\"></cu-icon></button>\n</div>\n";

/***/ }),

/***/ "./src/angularjs/components/calendar/calendar.js":
/*!*******************************************************!*\
  !*** ./src/angularjs/components/calendar/calendar.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _calendar = __webpack_require__(/*! ./calendar.html */ "./src/angularjs/components/calendar/calendar.html");

var _calendar2 = _interopRequireDefault(_calendar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } //
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  angular.module('unison').component('cuCalendarView', {
    template: _calendar2.default,
    bindings: {
      minDate: '<?',
      maxDate: '<?',
      numMonthsToShow: '<?',
      visibleDate: '=?'
    },
    transclude: true,
    controller: ['$compile', '$sce', '$scope', '$timeout', '$transclude', 'cuDateLiteService', function DateRangePickerPanel($compile, $sce, $scope, $timeout, $transclude, DLS) {
      var _this = this;

      this.$onInit = function () {
        _this.minDate = _this.minDate || DLS.genesis;
        _this.maxDate = _this.maxDate || DLS.maxDate;

        _this.numMonthsToShow = _this.numMonthsToShow || 1;

        $scope.$watch(function () {
          return +_this.visibleDate;
        }, _this.setCalendars);
      };

      this.getDayElement = function (day) {
        var element = null;

        $transclude(function (content, transcludedScope) {
          var customDayElement = Array.prototype.slice.call(content).filter(function (elem) {
            return elem.tagName === 'CU-CALENDAR-DAY-CUSTOM';
          })[0];
          var dayTemplate = customDayElement ? customDayElement.outerHTML : '<span>{{ $cuCalendarDay.display }}</span>';
          var dayScope = transcludedScope;

          // Put the day on the user's scope
          dayScope.$cuCalendarDay = day;

          element = $compile(dayTemplate)(dayScope);
        });

        return element;
      };

      this.onDayMouseenter = function (day) {
        if (!day.disabled) {
          _this.hoveredDate = day.date;
        }
      };

      this.onDayMouseleave = function (day) {
        if (!day.disabled) {
          delete _this.hoveredDate;
        }
      };

      this.hideBackwardsMonthButton = function () {
        var minMonth = DLS.getAbsoluteMonth(_this.minDate);
        return _this.getVisibleMonth() <= minMonth;
      };

      this.hideForwardMonthButton = function () {
        var maxMonth = DLS.getAbsoluteMonth(_this.maxDate);
        return _this.getVisibleMonth() + _this.numMonthsToShow >= maxMonth + 1;
      };

      this.setCalendars = function () {
        var visibleMonth = _this.getVisibleMonth();
        var calendars = [];

        for (var i = -1; i < _this.numMonthsToShow + 1; i += 1) {
          calendars.push(_this.getMonthInfo(visibleMonth + i));
        }

        var visibleCalendars = calendars.slice(1, _this.numMonthsToShow + 1);

        _this.heightInWeeks = Math.max.apply(Math, _toConsumableArray(visibleCalendars.map(function (_) {
          return _.heightInWeeks;
        })));

        // Transcluding and compiling every calendar day is expensive,
        // so throttle it for a smooth animation and click mania protection.
        if (_this.timeout) {
          $timeout.cancel(_this.timeout);

          _this.timeout = $timeout(function () {
            _this.calendars = calendars;
          }, 250);
        } else {
          _this.calendars = calendars;
        }
      };

      this.getMonthInfo = function (month) {
        var prevMonthNumDays = DLS.createDateLite(DLS.genesisYear, month, 0).getDate();
        var numDays = DLS.createDateLite(DLS.genesisYear, month + 1, 0).getDate();
        var startDay = DLS.createDateLite(DLS.genesisYear, month, 1).getDay();

        var days = [];

        for (var i = prevMonthNumDays - startDay + 1; i <= prevMonthNumDays; i += 1) {
          days.push({ display: '', disabled: true });
        }

        for (var _i = 1; _i <= numDays; _i += 1) {
          var date = DLS.createDateLite(DLS.genesisYear, month, _i);
          days.push({
            display: _i,
            date: date,
            disabled: _this.isDateDisabled(date)
          });
        }

        return {
          days: days,
          month: month,
          year: DLS.genesisYear + Math.floor(month / 12),
          monthName: DLS.MONTH_NAMES[month % 12],
          heightInWeeks: Math.ceil((startDay + numDays) / 7)
        };
      };

      this.goBackMonth = function () {
        _this.visibleDate.setDate(1);
        _this.visibleDate.setMonth(_this.visibleDate.getMonth() - 1);
      };

      this.goForwardMonth = function () {
        _this.visibleDate.setDate(1);
        _this.visibleDate.setMonth(_this.visibleDate.getMonth() + 1);
      };

      this.isDateDisabled = function (date) {
        return date < _this.minDate || date > _this.maxDate;
      };

      this.getVisibleMonth = function () {
        return DLS.getAbsoluteMonth(_this.visibleDate);
      };

      $scope.$watch('$ctrl.minDate', function () {
        return _this.setCalendars();
      });

      $scope.$watch('$ctrl.maxDate', function () {
        return _this.setCalendars();
      });
    }]
  });

  angular.module('unison').component('cuCalendarSquareElement', {
    require: {
      calendarCtrl: '^cuCalendarView'
    },
    bindings: {
      day: '<'
    },
    controller: ['$element', function DateRangePickerPanel($element) {
      var _this2 = this;

      this.$onInit = function () {
        $element.append(_this2.calendarCtrl.getDayElement(_this2.day));
      };
    }]
  });
})();

/***/ }),

/***/ "./src/angularjs/components/combo-button/combo-button-options.js":
/*!***********************************************************************!*\
  !*** ./src/angularjs/components/combo-button/combo-button-options.js ***!
  \***********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  angular.module('unison').component('cuComboButtonOptions', {
    transclude: true,
    template: '<ng-transclude></ng-transclude>',
    controller: ['$element', function ComboButtonOptionCtrl($element) {
      $element.css('minWidth', $element.closest('cu-combo-button').width());
    }]
  });
})();

/***/ }),

/***/ "./src/angularjs/components/combo-button/combo-button.html":
/*!*****************************************************************!*\
  !*** ./src/angularjs/components/combo-button/combo-button.html ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<cu-popover ng-disabled=\"$ctrl.disabled()\" positioning-strategy=\"{ align: ['right', 'left'] }\">\n    <cu-popover-target class=\"cu-d-block\">\n        <ng-transclude ng-transclude-slot=\"button\"></ng-transclude>\n    </cu-popover-target>\n\n    <cu-popover-content>\n        <ng-transclude ng-transclude-slot=\"options\" cu-popover-click-close></ng-transclude>\n    </cu-popover-content>\n</cu-popover>\n";

/***/ }),

/***/ "./src/angularjs/components/combo-button/combo-button.js":
/*!***************************************************************!*\
  !*** ./src/angularjs/components/combo-button/combo-button.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _comboButton = __webpack_require__(/*! ./combo-button.html */ "./src/angularjs/components/combo-button/combo-button.html");

var _comboButton2 = _interopRequireDefault(_comboButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  angular.module('unison').component('cuComboButton', {
    bindings: {
      disabled: '&ngDisabled'
    },
    transclude: {
      button: 'cuComboButtonHandle',
      options: 'cuComboButtonOptions'
    },
    template: _comboButton2.default
  });
})(); //
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/***/ }),

/***/ "./src/angularjs/components/counter/counter.js":
/*!*****************************************************!*\
  !*** ./src/angularjs/components/counter/counter.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  var template = '<cu-badge>{{ $ctrl.getNumberString() }}</cu-badge>';
  var unison = angular.module('unison');

  unison.component('cuCounter', {
    bindings: {
      value: '<'
    },
    template: template,
    controller: function controller() {
      var _this = this;

      this.getNumberString = function () {
        var num = +_this.value || 0;
        return num < 99 ? num.toString() : '99+';
      };
    }
  });
})();

/***/ }),

/***/ "./src/angularjs/components/date-picker/date-picker-panel.js":
/*!*******************************************************************!*\
  !*** ./src/angularjs/components/date-picker/date-picker-panel.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  var template = '\n<cu-calendar-view min-date="$ctrl.minDate" max-date="$ctrl.maxDate" visible-date="$ctrl.visibleDate">\n    <cu-calendar-day-custom \n            class="cu-calendar-square"\n            ng-click="$ctrl.onDayClicked($cuCalendarDay)"\n            ng-class="{ \'cu-calendar-day-selected-end\': $ctrl.isDateSelected($cuCalendarDay.date) }"\n    >\n        {{ $cuCalendarDay.display }}\n    </cu-calendar-day-custom>\n</cu-calendar-view>\n  ';

  angular.module('unison').component('cuDatePickerPanel', {
    bindings: {
      value: '<',
      timeZone: '@',
      onChange: '&',
      minDate: '<?',
      maxDate: '<?'
    },
    require: {
      popoverCtrl: '^?cuPopover'
    },
    template: template,
    controller: ['$filter', 'cuDateLiteService', function DateRangePicker($filter, DLS) {
      var _this = this;

      this.$onInit = function () {
        _this.today = new Date();
        _this.visibleDate = _this.value ? new Date(_this.value) : DLS.today();
      };

      this.isDateSelected = function (date) {
        return date && moment(date).format('YYYY MM DD') === moment.tz(_this.value, _this.timeZone).format('YYYY MM DD');
      };

      this.onDayClicked = function (day) {
        if (!day.disabled) {
          if (_this.popoverCtrl) {
            _this.popoverCtrl.opened = false;
          }

          var momentValue = moment.tz(_this.value || new Date(), _this.timeZone).year(day.date.getFullYear()).month(day.date.getMonth()).date(day.date.getDate());

          // Call onChange with a new date object that has the updated
          // date and the same time as the original date object.
          _this.onChange({
            $cuValue: momentValue.toDate()
          });
        }
      };
    }]
  });
})();

/***/ }),

/***/ "./src/angularjs/components/date-picker/date-picker.html":
/*!***************************************************************!*\
  !*** ./src/angularjs/components/date-picker/date-picker.html ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<cu-popover ng-disabled=\"$ctrl.disabled()\">\n    <cu-popover-target class=\"cu-d-block\">\n        <button class=\"cu-button-default\" ng-disabled=\"$ctrl.disabled()\" cu-button-popover-handle ct-date-picker-button>\n            <span ng-class=\"{ 'cu-text-ui-copy': !!$ctrl.getButtonText() }\"> {{ $ctrl.getButtonText() || 'Select a Date' }} </span>\n        </button>\n    </cu-popover-target>\n    <cu-popover-content>\n        <cu-date-picker-panel\n            value=\"$ctrl.value\"\n            time-zone=\"{{ $ctrl.timeZone }}\"\n            on-change=\"$ctrl.onChange({$cuValue: $cuValue})\"\n            min-date=\"$ctrl.minDate\"\n            max-date=\"$ctrl.maxDate\"\n        ></cu-date-picker-panel>\n    </cu-popover-content>\n</cu-popover>\n";

/***/ }),

/***/ "./src/angularjs/components/date-picker/date-picker.js":
/*!*************************************************************!*\
  !*** ./src/angularjs/components/date-picker/date-picker.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datePicker = __webpack_require__(/*! ./date-picker.html */ "./src/angularjs/components/date-picker/date-picker.html");

var _datePicker2 = _interopRequireDefault(_datePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  angular.module('unison').component('cuDatePicker', {
    template: _datePicker2.default,
    bindings: {
      onChange: '&',
      value: '<',
      timeZone: '@',
      minDate: '<?',
      maxDate: '<?',
      disabled: '&ngDisabled'
    },
    controller: function controller() {
      var _this = this;

      this.getButtonText = function () {
        return _this.value ? moment.tz(_this.value, _this.timeZone).format('MMMM D, YYYY') : '';
      };
    }
  });
})(); //
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/***/ }),

/***/ "./src/angularjs/components/date-range-picker/date-range-picker-footnote.js":
/*!**********************************************************************************!*\
  !*** ./src/angularjs/components/date-range-picker/date-range-picker-footnote.js ***!
  \**********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  angular.module('unison').component('cuDateRangePickerFootnote', {
    template: '<ng-transclude></ng-transclude>',
    bindings: {
      onAliasSelected: '&'
    },
    transclude: true,
    require: {
      panelCtrl: '^^cuDateRangePickerPanel'
    },
    controller: function controller() {
      var _this = this;

      this.$onInit = function () {
        _this.panelCtrl.registerFootnote(_this);
      };
    }
  });
})();

/***/ }),

/***/ "./src/angularjs/components/date-range-picker/date-range-picker-panel.html":
/*!*********************************************************************************!*\
  !*** ./src/angularjs/components/date-range-picker/date-range-picker-panel.html ***!
  \*********************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<div class=\"cu-d-flex cu-text-left\">\n    <cu-calendar-view\n            visible-date=\"$ctrl.visibleDate\"\n            num-months-to-show=\"2\"\n            min-date=\"$ctrl.minDate\"\n            max-date=\"$ctrl.maxDate\"\n            absolute-min-date=\"$ctrl.absoluteMinDate\"\n            absolute-max-date=\"$ctrl.absoluteMaxDate\"\n    >\n        <cu-calendar-day-custom\n            ng-class=\"$ctrl.getClassesForDate($cuCalendarDay.date)\"\n            ng-click=\"$ctrl.onDayClicked($cuCalendarDay)\"\n            ng-mouseenter=\"$ctrl.onDayMouseenter($cuCalendarDay)\"\n            ng-mouseleave=\"$ctrl.onDayMouseleave($cuCalendarDay)\"\n            class=\"cu-text-center\"\n        >{{ $cuCalendarDay.display }}</cu-calendar-day-custom>\n    </cu-calendar-view>\n\n    <div class=\"cu-p-3 cu-pr-4\" style=\"border-left: 1px solid #dbdee0;\" ng-if=\"$ctrl.normalizedAliases.length\">\n        <div ng-repeat=\"alias in $ctrl.normalizedAliases\">\n            <button\n                    ng-click=\"$ctrl.selectedAlias = alias.name\"\n                    ng-class=\"{ 'cu-button-flat-primary': alias.name === $ctrl.selectedAlias }\"\n                    class=\"cu-button-flat cu-text-left cu-w-100\"\n                    tabindex=\"-1\"\n                    ct-date-range-picker-alias=\"{{ alias.name }}\"\n            >{{ alias.display }}</button>\n        </div>\n\n        <div\n                class=\"cu-d-flex cu-pt-2 cu-pl-3\"\n                cu-visible=\"$ctrl.selectedAlias === 'custom'\"\n                ng-style=\"{ height: $ctrl.selectedAlias === 'custom' ? '' : '1px' }\"\n        >\n            <label class=\"cu-pr-2 cu-pb-2 cu-d-flex cu-flex-column\">\n                <span class=\"cu-pb-1\">Start Date</span>\n                <input\n                        type=\"text\"\n                        placeholder=\"mm/dd/yy\"\n                        class=\"cu-form-control cu-drpp-input\"\n                        ng-class=\"{ 'cu-input-error': !$ctrl.isCustomStartStringValid() }\"\n                        ng-model=\"$ctrl.customStartString\"\n                        ng-focus=\"$ctrl.onCustomStartFocus()\"\n                        cu-focusout=\"$ctrl.customStartHasFocus = false\"\n                        ng-keydown=\"$ctrl.onCustomStartKeydown($event)\"\n                        cu-date-restricted-input\n                        ct-date-range-picker-custom-start\n                >\n            </label>\n            <label class=\"cu-pl-2 cu-pb-2 cu-d-flex cu-flex-column\">\n                <span class=\"cu-pb-1\">End Date</span>\n                <input\n                        type=\"text\"\n                        placeholder=\"mm/dd/yy\"\n                        class=\"cu-form-control cu-drpp-input\"\n                        ng-class=\"{ 'cu-input-error': !$ctrl.isCustomEndStringValid() }\"\n                        ng-model=\"$ctrl.customEndString\"\n                        ng-focus=\"$ctrl.onCustomEndFocus()\"\n                        cu-focusout=\"$ctrl.customEndHasFocus = false\"\n                        ng-keydown=\"$ctrl.onCustomEndKeydown($event)\"\n                        cu-date-restricted-input\n                        ct-date-range-picker-custom-end\n                >\n            </label>\n        </div>\n    </div>\n</div>\n\n<div class=\"cu-d-flex cu-p-4 cu-justify-content-between cu-align-items-center\" style=\"border-top: 1px solid #dbdee0\">\n    <div ng-transclude=\"footnote\" class=\"cu-text-caption\"></div>\n\n    <div>\n        <button\n            class=\"cu-button-flat\"\n            cu-popover-click-close\n            ct-date-range-picker-cancel\n        >Cancel</button>\n        <button\n            class=\"cu-button-primary\"\n            ng-disabled=\"!$ctrl.isCustomStartStringValid() || !$ctrl.isCustomEndStringValid() || $ctrl.pinnedDate\"\n            ng-click=\"$ctrl.onSetDate()\"\n            ct-date-range-picker-set-date\n        >Set Date</button>\n    </div>\n</div>\n";

/***/ }),

/***/ "./src/angularjs/components/date-range-picker/date-range-picker-panel.js":
/*!*******************************************************************************!*\
  !*** ./src/angularjs/components/date-range-picker/date-range-picker-panel.js ***!
  \*******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _dateRangePickerPanel = __webpack_require__(/*! ./date-range-picker-panel.html */ "./src/angularjs/components/date-range-picker/date-range-picker-panel.html");

var _dateRangePickerPanel2 = _interopRequireDefault(_dateRangePickerPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var CUSTOM_ALIAS_NAME = 'custom';
  var ALL_TIME_ALIAS_NAME = 'allTime';

  angular.module('unison').component('cuDateRangePickerPanel', {
    template: _dateRangePickerPanel2.default,
    bindings: {
      inputValue: '<',
      onChange: '&',
      aliases: '<?',
      minDate: '<?',
      maxDate: '<?',
      maxDateRange: '<?'
    },
    require: {
      popoverCtrl: '^?cuPopover'
    },
    transclude: {
      footnote: '?cuDateRangePickerPanelFootnote'
    },
    controller: ['$scope', 'cuDateLiteService', function DateRangePickerPanel($scope, DLS) {
      var _this = this;

      this.$onInit = function () {
        _this.absoluteMinDate = _this.minDate || DLS.genesis;
        var absoluteMinDateMs = _this.absoluteMinDate.getTime();

        _this.absoluteMaxDate = _this.maxDate || DLS.today();
        var absoluteMaxDateMs = _this.absoluteMaxDate.getTime();

        _this.dateRangeMs = DLS.msPerDay * ((_this.maxDateRange || 1) - 1);

        _this.minDate = _this.absoluteMinDate;
        _this.maxDate = _this.absoluteMaxDate;
        _this.visibleDate = _this.maxDate;

        if (_this.aliases) {
          _this.normalizedAliases = angular.copy(_this.aliases);

          for (var i = 0; i < _this.normalizedAliases.length; i += 1) {
            var alias = _this.normalizedAliases[i];

            if (typeof alias === 'string') {
              if (DLS.ALIASES[alias]) {
                _this.normalizedAliases[i] = DLS.ALIASES[alias];
              } else {
                _this.normalizedAliases.splice(i, 1);
                i -= 1;
              }
            }
          }
        } else {
          _this.normalizedAliases = [DLS.ALIASES.last7Days, DLS.ALIASES.last30Days, DLS.ALIASES.last3Months, DLS.ALIASES.allTime, DLS.ALIASES.custom];
        }

        _this.aliasMap = _this.normalizedAliases.reduce(function (aliasMap, alias) {
          /* eslint no-param-reassign: off */
          aliasMap[alias.name] = alias;
          return aliasMap;
        }, {});

        _this.footnoteCtrl = null;

        if (_this.popoverCtrl) {
          _this.popoverCtrl.registerCloseCallback(_this.onPopoverClose);
        }

        $scope.$watch('$ctrl.inputValue', function () {
          _this.selectedAlias = _this.inputValue.alias;

          if (_this.selectedAlias === CUSTOM_ALIAS_NAME) {
            _this.startDate = _this.inputValue.startDate;
            _this.endDate = _this.inputValue.endDate;
          }
        });

        $scope.$watch('$ctrl.startDate', function () {
          if (_this.startDate && !_this.customStartHasFocus) {
            _this.customStartString = DLS.dateToString(_this.startDate);

            /*
             * This is the main code that controls the UI for the date range. If the date range
             * exists, set the min and max date dynamically, respecting the absolute min and max
             * date boundaries. By setting min date and max date in this way, the appropriate
             * day squares are disabled, preventing the user from selecting those days.
             */
            if (_this.dateRangeMs > 0) {
              var startTimeMs = _this.startDate.getTime();
              var minDateMs = Math.max(absoluteMinDateMs, startTimeMs - _this.dateRangeMs);
              var maxDateMs = Math.min(absoluteMaxDateMs, startTimeMs + _this.dateRangeMs);

              _this.minDate = DLS.createDateLite(minDateMs);
              _this.maxDate = DLS.createDateLite(maxDateMs);
            }
          }
        });

        $scope.$watch('$ctrl.endDate', function () {
          if (_this.endDate && !_this.customEndHasFocus) {
            _this.customEndString = DLS.dateToString(_this.endDate);

            /*
             * End date is always assigned after startDate is assigned, meaning the date range
             * is fully selected and we can lift the temporary min/max date restrictions and show
             * the full calendar again.
             */
            _this.minDate = _this.absoluteMinDate;
            _this.maxDate = _this.absoluteMaxDate;
          }
        });

        $scope.$watch('$ctrl.selectedAlias', function () {
          if (!_this.isCustomAliasSelected() && _this.aliasMap[_this.selectedAlias]) {
            _this.startDate = _this.aliasMap[_this.selectedAlias].start();
            _this.endDate = _this.aliasMap[_this.selectedAlias].end();

            delete _this.pinnedDate;
          }

          // We might not have an end date if we're on a preset alias but
          // have just switched to custom by clicking on the calendar.
          if (_this.endDate) {
            _this.snapDateRight(_this.endDate);
            _this.snapToEndDate();
          }

          /*
           * If we have max date range, "All Time"'s start date is max date minus the date range
           * else, "All Time"'s start date is the min date
           */
          if (_this.selectedAlias === ALL_TIME_ALIAS_NAME) {
            // +1 since the min date isn't selectable
            var allTimeStartDate = moment(_this.absoluteMinDate).add(1, 'd');

            _this.startDate = allTimeStartDate.startOf('day').toDate();
          }

          if (_this.footnoteCtrl) {
            _this.footnoteCtrl.onAliasSelected({
              $cuSelectedAlias: _this.selectedAlias
            });
          }
        });

        $scope.$watch('$ctrl.pinnedDate', function (pinnedDate) {
          if (pinnedDate || !_this.startDate || !_this.endDate) {
            _this.customStartString = '';
            _this.customEndString = '';
          } else {
            _this.customStartString = DLS.dateToString(_this.startDate);
            _this.customEndString = DLS.dateToString(_this.endDate);
          }
        });

        $scope.$watch('$ctrl.customStartString', function () {
          if (_this.customStartHasFocus && _this.isCustomStartStringValid(_this.customStartString)) {
            _this.startDate = DLS.createDateLite(_this.customStartString);
            _this.snapToStartDate();
          }
        });

        $scope.$watch('$ctrl.customEndString', function () {
          if (_this.customEndHasFocus && _this.isCustomEndStringValid(_this.customEndString)) {
            _this.endDate = DLS.createDateLite(_this.customEndString);
            _this.snapToEndDate();
          }
        });
      };

      this.$onDestroy = function () {
        if (_this.popoverCtrl) {
          _this.popoverCtrl.deregisterCloseCallback(_this.onPopoverClose);
        }
      };

      this.onSetDate = function () {
        _this.onChange({
          cuValue: {
            alias: _this.selectedAlias,
            startDate: _this.startDate,
            endDate: _this.endDate
          }
        });

        if (_this.popoverCtrl) {
          _this.popoverCtrl.opened = false;
        }
      };

      this.onPopoverClose = function () {
        delete _this.pinnedDate;

        _this.selectedAlias = _this.inputValue.alias;
      };

      this.onDayClicked = function (day) {
        if (day.disabled || !day.date) {
          return;
        }

        if (_this.isCustomAliasSelected()) {
          if (_this.pinnedDate) {
            var startDate = day.date >= _this.pinnedDate ? _this.pinnedDate : day.date;
            var endDate = day.date < _this.pinnedDate ? _this.pinnedDate : day.date;

            // Clone the dates so we can modify this.startDate or this.endDate
            // without also modifying the dates in the calendar.
            _this.startDate = DLS.createDateLite(startDate);
            _this.endDate = DLS.createDateLite(endDate);

            delete _this.pinnedDate;
          } else {
            _this.pinnedDate = day.date;
            _this.startDate = _this.pinnedDate;
            delete _this.endDate;
          }
        } else {
          _this.selectedAlias = CUSTOM_ALIAS_NAME;
          _this.pinnedDate = day.date;
          _this.startDate = day.date;
          delete _this.endDate;
        }
      };

      this.onCustomStartKeydown = function (event) {
        if (event.keyCode === 40 && _this.startDate < _this.endDate) {
          _this.startDate.setDate(_this.startDate.getDate() + 1);
          _this.startDate = DLS.createDateLite(_this.startDate);
          _this.customStartString = DLS.dateToString(_this.startDate);
          _this.snapToStartDate();
        } else if (event.keyCode === 38 && _this.startDate > DLS.genesis) {
          _this.startDate.setDate(_this.startDate.getDate() - 1);
          _this.startDate = DLS.createDateLite(_this.startDate);
          _this.customStartString = DLS.dateToString(_this.startDate);
          _this.snapToStartDate();
        }
      };

      this.onCustomEndKeydown = function (event) {
        if (event.keyCode === 40 && _this.endDate < DLS.today()) {
          _this.endDate.setDate(_this.endDate.getDate() + 1);
          _this.endDate = DLS.createDateLite(_this.endDate);
          _this.customEndString = DLS.dateToString(_this.endDate);
          _this.snapToEndDate();
        } else if (event.keyCode === 38 && _this.endDate > _this.startDate) {
          _this.endDate.setDate(_this.endDate.getDate() - 1);
          _this.endDate = DLS.createDateLite(_this.endDate);
          _this.customEndString = DLS.dateToString(_this.endDate);
          _this.snapToEndDate();
        }
      };

      this.onCustomStartFocus = function () {
        _this.customStartHasFocus = true;
        delete _this.pinnedDate;
        _this.snapToStartDate(_this.startDate);
      };

      this.onCustomEndFocus = function () {
        _this.customEndHasFocus = true;
        delete _this.pinnedDate;
        _this.snapToEndDate(_this.endDate);
      };

      this.onDayMouseenter = function (day) {
        if (!day.disabled) {
          _this.hoveredDate = day.date;
        }
      };

      this.onDayMouseleave = function (day) {
        if (!day.disabled) {
          delete _this.hoveredDate;
        }
      };

      this.isCustomAliasSelected = function () {
        return _this.selectedAlias === CUSTOM_ALIAS_NAME;
      };

      this.isCustomStartStringValid = function () {
        if (_this.pinnedDate) {
          return true;
        }

        if (!DLS.isDateStringValid(_this.customStartString)) {
          return false;
        }

        var start = DLS.createDateLite(_this.customStartString);
        var end = DLS.createDateLite(_this.customEndString);
        var isEndStringValid = DLS.isDateStringValid(_this.customEndString);
        var isEndBeforeStart = end < start;
        var isStartBeforeMinDate = start < _this.absoluteMinDate;

        if (isEndStringValid && (isEndBeforeStart || isStartBeforeMinDate)) {
          return false;
        } else if (isEndStringValid && _this.dateRangeMs > 0 && end.getTime() - start.getTime() > _this.dateRangeMs) {
          return false;
        }

        return true;
      };

      this.isCustomEndStringValid = function () {
        if (_this.pinnedDate) {
          return true;
        }

        if (!DLS.isDateStringValid(_this.customEndString)) {
          return false;
        }

        var start = DLS.createDateLite(_this.customStartString);
        var end = DLS.createDateLite(_this.customEndString);
        var isStartStringValid = DLS.isDateStringValid(_this.customStartString);
        var isEndInFuture = end > DLS.today();
        var isEndBeforeStart = end < start;
        var isEndAfterMaxDate = end > _this.absoluteMaxDate;

        if (isEndInFuture) {
          return false;
        } else if (isStartStringValid && (isEndBeforeStart || isEndAfterMaxDate)) {
          return false;
        } else if (isStartStringValid && _this.dateRangeMs > 0 && end.getTime() - start.getTime() > _this.dateRangeMs) {
          return false;
        }

        return true;
      };

      this.getClassesForDate = function (date) {
        var classes = '';

        if (_this.pinnedDate && _this.hoveredDate) {
          // One date has been selected and we're selecting the second date
          if (+date === +_this.pinnedDate) {
            classes += 'cu-calendar-day-selected-end ';
          }

          if (DLS.contains(date, _this.pinnedDate, _this.hoveredDate) || DLS.contains(date, _this.hoveredDate, _this.pinnedDate)) {
            classes += 'cu-calendar-day-suggestion ';
          }
        } else {
          // No range edits are taking place or an edit
          // is taking place but nothing new is selected
          if (+date === +_this.startDate || +date === +_this.endDate) {
            classes += 'cu-calendar-day-selected-end ';
          }

          if (date > _this.startDate && date < _this.endDate) {
            classes += 'cu-calendar-day-selected ';
          }
        }

        return classes;
      };

      this.snapToStartDate = function () {
        var startMonth = DLS.getAbsoluteMonth(_this.startDate);
        var endMonth = DLS.getAbsoluteMonth(_this.endDate || _this.startDate);
        var leftDisplayMonth = _this.getLeftVisibleMonth();
        var rightDisplayMonth = _this.getRightVisibleMonth();

        if (startMonth < leftDisplayMonth) {
          _this.snapDateLeft(_this.startDate);
        } else if (!rightDisplayMonth || startMonth > rightDisplayMonth) {
          _this.snapDateRight(_this.startDate);
        } else if (startMonth === rightDisplayMonth && startMonth !== endMonth) {
          _this.snapDateLeft(_this.startDate);
        }
      };

      this.snapToEndDate = function () {
        var startMonth = DLS.getAbsoluteMonth(_this.startDate);
        var endMonth = DLS.getAbsoluteMonth(_this.endDate);
        var leftDisplayMonth = _this.getLeftVisibleMonth();
        var rightDisplayMonth = _this.getRightVisibleMonth();

        if (endMonth < leftDisplayMonth) {
          _this.snapDateLeft(_this.endDate);
        } else if (!rightDisplayMonth || endMonth > rightDisplayMonth) {
          _this.snapDateRight(_this.endDate);
        } else if (endMonth === leftDisplayMonth && startMonth !== endMonth) {
          _this.snapDateRight(_this.endDate);
        }
      };

      this.snapDateLeft = function (date) {
        _this.visibleDate = date;
      };

      this.snapDateRight = function (date) {
        var visibleDate = DLS.createDateLite(date);
        visibleDate.setDate(1);
        visibleDate.setMonth(visibleDate.getMonth() - 1);
        _this.visibleDate = visibleDate;
      };

      this.registerFootnote = function (footnoteCtrl) {
        _this.footnoteCtrl = footnoteCtrl;
      };

      this.getLeftVisibleMonth = function () {
        return DLS.getAbsoluteMonth(_this.visibleDate);
      };

      this.getRightVisibleMonth = function () {
        return _this.getLeftVisibleMonth() + 1;
      };
    }]
  });
})(); //
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/***/ }),

/***/ "./src/angularjs/components/date-range-picker/date-range-picker.js":
/*!*************************************************************************!*\
  !*** ./src/angularjs/components/date-range-picker/date-range-picker.js ***!
  \*************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  angular.module('unison').component('cuDateRangePicker', {
    template: '\n      <cu-popover \n        on-close="$ctrl.onPopoverClose()"\n        ng-disabled="$ctrl.disabled()"\n        positioning-strategy="$ctrl.positioningStrategy"\n        append-to-body="$ctrl.appendToBody"\n      >\n        <cu-popover-target class="cu-d-inline-block">\n          <button \n            tabindex="-1" \n            class="cu-button-default cu-pr-2"\n            ng-disabled="$ctrl.disabled()" \n            ng-style="{ width: $ctrl.value.alias === \'custom\' ? \'184px\' : \'144px\' }" \n            ct-date-range-picker-button\n          >\n            <div class="cu-d-flex cu-flex-1 cu-justify-content-between cu-align-items-center">\n              <span>{{ $ctrl.buttonText() }}</span>\n              <cu-icon name="chevron-down"></cu-icon>\n            </div>\n          </button>\n        </cu-popover-target>\n        <cu-popover-content>\n          <cu-date-range-picker-panel \n            input-value="$ctrl.value"\n            on-change="$ctrl.onDateChange(cuValue)"\n            aliases="$ctrl.aliases"\n            min-date="$ctrl.minDate"\n            max-date="$ctrl.maxDate"\n            max-date-range="$ctrl.maxDateRange"\n          >\n            <cu-date-range-picker-panel-footnote ng-transclude="footnote"></cu-date-range-picker-panel-footnote>\n          </cu-date-range-picker-panel>\n        </cu-popover-content>\n      </cu-popover>\n    ',
    bindings: {
      onChange: '&',
      value: '=?',
      aliases: '<?',
      minDate: '<?',
      maxDate: '<?',
      maxDateRange: '<?',
      disabled: '&ngDisabled',
      // popover properties
      appendToBody: '<?',
      positioningStrategy: '<?'
    },
    transclude: {
      footnote: '?cuDateRangePickerFootnote'
    },
    controller: ['cuDateLiteService', function DateRangePicker(DLS) {
      var _this = this;

      this.$onInit = function () {
        _this.value = _this.value || { alias: DLS.ALIASES.last7Days.name };
      };

      this.onDateChange = function (date) {
        _this.value = date;
        _this.onChange({ cuValue: date });
      };

      this.buttonText = function () {
        if (!DLS.ALIASES[_this.value.alias] || _this.value.alias === DLS.ALIASES.custom.name) {
          return DLS.dateToString(_this.value.startDate) + ' - ' + DLS.dateToString(_this.value.endDate);
        }

        return DLS.ALIASES[_this.value.alias].display;
      };
    }]
  });
})();

/***/ }),

/***/ "./src/angularjs/components/date-range-picker/date-restricted-input.js":
/*!*****************************************************************************!*\
  !*** ./src/angularjs/components/date-range-picker/date-restricted-input.js ***!
  \*****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  angular.module('unison').directive('cuDateRestrictedInput', function () {
    return {
      restrict: 'A',
      link: function link(scope, element) {
        element.on('keypress', function (event) {
          var input = event.target;
          var value = input.value;
          var cursorAt = input.selectionStart;

          // If the browser sucks and doesn't have event.key,
          // then we don't validate anything, because screw that
          var isKeyValid = !event.key || event.key >= '0' && event.key <= '9' || event.key === '/' ||
          // Allow arrow keys, delete, backspace, home, end, etc...
          event.key.length > 1;

          var skipChar = event.key === '/' && value.charAt(cursorAt) === '/';

          if (!isKeyValid) {
            event.stopImmediatePropagation();
            event.preventDefault();
          }

          if (skipChar) {
            input.setSelectionRange(cursorAt + 1, cursorAt + 1);
            event.preventDefault();
          }
        });
      }
    };
  });
})();

/***/ }),

/***/ "./src/angularjs/components/gravatar/gravatar.js":
/*!*******************************************************!*\
  !*** ./src/angularjs/components/gravatar/gravatar.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  var defaultGravatarSize = 1;
  var defaultGravatarUrl = encodeURIComponent('https://www.gravatar.com/avatar?s=' + defaultGravatarSize);

  var template = '\n<cu-avatar>\n    <img \n        ng-show="$ctrl.showAvatar"\n        class="cu-h-100 cu-w-100" \n        ng-src="https://secure.gravatar.com/avatar/{{ $ctrl.hash }}?d=' + defaultGravatarUrl + '" \n        cu-load="$ctrl.imageLoaded($event)"\n        cu-error="$ctrl.showInitials = true"\n    />\n    <cu-gravatar-initials\n        ng-show="$ctrl.showInitials" \n        class="cu-d-flex cu-h-100 cu-w-100 cu-align-items-center cu-justify-content-center cu-text-meta-tag"\n    >{{ $ctrl.initials.slice(0, 2) }}</cu-gravatar-initials>\n</cu-avatar>\n  ';

  angular.module('unison').component('cuGravatar', {
    bindings: {
      hash: '@',
      initials: '@'
    },
    template: template,
    controller: function controller() {
      var _this = this;

      this.$onInit = function () {
        _this.showAvatar = false;
        _this.showInitials = false;
      };

      this.imageLoaded = function (event) {
        if (event.target.naturalWidth === defaultGravatarSize) {
          _this.showInitials = true;
        } else {
          _this.showAvatar = true;
        }
      };
    }
  });
})();

/***/ }),

/***/ "./src/angularjs/components/icon/icon.js":
/*!***********************************************!*\
  !*** ./src/angularjs/components/icon/icon.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__(/*! ../../../../icons/index.ts */ "./icons/index.ts");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var unison = angular.module('unison');

  // Generic directive
  // e.g. <cu-icon name="error">
  unison.directive('cuIcon', function () {
    return {
      restrict: 'E',
      scope: {
        name: '@'
      },
      link: function link(scope, element) {
        element.addClass('cu-icon-container');
        scope.$watch('name', function (newVal, oldVal) {
          var svg = _index2.default[newVal];
          element.html(svg);
          element.removeClass('cu-icon-' + oldVal);
          element.addClass('cu-icon-' + newVal);
        });
      }
    };
  });
})(); //
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/***/ }),

/***/ "./src/angularjs/components/menu/menu-item.js":
/*!****************************************************!*\
  !*** ./src/angularjs/components/menu/menu-item.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  var unison = angular.module('unison');

  unison.component('cuMenuItem', {
    transclude: true,
    bindings: {
      id: '<itemId',
      hasSubmenu: '<?'
    },
    require: {
      itemsCtrl: '^^cuMenuItems'
    },
    template: '\n      <cu-menu-item-inner\n          class="cu-d-block"\n          ng-class="{ \'cu-menu-item-active\': $ctrl.isItemSelected() }"\n          ng-mouseover="$ctrl.onMouseover()"\n          ng-mouseleave="$ctrl.onMouseleave()"\n        >\n        <ng-transclude class="cu-menu-item-transclude-slot"></ng-transclude>\n      </cu-menu-item-inner>\n    ',
    controller: ['$element', '$log', '$location', '$timeout', function MenuItemCtrl($element, $log, $location, $timeout) {
      var _this = this;

      this.$onInit = function () {
        if (_this.id !== undefined) {
          _this.itemsCtrl.registerItemCtrl(_this);
        } else {
          $log.error('cu-menu-item and cu-menu-submenu-item must have a item-id attribute');
        }
      };

      this.$onDestroy = function () {
        _this.itemsCtrl.deregisterItemCtrl(_this);
      };

      this.isItemSelected = function () {
        return _this.itemsCtrl.getSelectedItemId() === _this.id;
      };

      this.onMouseover = function () {
        if (_this.itemsCtrl.preventMouseoverActivation) {
          _this.itemsCtrl.preventMouseoverActivation = false;
          return;
        }

        _this.itemsCtrl.selectItemCtrl(_this);
      };

      this.onMouseleave = function () {
        if (!_this.itemsCtrl.preventMouseoverActivation) {
          _this.itemsCtrl.deselectSelectedItem();
        }
      };

      this.triggerClick = function () {
        $timeout(function () {
          $element.children()[0].click();
        }, 0, false);
      };

      this.getText = function () {
        return $element.text().trim();
      };
    }]
  });
})();

/***/ }),

/***/ "./src/angularjs/components/menu/menu-items.js":
/*!*****************************************************!*\
  !*** ./src/angularjs/components/menu/menu-items.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  var unison = angular.module('unison');

  unison.component('cuMenuItems', {
    transclude: true,
    bindings: {
      typeaheadValues: '<?',
      sortedItemIds: '<?'
    },
    require: {
      submenuItemCtrl: '?^^cuMenuSubmenuItem',
      popoverCtrl: '?^^cuPopover'
    },
    template: '<ng-transclude></ng-transclude>',
    controller: ['$element', '$log', '$scope', '$timeout', function MenuItemsCtrl($element, $log, $scope, $timeout) {
      var _this = this;

      this.$onInit = function () {
        _this.itemIdCache = {}; // keep to enforce uniqueness
        _this.itemCtrls = [];
        _this.selectedItemCtrlIndex = null;
        _this.typeaheadString = '';
        _this.typeaheadTimeout = null;
        _this.preventMouseoverActivation = false;

        if (_this.sortedItemIds) {
          _this.itemIndexById = _this.sortedItemIds.reduce(function (itemIndexById, itemId, index) {
            itemIndexById[itemId] = index;
            return itemIndexById;
          }, {});
        }

        if (_this.popoverCtrl) {
          _this.popoverCtrl.registerCloseCallback(_this.deselectSelectedItem);
        }

        $element.attr('tabindex', '-1').on('keydown', function (event) {
          $scope.$apply(function () {
            return _this.onKeydown(event);
          });
        });
      };

      this.$postLink = function () {
        if (_this.submenuItemCtrl) {
          _this.focus();
        }
      };

      this.$onDestroy = function () {
        if (_this.popoverCtrl) {
          _this.popoverCtrl.deregisterCloseCallback(_this.deselectSelectedItem);
        }
      };

      this.numItems = function () {
        return _this.typeaheadValues ? _this.typeaheadValues.length : _this.itemCtrls.length;
      };

      this.registerItemCtrl = function (itemCtrl) {
        if (_this.itemIdCache[itemCtrl.id] !== undefined) {
          $log.error('cu-menu-item and cu-menu-submenu-item ids must be unique. ' + itemCtrl.id + ' has already been registered.');
          return;
        }

        _this.itemIdCache[itemCtrl.id] = true;

        var index = _this.sortedItemIds ? _this.itemIndexById[itemCtrl.id] : _this.itemCtrls.length;

        _this.itemCtrls[index] = itemCtrl;
      };

      this.deregisterItemCtrl = function (itemCtrl) {
        delete _this.itemIdCache[itemCtrl.id];

        if (_this.getSelectedItemId() === itemCtrl.id) {
          _this.selectedItemCtrlIndex = null;
        }

        var index = _this.getItemCtrlIndex(itemCtrl);

        if (_this.sortedItemIds) {
          delete _this.itemCtrls[index];
        } else {
          _this.itemCtrls.splice(index, 1);
        }
      };

      this.selectItemCtrl = function (itemCtrl) {
        _this.selectedItemCtrlIndex = _this.getItemCtrlIndex(itemCtrl);
      };

      this.selectItemCtrlByIndex = function (itemCtrlIndex) {
        _this.selectedItemCtrlIndex = itemCtrlIndex;
        _this.scrollToItemPosition(itemCtrlIndex);
      };

      this.deselectSelectedItem = function () {
        _this.selectedItemCtrlIndex = null;
      };

      this.getSelectedItemId = function () {
        return _this.itemCtrls[_this.selectedItemCtrlIndex] ? _this.itemCtrls[_this.selectedItemCtrlIndex].id : null;
      };

      this.getItemCtrlIndex = function (itemCtrl) {
        if (_this.sortedItemIds) {
          return _this.itemIndexById[itemCtrl.id];
        }

        for (var i = 0; i < _this.itemCtrls.length; i += 1) {
          if (_this.itemCtrls[i] === itemCtrl) {
            return i;
          }
        }

        return null;
      };

      this.getSelectedItemCtrl = function () {
        return _this.itemCtrls[_this.selectedItemCtrlIndex];
      };

      this.onKeydown = function (event) {
        var selectedItemCtrl = _this.getSelectedItemCtrl();
        var triggerItemClick = event.keyCode === 13 || // Enter
        event.keyCode === 32 && !_this.typeaheadTimeout || // Space
        event.keyCode === 39 && selectedItemCtrl && selectedItemCtrl.hasSubmenu; // Right

        if (event.keyCode === 40) {
          // Down
          var indexToSelect = _this.selectedItemCtrlIndex == null ? 0 : Math.min(_this.numItems() - 1, _this.selectedItemCtrlIndex + 1);
          _this.selectItemCtrlByIndex(indexToSelect);
          event.preventDefault();
        } else if (event.keyCode === 38) {
          // Up
          var _indexToSelect = _this.selectedItemCtrlIndex == null ? _this.numItems() - 1 : Math.max(0, _this.selectedItemCtrlIndex - 1);
          _this.selectItemCtrlByIndex(_indexToSelect);
          event.preventDefault();
        } else if (event.keyCode === 37 && _this.submenuItemCtrl) {
          // Left
          _this.submenuItemCtrl.back();
        } else if (selectedItemCtrl && triggerItemClick) {
          selectedItemCtrl.triggerClick();
          event.preventDefault();
        } else {
          if (event.keyCode === 32) {
            // Space
            event.preventDefault(); // Prevent scrolling
          }

          if (_this.typeaheadTimeout) {
            $timeout.cancel(_this.typeaheadTimeout);
            _this.typeaheadTimeout = null;
          }

          _this.typeaheadString += String.fromCharCode(event.keyCode).toLowerCase();
          _this.scrollToTypeahead();

          _this.typeaheadTimeout = $timeout(function () {
            _this.typeaheadString = '';
            _this.typeaheadTimeout = null;
          }, 1000);
        }

        event.stopPropagation();
      };

      this.scrollToTypeahead = function () {
        var typeaheadValues = _this.typeaheadValues || _this.itemCtrls.map(function (itemCtrl) {
          return itemCtrl.getText();
        });

        for (var i = 0; i < typeaheadValues.length; i += 1) {
          if (typeaheadValues[i].toLowerCase().indexOf(_this.typeaheadString) === 0) {
            _this.selectItemCtrlByIndex(i);
            break;
          }
        }
      };

      this.scrollToItemPosition = function (index) {
        var itemHeight = 37;
        var itemTop = itemHeight * index;
        var itemBottom = itemHeight * (index + 1);
        var scrollTop = $element[0].scrollTop;
        var height = $element[0].clientHeight;

        if (itemTop < scrollTop) {
          _this.preventMouseoverActivation = true;
          /* eslint no-param-reassign: off */
          $element[0].scrollTop = itemTop;
        } else if (itemBottom > scrollTop + height) {
          _this.preventMouseoverActivation = true;
          /* eslint no-param-reassign: off */
          $element[0].scrollTop = itemTop - height + itemHeight;
        }
      };

      this.focus = function () {
        $element[0].focus();
      };
    }]
  });
})();

/***/ }),

/***/ "./src/angularjs/components/menu/menu-submenu-header.js":
/*!**************************************************************!*\
  !*** ./src/angularjs/components/menu/menu-submenu-header.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  var unison = angular.module('unison');

  unison.component('cuMenuSubmenuHeader', {
    transclude: true,
    require: {
      submenuCtrl: '^^cuMenuSubmenuItem'
    },
    template: '\n      <div class="cu-d-flex cu-align-items-center cu-justify-content-between cu-w-100 cu-mb-2">\n        <div ng-click="$ctrl.submenuCtrl.back()" class="cu-d-flex cu-align-items-center cu-p-2 cu-pl-3" style="flex: 1;" ct-menu-submenu-header-back>\n            <cu-icon name="chevron-right" class="cu-rot-180 cu-mr-2"></cu-icon>\n            <ng-transclude class="cu-text-ui-copy"></ng-tranclude>\n        </div>\n        <button ng-click="$ctrl.submenuCtrl.close()" class="cu-button-flat cu-button-icon cu-mr-2">\n          <cu-icon name="close" ct-menu-submenu-header-close></cu-icon>\n        </button>\n      </div>\n    '
  });
})();

/***/ }),

/***/ "./src/angularjs/components/menu/menu-submenu-item.js":
/*!************************************************************!*\
  !*** ./src/angularjs/components/menu/menu-submenu-item.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  var unison = angular.module('unison');

  unison.component('cuMenuSubmenuItem', {
    bindings: {
      id: '<itemId',
      onChange: '&?'
    },
    transclude: {
      submenu: 'cuMenu'
    },
    require: {
      menuItemsCtrl: '^^cuMenuItems',
      popoverCtrl: '?^^cuPopover'
    },
    template: '\n      <cu-menu-item item-id="$ctrl.id" icon="chevron-right" ng-click="$ctrl.showSubmenu()" has-submenu="true"> \n        <ng-transclude class="cu-menu-item-transclude-slot" style="flex: 1"></ng-transclude>\n        <cu-icon name="chevron-right" class="cu-d-flex cu-align-items-center cu-mr-3"></cu-icon>\n      </cu-menu-item>\n      <cu-menu-submenu ng-if="$ctrl.submenuNgIf" ng-class="$ctrl.ngAnimateClasses">\n        <div ng-transclude="submenu" class="cu-h-100"></div>\n      </cu-menu-submenu>\n    ',
    controller: ['$element', '$timeout', function MenuSubmenuItemCtrl($element, $timeout) {
      var _this = this;

      this.$onInit = function () {
        _this.submenuNgIf = false;
        if (_this.onChange) {
          _this.onChange({ $status: 'closed' });
        }
        _this.ngAnimateClasses = {
          'ng-enter': true
        };

        if (_this.popoverCtrl) {
          _this.popoverCtrl.registerCloseCallback(_this.back);
        }

        $element.on('transitionend', function (event) {
          if (angular.element(event.target).hasClass('ng-leave')) {
            if (_this.submenuNgIf) {
              _this.submenuNgIf = false;
              if (_this.onChange) {
                _this.onChange({ $status: 'closed' });
              }
              _this.menuItemsCtrl.focus();
              event.stopPropagation();
            }
          }
        });
      };

      this.$onDestroy = function () {
        if (_this.popoverCtrl) {
          _this.popoverCtrl.deregisterCloseCallback(_this.back);
        }
      };

      this.showSubmenu = function () {
        _this.submenuNgIf = true;
        if (_this.onChange) {
          _this.onChange({ $status: 'open' });
        }

        $timeout(function () {
          _this.ngAnimateClasses = {
            'ng-enter': true,
            'ng-enter-active': true
          };
        });
      };

      this.back = function () {
        _this.ngAnimateClasses = {
          'ng-leave': true,
          'ng-leave-active': true
        };
      };

      this.close = function () {
        if (_this.popoverCtrl) {
          _this.popoverCtrl.opened = false;
        }
      };
    }]
  });
})();

/***/ }),

/***/ "./src/angularjs/components/modal/modal.html":
/*!***************************************************!*\
  !*** ./src/angularjs/components/modal/modal.html ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"$ctrl.opened\" class=\"cu-modal-container\">\n    <div class=\"cu-sheet-low cu-d-flex cu-flex-column cu-pos-relative\">\n        <div class=\"cu-modal-header-container\">\n            <div ng-transclude=\"header\"></div>\n            <cu-icon\n                name=\"close\"\n                class=\"cu-modal-closer\"\n                ng-if=\"$ctrl.onCancel\"\n                ng-click=\"$ctrl.onCancel()\"\n                ct-modal-cancel-button\n            ></cu-icon>\n        </div>\n\n        <div ng-transclude=\"body\" class=\"cu-modal-body-container\"></div>\n        <div ng-transclude=\"footer\" class=\"cu-modal-footer-container\"></div>\n    </div>\n</div>\n";

/***/ }),

/***/ "./src/angularjs/components/modal/modal.js":
/*!*************************************************!*\
  !*** ./src/angularjs/components/modal/modal.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _modal = __webpack_require__(/*! ./modal.html */ "./src/angularjs/components/modal/modal.html");

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  angular.module('unison').component('cuModal', {
    transclude: {
      header: '?cuModalHeader',
      body: 'cuModalBody',
      footer: '?cuModalFooter'
    },
    bindings: {
      opened: '<',
      onCancel: '&?'
    },
    template: _modal2.default
  });
})(); //
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/***/ }),

/***/ "./src/angularjs/components/nav-tabs/nav-item.js":
/*!*******************************************************!*\
  !*** ./src/angularjs/components/nav-tabs/nav-item.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  angular.module('unison').component('cuNavItem', {
    controller: ['$element', function NavItemCtrl($element) {
      $element.addClass('cu-nav-item');
    }]
  });
})();

/***/ }),

/***/ "./src/angularjs/components/nav-tabs/nav-menu-item.html":
/*!**************************************************************!*\
  !*** ./src/angularjs/components/nav-tabs/nav-menu-item.html ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<div class=\"cu-nav-menu-item\">\n  <cu-popover\n    opened=\"$ctrl.opened\"\n    preload=\"true\"\n    on-open=\"$ctrl.onOpened()\"\n    on-close=\"$ctrl.onClosed()\"\n    positioning-strategy='$ctrl.positioningStrategy'\n    open-on-hover=\"::true\"\n    no-arrow=\"::true\"\n    ng-disabled=\"$ctrl.disabled()\">\n    <cu-popover-target>\n      <ng-transclude ng-transclude-slot=\"link\"></ng-transclude>\n    </cu-popover-target>\n    <cu-popover-content\n      class=\"cu-bs-3\"><ng-transclude ng-transclude-slot=\"content\"></ng-transclude></cu-popover-content>\n  </cu-popover>\n</div>\n";

/***/ }),

/***/ "./src/angularjs/components/nav-tabs/nav-menu-item.js":
/*!************************************************************!*\
  !*** ./src/angularjs/components/nav-tabs/nav-menu-item.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _navMenuItem = __webpack_require__(/*! ./nav-menu-item.html */ "./src/angularjs/components/nav-tabs/nav-menu-item.html");

var _navMenuItem2 = _interopRequireDefault(_navMenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  angular.module('unison').component('cuNavMenuItem', {
    require: {
      mainCtrl: '^cuNavTabs'
    },
    bindings: {
      onOpen: '&',
      onClose: '&',
      positioningStrategy: '<?',
      disabled: '&ngDisabled'
    },
    transclude: {
      link: 'cuNavItemLink',
      content: 'cuNavItemContent'
    },
    template: _navMenuItem2.default,
    controller: ['$element', function NavMenuItemCtrl($element) {
      var _this = this;

      $element.addClass('cu-nav-menu-item');

      this.$onInit = function () {
        _this.opened = false;
        _this.mainCtrl.registerTab(_this);
      };

      this.close = function () {
        _this.opened = false;
      };

      this.onOpened = function () {
        // Let the parent know we've opened, so it can close other tabs.
        _this.mainCtrl.onTabOpened(_this);
        _this.onOpen();
      };

      this.onClosed = function () {
        _this.onClose();
      };
    }]
  });
})(); //
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/***/ }),

/***/ "./src/angularjs/components/nav-tabs/nav-tabs-vertical.js":
/*!****************************************************************!*\
  !*** ./src/angularjs/components/nav-tabs/nav-tabs-vertical.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  angular.module('unison').component('cuNavTabsVertical', {
    controller: ['$element', function NavTabsCtrl($element) {
      $element.addClass('cu-nav-tabs-vertical');

      var tabs = [];

      this.registerTab = function (tabCtrl) {
        return tabs.push(tabCtrl);
      };

      this.onTabOpened = function (openedTab) {
        tabs.forEach(function (tab) {
          if (tab !== openedTab) {
            tab.close();
          }
        });
      };
    }]
  });
})();

/***/ }),

/***/ "./src/angularjs/components/nav-tabs/nav-tabs.js":
/*!*******************************************************!*\
  !*** ./src/angularjs/components/nav-tabs/nav-tabs.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  angular.module('unison').component('cuNavTabs', {
    controller: ['$element', function NavTabsCtrl($element) {
      $element.addClass('cu-nav-tabs-horizontal');

      var tabs = [];

      this.registerTab = function (tabCtrl) {
        return tabs.push(tabCtrl);
      };

      this.onTabOpened = function (openedTab) {
        tabs.forEach(function (tab) {
          if (tab !== openedTab) {
            tab.close();
          }
        });
      };
    }]
  });
})();

/***/ }),

/***/ "./src/angularjs/components/page-frame/page-frame.js":
/*!***********************************************************!*\
  !*** ./src/angularjs/components/page-frame/page-frame.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  var template = '\n<cu-page-frame-header-wrap ng-transclude="header"></cu-page-frame-header-wrap>\n\n<cu-page-frame-scroll-wrap>\n  <cu-page-frame-content-wrap>\n    <ng-transclude ng-transclude-slot="contentArea"></ng-transclude>\n    <ng-transclude ng-transclude-slot="content"></ng-transclude>\n  </cu-page-frame-content-wrap>    \n</cu-page-frame-scroll-wrap>\n';
  var unison = angular.module('unison');

  unison.component('cuPageFrameMain', {
    transclude: {
      header: '?cuPageFrameHeader',
      contentArea: '?cuPageFrameContentArea',
      content: '?cuPageFrameContent'
    },
    template: template
  });
})();

/***/ }),

/***/ "./src/angularjs/components/pagination-controls/pagination-controls.html":
/*!*******************************************************************************!*\
  !*** ./src/angularjs/components/pagination-controls/pagination-controls.html ***!
  \*******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<div class=\"cu-d-flex cu-pagination-controls\">\n    <button\n        class=\"cu-button-default cu-button-icon\"\n        ng-disabled=\"$ctrl.currentPage === 0 || $ctrl.disabled()\"\n        ng-click=\"$ctrl.callOnChange($ctrl.currentPage - 1)\"\n        ct-pagination-controls-prev\n    >\n        <cu-icon name=\"chevron-right\" class=\"cu-rot-180\"></cu-icon>\n    </button>\n\n    <button\n        class=\"cu-button-default\"\n        ng-disabled=\"$ctrl.disabled()\"\n        ng-if=\"$ctrl.visiblePages[0] > 1\"\n        ng-click=\"$ctrl.callOnChange(0)\"\n        ct-pagination-controls-page=\"0\"\n    >1\n    </button>\n\n    <button\n        class=\"cu-button-default\"\n        ng-disabled=\"$ctrl.disabled()\"\n        ng-if=\"$ctrl.visiblePages[0] > 1\"\n        ng-click=\"$ctrl.callOnChange($ctrl.visiblePages[0] - 1)\"\n        ct-pagination-controls-prev-dots\n    >...\n    </button>\n\n    <button\n        class=\"cu-button-default\"\n        ng-repeat=\"pageNum in $ctrl.visiblePages track by $index\"\n        ng-disabled=\"$ctrl.disabled()\"\n        ng-class=\"{ 'cu-selected': pageNum === $ctrl.currentPage }\"\n        ng-click=\"$ctrl.callOnChange(pageNum)\"\n        ct-pagination-controls-page=\"{{ pageNum }}\"\n    >{{ pageNum + 1 }}\n    </button>\n\n    <button\n        class=\"cu-button-default\"\n        ng-disabled=\"$ctrl.disabled()\"\n        ng-if=\"$ctrl.visiblePages[$ctrl.visiblePages.length - 1] < $ctrl.numPages - 2\"\n        ng-click=\"$ctrl.callOnChange($ctrl.visiblePages[$ctrl.visiblePages.length - 1] + 1)\"\n        ct-pagination-controls-next-dots\n    >...\n    </button>\n\n    <button\n        class=\"cu-button-default\"\n        ng-disabled=\"$ctrl.disabled()\"\n        ng-if=\"$ctrl.visiblePages[$ctrl.visiblePages.length - 1] < $ctrl.numPages - 1\"\n        ng-click=\"$ctrl.callOnChange($ctrl.numPages - 1)\"\n        ct-pagination-controls-page=\"{{ $ctrl.numPages - 1 }}\"\n    >{{ $ctrl.numPages }}\n    </button>\n\n    <button\n        class=\"cu-button-default cu-button-icon\"\n        ng-disabled=\"$ctrl.currentPage === $ctrl.numPages - 1 || $ctrl.disabled()\"\n        ng-click=\"$ctrl.callOnChange($ctrl.currentPage + 1)\"\n        ct-pagination-controls-next\n    >\n        <cu-icon name=\"chevron-right\"></cu-icon>\n    </button>\n</div>\n";

/***/ }),

/***/ "./src/angularjs/components/pagination-controls/pagination-controls.js":
/*!*****************************************************************************!*\
  !*** ./src/angularjs/components/pagination-controls/pagination-controls.js ***!
  \*****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _paginationControls = __webpack_require__(/*! ./pagination-controls.html */ "./src/angularjs/components/pagination-controls/pagination-controls.html");

var _paginationControls2 = _interopRequireDefault(_paginationControls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  angular.module('unison').component('cuPaginationControls', {
    template: _paginationControls2.default,
    bindings: {
      numPages: '<',
      currentPage: '<',
      onPageChange: '&',
      disabled: '&ngDisabled'
    },
    controller: [function PopoverCtrl() {
      var _this = this;

      this.numPageControls = 3;

      this.$onChanges = function () {
        _this.setState(_this.numPages, _this.currentPage || 0);
      };

      this.setState = function (numPages, currentPage) {
        var firstNum = currentPage - currentPage % _this.numPageControls;

        _this.visiblePages = [];
        for (var i = 0, b = firstNum; i < _this.numPageControls && b < numPages; i += 1, b += 1) {
          _this.visiblePages.push(b);
        }
      };

      this.callOnChange = function (currentPage) {
        if (!_this.disabled()) {
          _this.onPageChange({ $cuValue: currentPage });
        }
      };
    }]
  });
})(); //
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/***/ }),

/***/ "./src/angularjs/components/popover/popover.js":
/*!*****************************************************!*\
  !*** ./src/angularjs/components/popover/popover.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _popover = __webpack_require__(/*! ../../../common/popover.ts */ "./src/common/popover.ts");

(function () {
  angular.module('unison').component('cuPopover', {
    template: '\n      <ng-transclude ng-transclude-slot="target"\n              ng-click="$ctrl.onTargetClick()"\n              tabindex="-1"\n              style="outline: none"\n              ng-mouseenter="$ctrl.setOpenTimeout()"\n              ng-mouseleave="$ctrl.setCloseTimeout()"\n      ></ng-transclude>\n      <cu-popover-content-container\n              ng-if="$ctrl.preloaded || !$ctrl.lazy || $ctrl.opened"\n              ng-show="$ctrl.opened"\n              class="cu-popover-content-container"\n              ng-style="$ctrl.contentStyles"\n              ng-mouseenter="$ctrl.setOpenTimeout()"\n              ng-mouseleave="$ctrl.setCloseTimeout()"\n              cu-focusout="$ctrl.onContentFocusout($event)"\n      >\n          <div ng-transclude="content" class="cu-d-flex"></div>\n          <cu-popover-arrow \n              class="cu-popover-arrow"\n              ng-hide="$ctrl.noArrow"\n              ng-class="\'cu-popover-arrow-fixed-\' + $ctrl.fixedDirection + \' cu-popover-arrow-align-\' + $ctrl.alignDirection"\n              ng-style="$ctrl.arrowStyles"\n          ></cu-popover-arrow>\n      </cu-popover-content-container>\n    ',
    transclude: {
      target: 'cuPopoverTarget',
      content: 'cuPopoverContent'
    },
    bindings: {
      opened: '=?',

      appendToBody: '<?',
      closeOnScroll: '<?',
      fixedOffset: '<?',
      lazy: '<?',
      openOnHover: '<?',
      noArrow: '<?',
      positioningStrategy: '<?',
      stealFocus: '<?',

      onOpen: '&',
      onClose: '&',

      disabled: '&ngDisabled'
    },
    require: {
      parentPopoverCtrl: '?^^cuPopover'
    },
    controller: ['$document', '$element', '$scope', '$timeout', '$window', function PopoverCtrl($document, $element, $scope, $timeout, $window) {
      var _this = this;

      var forceReposition = function forceReposition() {
        _this.positionPopoverContent();
        $scope.$digest();
      };
      var forceClose = function forceClose() {
        _this.opened = false;
        $scope.$digest();
      };
      var previousActiveElement = null;
      var hoverCloseTimeout = null;
      var hoverOpenTimeout = null;

      this.$onInit = function () {
        _this.contentStyles = {};
        _this.arrowStyles = {};
        _this.closeCallbacks = [];
        _this.scrollParents = [];

        _this.opened = _this.opened || false;

        _this.appendToBody = _this.appendToBody === undefined ? false : _this.appendToBody;
        _this.lazy = _this.lazy === undefined ? true : _this.lazy;
        _this.noArrow = _this.noArrow === undefined ? false : _this.noArrow;

        var popoverOffset = _this.noArrow ? _popover.POPOVER_NO_ARROW_OFFSET : _popover.POPOVER_OFFSET;

        _this.fixedOffset = _this.fixedOffset === undefined ? popoverOffset : +_this.fixedOffset;
        _this.positioningStrategy = _this.positioningStrategy || {};
        _this.stealFocus = _this.stealFocus === undefined ? !_this.openOnHover : _this.stealFocus;

        if (_this.parentPopoverCtrl) {
          _this.parentPopoverCtrl.childPopoverCtrl = _this;
        }

        $scope.$watch(function () {
          return _this.opened;
        }, function (newVal, oldVal) {
          if (newVal !== oldVal) {
            if (_this.opened) {
              _this.open();
            } else {
              _this.close();
            }
          }
        });

        $scope.$watch(function () {
          return _this.disabled();
        }, function (newVal) {
          if (newVal && _this.opened) {
            _this.opened = false;
          }
        });

        $window.addEventListener('resize', forceClose);
      };

      this.$onChanges = function () {
        if (_this.openOnHover === false) {
          $timeout.cancel(hoverOpenTimeout);
          $timeout.cancel(hoverCloseTimeout);
        }
      };

      this.$postLink = function () {
        angular.element(_this.targetElem).on('mouseenter', function () {
          $scope.$apply(function () {
            _this.preloaded = true;
          });
        }).on('mouseleave', function () {
          $scope.$apply(function () {
            _this.preloaded = false;
          });
        });
      };

      this.setOpenTimeout = function () {
        if (_this.openOnHover && !_this.disabled()) {
          hoverOpenTimeout = $timeout(function () {
            if (!_this.disabled()) {
              _this.opened = true;
            }
          }, 100);
          $timeout.cancel(hoverCloseTimeout);
          hoverCloseTimeout = null;
        }
      };

      this.setCloseTimeout = function () {
        if (_this.openOnHover && !_this.disabled()) {
          hoverCloseTimeout = $timeout(function () {
            if (!_this.disabled()) {
              _this.opened = false;
            }
          }, 200);
          $timeout.cancel(hoverOpenTimeout);
          hoverOpenTimeout = null;
        }
      };

      this.$onDestroy = function () {
        _this.cleanupContentElement();

        $window.removeEventListener('resize', forceClose);
      };

      this.getPositioningStrategy = function getPositioningStrategy(type) {
        return this.positioningStrategy[type] || angular.copy(_popover.DEFAULT_POSITIONING_STRATEGY[type]);
      };

      this.getPositioningStrategies = function getPositioningStrategies() {
        return angular.extend({}, _popover.DEFAULT_POSITIONING_STRATEGY, this.positioningStrategy);
      };

      this.open = function () {
        $element.addClass('cu-popover-opened');

        _this.contentStyles.top = '-99999px';
        _this.contentStyles.left = '-99999px';
        _this.arrowStyles.top = '-99999px';
        _this.arrowStyles.left = '-99999px';

        delete _this.contentStyles.bottom;
        delete _this.contentStyles.right;
        delete _this.arrowStyles.bottom;
        delete _this.arrowStyles.right;

        $timeout(function () {
          if (_this.opened) {
            _this.setScrollParents();

            _this.positionPopoverContent();

            if (_this.stealFocus) {
              // $timeout because safari will not immediately position the content
              // which could cause the page to scroll when focus changes
              $timeout(function () {
                previousActiveElement = $document[0].activeElement;

                var focuser = _this.contentElem.querySelector('[cu-popover-focuser]');
                if (focuser) {
                  focuser.focus();
                } else {
                  _this.contentElem.focus();
                }
              });
            }

            // Trigger the event after the popover is visible & positioned
            _this.onOpen();
          }
        });
      };

      this.close = function () {
        if (_this.childPopoverCtrl) {
          _this.childPopoverCtrl.opened = false;
        }

        $element.removeClass('cu-popover-opened');

        // If we still have focus at this point restore it to the previousActiveElement.
        if (previousActiveElement && _this.hasFocus()) {
          previousActiveElement.focus();
        }

        _this.cleanupContentElement();

        _this.closeCallbacks.forEach(function (callback) {
          return callback();
        });
        _this.onClose();
      };

      this.onTargetClick = function () {
        if (!_this.disabled() && !_this.openOnHover) {
          _this.opened = !_this.opened;
        }
      };

      this.hasFocus = function (newFocusTarget) {
        // Check against the document's active element,
        // or a passed-in focus target (e.g. from a DOM focusout event)
        var focusTarget = newFocusTarget || $document[0].activeElement;

        // Using parentNode here because the focusOut event relatedTarget
        // lands on our <ng-transclude> element, just above the actual popover content
        return _this.targetElem.parentNode.contains(focusTarget) || _this.contentElem.contains(focusTarget) || _this.childPopoverCtrl && _this.childPopoverCtrl.opened && _this.childPopoverCtrl.hasFocus(focusTarget);
      };

      this.onContentFocusout = function (event) {
        // If we have openOnHover behavior, don't use focus to manage visibility
        // If the new focus target is still within the popover, don't close the popover.
        if (!_this.openOnHover && !_this.hasFocus(event.relatedTarget)) {
          _this.opened = false;
        }
      };

      this.registerCloseCallback = function (callback) {
        _this.closeCallbacks.push(callback);
      };

      this.deregisterCloseCallback = function (callback) {
        for (var i = 0; i < _this.closeCallbacks.length; i += 1) {
          if (_this.closeCallbacks[i] === callback) {
            _this.closeCallbacks.splice(i, 1);
            break;
          }
        }
      };

      /*
      Position the popover content and popover arrow. The positioning logic is as follows...
      Attempt to fix the content in the preferred direction. Continue attempting to fix the
      content as long as we haven't exhausted the list of preferred options. If we cannot fix
      the content in any of the preferred directions, then fix the content in the direction
      that has the most free space available.
       Then follow the same process for alignment, except that if no preferred alignment can
      be reached, we center align the content.
       */
      this.positionPopoverContent = function () {
        var positionMetrics = _this.getPositionMetrics();

        _this.contentStyles = {};
        _this.arrowStyles = {};

        var positioning = (0, _popover.determinePositioningStrategies)(positionMetrics, _this.getPositioningStrategies(), _this.fixedOffset);

        var styles = (0, _popover.calculatePositioning)(positionMetrics, {
          fixedDirection: positioning.fixed,
          alignDirection: positioning.align,
          fixedOffset: _this.fixedOffset
        });

        _this.fixedDirection = positioning.fixed;
        _this.alignDirection = positioning.align;
        _this.contentStyles = styles.contentStyles;
        _this.arrowStyles = styles.arrowStyles;

        if (_this.appendToBody) {
          _this.appendToBodyWrapper = angular.element('<div class="unison-component"></div>');
          _this.appendToBodyWrapper.append(_this.contentContainerElem);
          angular.element($window.document.body).append(_this.appendToBodyWrapper);
        }
      };

      this.getPositionMetrics = function getPositionMetrics() {
        var contentDimensions = {
          width: this.contentElem.offsetWidth,
          height: this.contentElem.offsetHeight
        };

        var positioningTarget = $element[0].querySelector(_popover.CUSTOM_POSITIONING_TARGET_SELECTOR) || this.targetElem;
        var targetBox = positioningTarget.getBoundingClientRect();
        var windowBox = {
          top: 0,
          bottom: $window.innerHeight,
          left: 0,
          right: $window.innerWidth,
          height: $window.innerHeight,
          width: $window.innerWidth
        };
        return { contentDimensions: contentDimensions, targetBox: targetBox, windowBox: windowBox };
      };

      this.setScrollParents = function () {
        _this.clearScrollParents();

        var scrollFn = _this.closeOnScroll ? forceClose : forceReposition;

        var parent = _this.contentElem.parentNode;

        while (parent.nodeType === Node.ELEMENT_NODE) {
          var styles = $window.getComputedStyle(parent);
          var canScroll = styles.overflow === 'auto' || styles.overflow === 'scroll';

          if (canScroll) {
            _this.scrollParents.push(angular.element(parent).on('scroll', scrollFn));
          }

          parent = parent.parentNode;
        }

        $window.addEventListener('scroll', scrollFn);
      };

      this.clearScrollParents = function () {
        _this.scrollParents.forEach(function (scrollParent) {
          scrollParent.off('scroll', forceClose).off('scroll', forceReposition);
        });

        _this.scrollParents = [];

        $window.removeEventListener('scroll', forceClose);
        $window.removeEventListener('scroll', forceReposition);
      };

      this.cleanupContentElement = function () {
        // We appended this element to the body, so we must remove it
        if (_this.appendToBody && _this.appendToBodyWrapper) {
          $element.append(_this.contentContainerElem);
          _this.appendToBodyWrapper.remove();
          _this.appendToBodyWrapper = null;
        }

        _this.clearScrollParents();
      };
    }]
  });

  angular.module('unison').component('cuPopoverTarget', {
    template: '<ng-transclude></ng-transclude>',
    transclude: true,
    require: {
      popoverCtrl: '^^cuPopover'
    },
    controller: ['$element', function PopoverTargetCtrl($element) {
      var _this2 = this;

      this.$onInit = function () {
        _this2.popoverCtrl.targetElem = $element[0];
      };
    }]
  });

  angular.module('unison').component('cuPopoverContentContainer', {
    template: '<ng-transclude></ng-transclude>',
    transclude: true,
    require: {
      popoverCtrl: '^^cuPopover'
    },
    controller: ['$element', function PopoverContentContainereCtrl($element) {
      var _this3 = this;

      this.$onInit = function () {
        _this3.popoverCtrl.contentContainerElem = $element[0];
      };
    }]
  });

  angular.module('unison').component('cuPopoverContent', {
    template: '<ng-transclude></ng-transclude>',
    transclude: true,
    require: {
      popoverCtrl: '^^cuPopover'
    },
    controller: ['$element', function PopoverContentCtrl($element) {
      var _this4 = this;

      this.$onInit = function () {
        $element[0].setAttribute('tabindex', '-1');
        $element[0].classList.add('cu-popover-content');
        _this4.popoverCtrl.contentElem = $element[0];
      };
    }]
  });

  angular.module('unison').directive('cuPopoverClickClose', function () {
    return {
      restrict: 'A',
      require: '^^?cuPopover',
      link: function link(scope, element, attrs, popoverCtrl) {
        if (popoverCtrl) {
          element.on('click', function () {
            return scope.$apply(function () {
              /* eslint no-param-reassign: off */
              popoverCtrl.opened = false;
            });
          });
        }
      }
    };
  });
})(); //
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/***/ }),

/***/ "./src/angularjs/components/progress-bar/progress-bar.js":
/*!***************************************************************!*\
  !*** ./src/angularjs/components/progress-bar/progress-bar.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

(function () {
  var template = '\n  <div class=\'cu-progress\'>\n      <span\n        class="cu-progress-bar"\n        ng-class="{\n          \'cu-progress-bar-indeterminate\': $ctrl.isIndeterminate,\n          \'cu-progress-bar\': !$ctrl.isIndeterminate,\n          \'cu-disabled\': $ctrl.disabled(),\n        }"\n        ng-disabled="$ctrl.disabled()"\n        ng-style="{ width: $ctrl.getCurrentBarWidth() + \'%\' }"  \n        aria-valuenow="$ctrl.getCurrentBarWidth()"\n        aria-valuemin="0"\n        aria-valuemax="100"  \n      ></span>\n  </div>\n  ';

  angular.module('unison').component('cuProgressBar', {
    bindings: {
      disabled: '&ngDisabled',
      isIndeterminate: '<?',
      value: '<'
    },
    template: template,
    controller: ['$element', function CuProgressBar($element) {
      var _this = this;

      $element.addClass('cu-d-block');

      this.$onInit = function () {
        _this.isIndeterminate = _this.isIndeterminate || _this.value === undefined;
        _this.currentBarWidth = _this.valueToPercent(_this.value);
      };

      this.getCurrentBarWidth = function () {
        if (_this.disabled()) {
          return _this.currentBarWidth || '0';
        }

        _this.currentBarWidth = _this.valueToPercent(_this.value);
        return _this.currentBarWidth;
      };

      this.valueToPercent = function (val) {
        if (isNaN(val)) {
          return '0';
        }

        return Math.min(Math.max(0, Math.floor(100 * val)), 100).toString();
      };
    }]
  });
})();

/***/ }),

/***/ "./src/angularjs/components/radio-button-group/radio-button-group.js":
/*!***************************************************************************!*\
  !*** ./src/angularjs/components/radio-button-group/radio-button-group.js ***!
  \***************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  angular.module('unison').component('cuRadioButtonGroup', {
    bindings: {
      value: '=?',
      onChange: '&'
    },
    transclude: true,
    template: '<ng-transclude class="cu-d-inline-flex"></ng-transclude>'
  });
})();

/***/ }),

/***/ "./src/angularjs/components/radio-button-group/radio-button-option.js":
/*!****************************************************************************!*\
  !*** ./src/angularjs/components/radio-button-group/radio-button-option.js ***!
  \****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  var template = '\n<button ng-transclude \n    class="cu-button-default"\n    ng-click="$ctrl.onClick()"\n    ng-disabled="$ctrl.disabled()"\n    ct-radio-button-option="{{ $ctrl.value }}"\n></button>\n';

  angular.module('unison').component('cuRadioButtonOption', {
    bindings: {
      value: '@',
      disabled: '&ngDisabled'
    },
    transclude: true,
    template: template,
    require: {
      parentCtrl: '^cuRadioButtonGroup'
    },
    controller: ['$element', '$scope', function RadioOptionCtrl($element, $scope) {
      var _this = this;

      this.$onInit = function () {
        $scope.$watch('$ctrl.isSelected()', function (isSelected) {
          if (isSelected) {
            $element[0].classList.add('cu-selected');
          } else {
            $element[0].classList.remove('cu-selected');
          }
        });
      };

      this.isSelected = function () {
        return _this.value === _this.parentCtrl.value;
      };

      this.onClick = function () {
        if (!_this.disabled()) {
          _this.parentCtrl.value = _this.value;
          _this.parentCtrl.onChange({ $cuValue: _this.value });
        }
      };
    }]
  });
})();

/***/ }),

/***/ "./src/angularjs/components/radio-group/radio-group.js":
/*!*************************************************************!*\
  !*** ./src/angularjs/components/radio-group/radio-group.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

(function () {
  var radioGroupTemplate = '<ng-transclude class="cu-radio-group"></ng-transclude>';
  var radioGroupHorizontalTemplate = '<ng-transclude class="cu-radio-group cu-radio-group-horizontal"></ng-transclude>';

  var getRadioGroupComponent = function getRadioGroupComponent(template) {
    return {
      bindings: {
        value: '<?',
        onChange: '&'
      },
      transclude: true,
      template: template,
      controller: [function radioGroupCtrl() {
        var _this = this;

        this.onChangeInner = function (value) {
          _this.onChange({ $cuValue: value });
        };
      }]
    };
  };

  var radioGroupComponent = getRadioGroupComponent(radioGroupTemplate);
  var radioGroupHorizontalComponent = getRadioGroupComponent(radioGroupHorizontalTemplate);

  angular.module('unison').component('cuRadioGroup', radioGroupComponent).component('cuRadioGroupHorizontal', radioGroupHorizontalComponent);
})();

/***/ }),

/***/ "./src/angularjs/components/radio-group/radio-option.js":
/*!**************************************************************!*\
  !*** ./src/angularjs/components/radio-group/radio-option.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

(function () {
  var template = '\n<button class="cu-button-invisible cu-radio-option" ng-click="$ctrl.onClick()" ng-disabled="$ctrl.disabled()">\n    <div \n        class="cu-radio-outer-circle"\n        ct-radio-option="{{ $ctrl.value }}"\n    >\n        <div class="cu-radio-inner-circle" ng-show="$ctrl.isSelected()"></div>\n    </div>\n    <div class="cu-radio-label cu-text-body">\n        {{ $ctrl.label }}\n    </div>\n</button>\n';

  angular.module('unison').component('cuRadioOption', {
    bindings: {
      label: '@?',
      value: '@',
      disabled: '&ngDisabled'
    },
    template: template,
    require: {
      parentHCtrl: '?^cuRadioGroupHorizontal',
      parentVCtrl: '?^cuRadioGroup'
    },
    controller: [function RadioOptionCtrl() {
      var _this = this;

      this.$onInit = function () {
        _this.parentCtrl = _this.parentHCtrl || _this.parentVCtrl;
        if (!_this.parentCtrl) {
          throw Error('Unison: cuRadioOption needs parent cuRadioGroup or cuRadioGroupHorizontal');
        }

        _this.label = _this.label || _this.value;
      };

      this.isSelected = function () {
        return _this.value === _this.parentCtrl.value;
      };

      this.onClick = function () {
        if (!_this.disabled()) {
          _this.parentCtrl.onChangeInner(_this.value);
        }
      };
    }]
  });
})();

/***/ }),

/***/ "./src/angularjs/components/scrim/scrim.js":
/*!*************************************************!*\
  !*** ./src/angularjs/components/scrim/scrim.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  var unison = angular.module('unison');

  unison.component('cuScrim', {
    bindings: {
      opened: '<'
    },
    template: '<div class="cu-scrim" ng-class="{ \'cu-scrim-open\': $ctrl.opened }"></div>'
  });
})();

/***/ }),

/***/ "./src/angularjs/components/search-bar/search-bar.html":
/*!*************************************************************!*\
  !*** ./src/angularjs/components/search-bar/search-bar.html ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<div class=\"cu-search-bar\" ng-class=\"{ 'cu-search-bar-with-clear-button': $ctrl.onClear }\">\n    <cu-icon name=\"search\" class=\"cu-search-bar-search-icon\"></cu-icon>\n    <ng-transclude ng-transclude-slot=\"input\"></ng-transclude>\n    <button\n        class=\"cu-button-invisible cu-search-bar-close-button\"\n        ng-if=\"$ctrl.onClear && $ctrl.inputValue\"\n        ng-click=\"$ctrl.onClear()\">\n        <cu-tooltip>\n            <cu-tooltip-target>\n                <cu-icon name=\"close\"></cu-icon>\n            </cu-tooltip-target>\n            <cu-tooltip-content class=\"cu-d-block cu-m-3\">\n                Clear\n            </cu-tooltip-content>\n        </cu-tooltip>\n    </button>\n</div>\n";

/***/ }),

/***/ "./src/angularjs/components/search-bar/search-bar.js":
/*!***********************************************************!*\
  !*** ./src/angularjs/components/search-bar/search-bar.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _searchBar = __webpack_require__(/*! ./search-bar.html */ "./src/angularjs/components/search-bar/search-bar.html");

var _searchBar2 = _interopRequireDefault(_searchBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var unison = angular.module('unison');

  unison.component('cuSearchBar', {
    transclude: {
      input: 'input'
    },
    bindings: {
      onClear: '&?'
    },
    template: _searchBar2.default,
    controller: ['$element', '$scope', function CuSearchBar($element, $scope) {
      var _this = this;

      this.$postLink = function () {
        $scope.$watch(function () {
          return $element.find('input')[0] && $element.find('input')[0].value;
        }, function (inputValue) {
          _this.inputValue = inputValue;
        });
      };
    }]
  });
})(); //
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/***/ }),

/***/ "./src/angularjs/components/select/select-item.js":
/*!********************************************************!*\
  !*** ./src/angularjs/components/select/select-item.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  var unison = angular.module('unison');

  var template = '\n<cu-popover opened="$ctrl.opened" steal-focus="false" no-arrow="true" fixed-offset="-4" positioning-strategy="{fixed: [\'right\', \'left\'], align: [\'top\', \'bottom\']}">\n  <cu-popover-target class="cu-d-block">\n    <cu-select-item-inner\n        ng-click="$ctrl.onItemClicked()"\n        ng-mouseenter="$ctrl.onItemMouseenter()"\n        ng-mouseleave="$ctrl.onItemMouseleave($event)"\n        ng-class="{ \'cu-active\': $ctrl.isItemActive() }"\n        class="cu-justify-content-between cu-ml-2 cu-mr-2 cu-list-item" \n        style="flex: 1"\n        tabindex="-1"\n        cu-popover-click-close\n        ct-select-item="{{ $ctrl.value }}"\n     >\n      <ng-transclude></ng-transclude>\n      <cu-icon name="checkmark" class="cu-ml-2 cu-color-success" ng-if="$ctrl.isItemSelected()"></cu-icon>\n      <cu-icon name="chevron-right" class="cu-ml-2" ng-if="$ctrl.isParent"></cu-icon>\n    </cu-select-item-inner>\n  </cu-popover-target>\n  \n  <cu-popover-content>\n      <ng-transclude ng-transclude-slot="subItems"></ng-transclude>\n  </cu-popover-content>\n</cu-popover>\n  ';

  unison.component('cuSelectItem', {
    transclude: {
      subItems: '?cuSelectItems'
    },
    bindings: {
      value: '@'
    },
    require: {
      selectCtrl: '^^cuSelect'
    },
    template: template,
    controller: ['$document', '$element', '$log', '$scope', '$timeout', function SelectItemController($document, $element, $log, $scope, $timeout) {
      var _this = this;

      this.$onInit = function () {
        if (!_this.selectCtrl.listManager.itemsByValue[_this.value]) {
          $log.error('Unison: cu-select-item with value "' + _this.value + ' is not recognized by cu-select. Make sure it is in the cu-select items array. ');
          return;
        }

        _this.isParent = !!_this.selectCtrl.listManager.itemsByValue[_this.value].children;
        _this.selectCtrl.registerItem(_this);

        $scope.$watch(function () {
          return _this.selectCtrl.activeValue;
        }, function (activeValue) {
          if (!activeValue) {
            return;
          }

          if (activeValue !== _this.value) {
            var isAncestorActive = _this.selectCtrl.listManager.ancestors(activeValue).map(function (_) {
              return _.value;
            }).indexOf(_this.value) !== -1;

            if (!isAncestorActive) {
              _this.opened = false;
            }
          }
        });
      };

      this.$onDestroy = function () {
        _this.selectCtrl.deregisterItem(_this);
      };

      this.isItemSelected = function () {
        return _this.selectCtrl.internalValue === _this.value;
      };

      this.isItemActive = function () {
        return _this.opened || _this.selectCtrl.activeValue === _this.value;
      };

      this.onItemClicked = function () {
        if (!_this.isParent) {
          _this.selectCtrl.onItemClicked(_this);
        }
      };

      this.onItemMouseenter = function () {
        _this.selectCtrl.activeValue = _this.value;
        _this.open();
      };

      this.onItemMouseleave = function (event) {
        _this.selectCtrl.activeValue = null;

        var elAtPoint = $document[0].elementFromPoint(event.clientX, event.clientY);

        if (!$element[0].contains(elAtPoint)) {
          _this.close();
        }
      };

      this.open = function () {
        _this.selectCtrl.listManager.siblings(_this.value).forEach(function (item) {
          _this.selectCtrl.itemCtrls[item.value].close();
        });

        if (_this.isParent) {
          _this.openTimeout = $timeout(function () {
            _this.opened = true;
          }, 200);
        }
      };

      this.close = function () {
        _this.opened = false;
        $timeout.cancel(_this.openTimeout);
      };
    }]
  });
})();

/***/ }),

/***/ "./src/angularjs/components/select/select.js":
/*!***************************************************!*\
  !*** ./src/angularjs/components/select/select.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  var unison = angular.module('unison');

  var template = '\n<cu-popover close-on-scroll="true" class="cu-d-block" opened="$ctrl.opened" ng-disabled="$ctrl.disabled()">\n  <cu-popover-target class="cu-d-block">\n    <button\n        class="cu-button-default cu-d-flex cu-w-100"\n        ng-keydown="$ctrl.onButtonKeydown($event)"\n        cu-select-button\n        ng-disabled="$ctrl.disabled()"\n        cu-button-popover-handle\n        ct-select-button\n    >\n      <span class="cu-text-truncate" ng-class="{ \'cu-text-ui-copy\': $ctrl.displayLabel !== $ctrl.unselectedLabel }">\n        {{ $ctrl.displayLabel }}\n      </span>\n    </button>\n  </cu-popover-target>\n  \n  <cu-popover-content ng-keydown="$ctrl.onKeydown($event)">\n    <div ng-transclude="items"></div>\n  </cu-popover-content>\n</cu-popover>\n  ';

  unison.component('cuSelect', {
    transclude: {
      items: 'cuSelectItems'
    },
    bindings: {
      value: '=?',
      items: '<',
      onChange: '&',
      unselectedLabel: '@',
      disabled: '&ngDisabled'
    },
    template: template,
    controller: ['$attrs', '$controller', '$element', '$log', '$scope', 'cuListManagerFactory', function SelectController($attrs, $controller, $element, $log, $scope, ListManagerFactory) {
      var _this = this;

      this.$onInit = function () {
        if (!$element.attr('tabindex')) {
          $element.attr('tabindex', '-1');
        }

        _this.itemCtrls = {};
        _this.buttonElement = null;
        _this.opened = false;

        _this.setupListManager(_this.items);

        $scope.$watch('$ctrl.internalValue', function () {
          _this.updateValue();
        });

        $scope.$watch('$ctrl.value', function (newValue, oldValue) {
          if (_this.listManager.itemsByValue[_this.value] || _this.value === undefined) {
            _this.internalValue = _this.value;
          }

          if (newValue !== oldValue) {
            _this.onChange({ $cuValue: _this.internalValue });
          }
        });

        $scope.$watch('$ctrl.items', function () {
          _this.setupListManager(_this.items);
          // Update current value in case it has changed
          _this.updateValue();
        }, true);
      };

      this.setupListManager = function (items) {
        _this.listManager = ListManagerFactory();
        _this.listManager.setItems(angular.copy(items));

        _this.listManager.registerTypeaheadListener($element, function (typeaheadValue) {
          $scope.$apply(function () {
            var siblings = _this.listManager.siblings(_this.activeValue);

            for (var i = 0; i < siblings.length; i += 1) {
              if (siblings[i].typeaheadValue.toLowerCase().indexOf(typeaheadValue) === 0) {
                _this.activeValue = siblings[i].value;
                break;
              }
            }
          });
        });
      };

      this.updateValue = function () {
        var selectedCtrl = _this.listManager.itemsByValue[_this.internalValue];
        _this.displayLabel = selectedCtrl ? selectedCtrl.label : _this.unselectedLabel;

        if (_this.internalValue !== undefined && 'value' in $attrs) {
          _this.value = _this.internalValue;
        }
      };

      this.setButtonElement = function (buttonElement) {
        _this.buttonElement = buttonElement;
      };

      this.registerItem = function (itemCtrl) {
        _this.itemCtrls[itemCtrl.value] = itemCtrl;
      };

      this.deregisterItem = function (itemCtrl) {
        delete _this.itemCtrls[itemCtrl.value];
      };

      this.onItemClicked = function (itemCtrl) {
        _this.selectItemCtrl(itemCtrl);
        _this.focusToggleButton();
      };

      this.selectItemCtrl = function (itemCtrl) {
        _this.internalValue = itemCtrl.value;

        _this.close();
      };

      this.onButtonKeydown = function (event) {
        if (event.keyCode === 38 || event.keyCode === 40) {
          // up || down
          _this.open();
          event.preventDefault();
        }
      };

      this.focusToggleButton = function () {
        _this.buttonElement.focus();
      };

      this.open = function () {
        _this.activeValue = _this.internalValue;
        _this.opened = true;
      };

      this.close = function () {
        _this.opened = false;
        _this.activeValue = null;
      };

      this.onKeydown = function (event) {
        var activeItemCtrl = _this.itemCtrls[_this.activeValue];
        var activeListItem = _this.listManager.itemsByValue[_this.activeValue];

        if (event.keyCode === 32 && _this.listManager.typeaheadTimeout) {
          return;
        }

        if (event.keyCode === 38) {
          // up
          _this.activeValue = _this.listManager.prevItem(_this.activeValue).value;
          event.preventDefault();
        } else if (event.keyCode === 40) {
          // down
          _this.activeValue = _this.listManager.nextItem(_this.activeValue).value;
          event.preventDefault();
        } else if (event.keyCode === 37 && _this.selectItemCtrl) {
          // left
          var parent = _this.listManager.parent(activeListItem.value);

          if (parent) {
            _this.itemCtrls[parent.value].close();
            _this.activeValue = parent.value;
          }

          event.preventDefault();
        } else if (event.keyCode === 39) {
          // right
          if (activeListItem && activeListItem.children) {
            activeItemCtrl.open();
            _this.activeValue = _this.listManager.children(_this.activeValue)[0].value;
          }
          event.preventDefault();
        } else if (event.keyCode === 13 || event.keyCode === 32) {
          // enter || space
          if (activeListItem && activeListItem.children) {
            if (!activeItemCtrl.opened) {
              activeItemCtrl.open();
              _this.activeValue = activeListItem.children[0].value;
            }
          } else {
            _this.onItemClicked(activeItemCtrl);
          }
          event.preventDefault();
        } else if (event.keyCode === 27) {
          // esc
          _this.close();
          _this.focusToggleButton();
        }
      };
    }]
  });

  unison.directive('cuSelectButton', function () {
    return {
      restrict: 'A',
      require: '^^cuSelect',
      link: function link(scope, element, attrs, selectCtrl) {
        selectCtrl.setButtonElement(element);
      }
    };
  });
})();

/***/ }),

/***/ "./src/angularjs/components/slider/slider.html":
/*!*****************************************************!*\
  !*** ./src/angularjs/components/slider/slider.html ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<ng-transclude ng-transclude-slot=\"minLabel\" ng-click=\"$ctrl.callOnChange($ctrl.min)\" ng-disabled=\"true\"></ng-transclude>\n\n<cu-slider-body ng-mousedown=\"$ctrl.onMousedown($event)\" tabindex=\"-1\">\n    <cu-slider-bar-container ng-click=\"$ctrl.onBarClick($event)\">\n        <cu-slider-bar ng-style=\"{ left: $ctrl.getLowerHandlePositionLeft(), width: $ctrl.getRangeWidth() }\"></cu-slider-bar>\n    </cu-slider-bar-container>\n\n    <cu-slider-track>\n        <cu-slider-handle ng-if=\"$ctrl.showLowerHandle()\" ng-style=\"{ left: $ctrl.getLowerHandlePositionLeft() }\"></cu-slider-handle>\n        <cu-slider-handle ng-style=\"{ left: $ctrl.getHandlePositionLeft() }\"></cu-slider-handle>\n    </cu-slider-track>\n</cu-slider-body>\n\n<ng-transclude ng-transclude-slot=\"maxLabel\" ng-click=\"$ctrl.callOnChange($ctrl.max)\"></ng-transclude>\n";

/***/ }),

/***/ "./src/angularjs/components/slider/slider.js":
/*!***************************************************!*\
  !*** ./src/angularjs/components/slider/slider.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slider = __webpack_require__(/*! ./slider.html */ "./src/angularjs/components/slider/slider.html");

var _slider2 = _interopRequireDefault(_slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  function clamp(num, min, max) {
    return Math.min(max, Math.max(min, num));
  }

  angular.module('unison').component('cuSlider', {
    bindings: {
      value: '<',
      lowerValue: '<?',
      min: '<?',
      max: '<?',
      step: '<?',
      disabled: '&ngDisabled',
      onChange: '&'
    },
    transclude: {
      minLabel: '?cuSliderMinLabel',
      maxLabel: '?cuSliderMaxLabel'
    },
    template: _slider2.default,
    controller: ['$document', '$scope', function SliderCtrl($document, $scope) {
      var _this = this;

      this.$onInit = function () {
        if (_this.min === undefined) {
          _this.min = 0;
        }

        if (_this.max === undefined) {
          _this.max = 1;
        }

        if (_this.step === undefined) {
          _this.step = (_this.max - _this.min) / 100;
        }
      };

      this.$onDestroy = function () {
        _this.removeDocumentEventHandlers();
      };

      this.isCloserToLowerValue = function (value) {
        var distanceFromLowerValue = Math.abs(_this.lowerValue - _this.roundValueToStep(value));
        var distanceFromUpperValue = Math.abs(_this.value - _this.roundValueToStep(value));
        return distanceFromLowerValue < distanceFromUpperValue;
      };

      this.handleChange = function (value) {
        if (!_this.showLowerHandle()) {
          _this.callOnChange(value, undefined);
        } else if (_this.isCloserToLowerValue(value)) {
          _this.callOnChange(_this.value, value);
        } else {
          _this.callOnChange(value, _this.lowerValue);
        }
      };

      this.callOnChange = function (value, lowerValue) {
        if (!_this.disabled()) {
          _this.onChange({
            $cuValue: _this.roundValueToStep(value),
            $cuLowerValue: _this.roundValueToStep(lowerValue)
          });
        }
      };

      this.hasLowerValue = function () {
        return _this.lowerValue !== undefined;
      };
      this.implicitLowerValue = function () {
        return _this.hasLowerValue() ? _this.lowerValue : _this.min;
      };
      this.showLowerHandle = function () {
        return _this.lowerValue >= _this.min;
      };

      /*
      Round the value to the nearest step.
       ex. min: 0, max: 50, step: 10
      [0         10 *      20        30        40        50]
                    ^
           click at 12 rounds to 10
       ex. min: 5, max: 50, step: 10
      [5         15        25        35        45  * ]
                                                   ^
                                          click at 49 rounds to 50
       */
      this.roundValueToStep = function (value) {
        if (value === undefined) {
          return value;
        }
        var range = _this.max - _this.min;
        var numSteps = Math.floor(range / _this.step);
        var lastStep = _this.min + numSteps * _this.step;
        var valueFromMin = value - _this.min;
        var quotient = Math.floor(valueFromMin / _this.step);
        var remainder = valueFromMin % _this.step;

        // If the value is closer to the max than the
        // last step, go to max instead of closest step
        var snapToMaxPoint = (_this.max + lastStep) / 2;
        if (value >= snapToMaxPoint) {
          return _this.max;
        }

        var numStepsFromMin = quotient + Math.round(remainder / _this.step);
        var valueAdjustedToStep = _this.min + numStepsFromMin * _this.step;

        return clamp(valueAdjustedToStep, _this.min, _this.max);
      };

      this.getHandlePositionLeft = function () {
        var range = _this.max - _this.min;
        var valueFromMin = _this.value - _this.min;
        return clamp(valueFromMin / range * 100, 0, 100) + '%';
      };

      this.getRangeWidth = function () {
        var range = _this.max - _this.min;
        var valuesDiff = Math.abs(_this.value - _this.implicitLowerValue());
        return clamp(valuesDiff / range * 100, 0, 100) + '%';
      };

      this.getLowerHandlePositionLeft = function () {
        var range = _this.max - _this.min;
        var valueFromMin = _this.implicitLowerValue() - _this.min;
        return clamp(valueFromMin / range * 100, 0, 100) + '%';
      };

      this.onMousedown = function (event) {
        _this.bounds = event.target.parentElement.getBoundingClientRect();

        $document.on('mousemove', _this.onMousemove);
        $document.on('mouseup', _this.removeDocumentEventHandlers);

        _this.moveHandleFromEventPageX(event.pageX);
      };

      this.onMousemove = function (event) {
        $scope.$apply(function () {
          return _this.moveHandleFromEventPageX(event.pageX);
        });
      };

      this.removeDocumentEventHandlers = function () {
        $document.off('mousemove', _this.onMousemove);
        $document.off('mouseup', _this.removeDocumentEventHandlers);
      };

      this.moveHandleFromEventPageX = function (eventPageX) {
        var range = _this.max - _this.min;
        var safeEventPageX = clamp(eventPageX, _this.bounds.left, _this.bounds.right);
        var eventPageXInPercent = (safeEventPageX - _this.bounds.left) / _this.bounds.width;

        _this.handleChange(range * eventPageXInPercent + _this.min);
      };
    }]
  });
})(); //
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/***/ }),

/***/ "./src/angularjs/components/spinner/spinner.ts":
/*!*****************************************************!*\
  !*** ./src/angularjs/components/spinner/spinner.ts ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//
// Copyright (c) 2011-2019 by Curalate, Inc.
//
var angular = __webpack_require__(/*! angular */ "angular");
var spinner_svg_1 = __importDefault(__webpack_require__(/*! ../../../../icons/spinner.svg */ "./icons/spinner.svg"));
(function () {
    var unison = angular.module('unison');
    // e.g. <cu-spinner />
    unison.directive('cuSpinner', function () { return ({
        link: function (scope, element) {
            element.addClass('cu-spinner');
            element.addClass('cu-icon-container');
            element.html(spinner_svg_1.default);
        },
        restrict: 'E',
        scope: {
            class: '@',
        },
    }); });
})();


/***/ }),

/***/ "./src/angularjs/components/table-pagination-controls/table-pagination-controls.html":
/*!*******************************************************************************************!*\
  !*** ./src/angularjs/components/table-pagination-controls/table-pagination-controls.html ***!
  \*******************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<div class=\"cu-d-flex cu-justify-content-between cu-w-100\">\n    <cu-pagination-controls\n        num-pages=\"$ctrl.internalState.numPages\"\n        current-page=\"$ctrl.internalState.currentPage\"\n        on-page-change=\"$ctrl.onCurrentPageChange($cuValue)\"\n        ng-disabled=\"$ctrl.disabled()\"\n    ></cu-pagination-controls>\n\n    <cu-select\n        value=\"$ctrl.internalState.itemsPerPage.toString()\"\n        items=\"$ctrl.itemsPerPageSelectItems\"\n        on-change=\"$ctrl.onItemsPerPageChange($cuValue)\"\n        ng-disabled=\"$ctrl.disabled()\"\n    >\n        <cu-select-items>\n            <cu-select-item ng-repeat=\"item in $ctrl.itemsPerPageSelectItems\" value=\"{{ item.value }}\">\n                {{ item.label }}\n            </cu-select-item>\n        </cu-select-items>\n    </cu-select>\n</div>\n";

/***/ }),

/***/ "./src/angularjs/components/table-pagination-controls/table-pagination-controls.js":
/*!*****************************************************************************************!*\
  !*** ./src/angularjs/components/table-pagination-controls/table-pagination-controls.js ***!
  \*****************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _tablePaginationControls = __webpack_require__(/*! ./table-pagination-controls.html */ "./src/angularjs/components/table-pagination-controls/table-pagination-controls.html");

var _tablePaginationControls2 = _interopRequireDefault(_tablePaginationControls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  function getNewCurrentPage(numItems, oldNumPages, currentPage, itemsPerPage) {
    return Math.floor(currentPage / oldNumPages * Math.floor(numItems / itemsPerPage));
  }

  angular.module('unison').component('cuTablePaginationControls', {
    template: _tablePaginationControls2.default,
    bindings: {
      numItems: '<',
      currentPage: '<',
      itemsPerPage: '<',
      onPageChange: '&',
      disabled: '&ngDisabled',
      itemsPerPageSelectOptions: '<?'
    },
    controller: [function PopoverCtrl() {
      var _this = this;

      this.internalState = {};
      this.itemsPerPageOptions = this.itemsPerPageSelectOptions || [10, 25, 50, 100];
      this.itemsPerPageSelectItems = this.itemsPerPageOptions.map(function (_) {
        return { value: _, label: 'Show ' + _ + ' Results' };
      });

      this.$onChanges = function (_ref) {
        var currentPage = _ref.currentPage,
            itemsPerPage = _ref.itemsPerPage;

        if (itemsPerPage && !currentPage) {
          var newPage = getNewCurrentPage(_this.internalState.numItems, _this.internalState.numPages, _this.internalState.currentPage, itemsPerPage.currentValue);

          _this.setInternalState(_this.numItems, newPage, _this.itemsPerPage);
        } else {
          _this.setInternalState(_this.numItems, _this.currentPage, _this.itemsPerPage);
        }
      };

      this.setInternalState = function (numItems, currentPage, itemsPerPage) {
        _this.internalState.numItems = numItems;
        _this.internalState.currentPage = currentPage;
        _this.internalState.itemsPerPage = itemsPerPage;
        _this.internalState.numPages = Math.ceil(numItems / itemsPerPage);
      };

      this.onCurrentPageChange = function (currentPage) {
        _this.setInternalState(_this.internalState.numItems, currentPage, _this.internalState.itemsPerPage);

        _this.onPageChange({
          $cuCurrentPage: _this.internalState.currentPage,
          $cuItemsPerPage: +_this.internalState.itemsPerPage
        });
      };

      this.onItemsPerPageChange = function (itemsPerPage) {
        var newPage = getNewCurrentPage(_this.internalState.numItems, _this.internalState.numPages, _this.internalState.currentPage, itemsPerPage);

        _this.setInternalState(_this.internalState.numItems, newPage, itemsPerPage);

        _this.onPageChange({
          $cuCurrentPage: newPage,
          $cuItemsPerPage: +itemsPerPage
        });
      };
    }]
  });
})(); //
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/***/ }),

/***/ "./src/angularjs/components/time-picker/time-picker-panel.html":
/*!*********************************************************************!*\
  !*** ./src/angularjs/components/time-picker/time-picker-panel.html ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<div class=\"cu-py-4\">\n    <div class=\"cu-d-flex cu-align-items-center cu-px-4\">\n        <input\n            type=\"text\"\n            class=\"cu-form-control cu-time-picker-input\"\n            maxlength=\"2\"\n            ng-keypress=\"$event.isDefaultPrevented() ? angular.noop() : $ctrl.onHourKeypress($event)\"\n            ng-paste=\"$ctrl.onHourPaste()\"\n            ng-model=\"$ctrl.hour\"\n            placeholder=\"HH\"\n            ct-time-picker-hour\n        >\n        <div class=\"cu-mx-2\">:</div>\n        <input\n            type=\"text\"\n            class=\"cu-form-control cu-time-picker-input\"\n            maxlength=\"2\"\n            ng-keypress=\"$event.isDefaultPrevented() ? angular.noop() : $ctrl.onMinuteKeypress($event)\"\n            ng-paste=\"$ctrl.onMinutePaste()\"\n            ng-model=\"$ctrl.minute\"\n            placeholder=\"MM\"\n            ct-time-picker-minute\n        >\n\n        <cu-radio-button-group value=\"$ctrl.period\" class=\"cu-ml-2\">\n            <cu-radio-button-option value=\"AM\" ct-time-picker-am>AM</cu-radio-button-option>\n            <cu-radio-button-option value=\"PM\" ct-time-picker-pm>PM</cu-radio-button-option>\n        </cu-radio-button-group>\n\n        <span class=\"cu-ml-2\" ng-if=\"$ctrl.showTimeZone\">{{ $ctrl.timeZoneLabel }}</span>\n    </div>\n\n    <div class=\"cu-px-4 cu-pt-2 cu-text-caption\">\n        <div ng-if=\"$ctrl.hasMinTimeError()\" class=\"cu-color-error\">\n            <span ng-if=\"$ctrl.minTimeError\">{{ $ctrl.minTimeError }}</span>\n            <span ng-if=\"!$ctrl.minTimeError\">\n                Please select a time after {{ $ctrl.getMinTimeText() }}\n            </span>\n        </div>\n\n        <div ng-if=\"$ctrl.hasMaxTimeError()\" class=\"cu-color-error\">\n            <span ng-if=\"$ctrl.maxTimeError\">{{ $ctrl.maxTimeError }}</span>\n            <span ng-if=\"!$ctrl.maxTimeError\">\n                Please select a time before {{ $ctrl.getMaxTimeText() }}\n            </span>\n        </div>\n    </div>\n\n    <hr class=\"cu-my-4\">\n\n    <div class=\"cu-d-flex cu-justify-content-end cu-px-4\">\n        <button class=\"cu-button-flat cu-mr-1\" ct-time-picker-cancel ng-click=\"$ctrl.closePopover()\">\n            Cancel\n        </button>\n        <button\n            class=\"cu-button-primary\"\n            ng-click=\"$ctrl.onSetTime()\"\n            ng-disabled=\"!$ctrl.isStateValid()\"\n            ct-time-picker-set-time\n        >\n            Set Time\n        </button>\n    </div>\n</div>\n";

/***/ }),

/***/ "./src/angularjs/components/time-picker/time-picker-panel.js":
/*!*******************************************************************!*\
  !*** ./src/angularjs/components/time-picker/time-picker-panel.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _timePickerPanel = __webpack_require__(/*! ./time-picker-panel.html */ "./src/angularjs/components/time-picker/time-picker-panel.html");

var _timePickerPanel2 = _interopRequireDefault(_timePickerPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  // This function determines what the input value should be given a
  // keypress event and a max allowed number (12 for hours, 59 for minutes).
  function getNewTimeValueFromEvent(event, max) {
    var el = event.target;
    var inputArray = el.value.split('');

    // Replace or the selected text (if any) or inject the input key. This will give
    // us the string that would be created if the key was allowed to be pressed.
    inputArray.splice(el.selectionStart, el.selectionEnd - el.selectionStart, event.key);

    var attemptedInput = +inputArray.join('');

    // If the attempted string is NaN, we don't accept it and return the original value.
    if (isNaN(attemptedInput)) {
      return el.value;
    }

    // If the attempted number is too large then replace it with 0n, where n
    // is the number that was typed. Otherwise, allow the attempted number.
    return attemptedInput > max ? '0' + event.key : ('0' + attemptedInput).slice(-2);
  }

  angular.module('unison').component('cuTimePickerPanel', {
    template: _timePickerPanel2.default,
    bindings: {
      value: '<',
      timeZone: '@',
      minTime: '<?',
      minTimeError: '@?',
      maxTime: '<?',
      maxTimeError: '@?',
      onChange: '&',
      showTimeZone: '<?',
      closePopover: '&'
    },
    controller: ['$timeout', function TimePickerCtrl($timeout) {
      var _this = this;

      this.$onChanges = function (changesObj) {
        if (changesObj.timeZone || changesObj.value) {
          _this.timeZoneLabel = moment.tz(_this.value, _this.timeZone).zoneAbbr();
        }

        if (changesObj.value) {
          _this.resetInputs();
        }
      };

      this.resetInputs = function () {
        if (_this.value) {
          var momentValue = moment.tz(_this.value, _this.timeZone);
          _this.hour = momentValue.format('hh');
          _this.minute = momentValue.format('mm');
          _this.period = momentValue.format('A');
        } else {
          _this.hour = '';
          _this.minute = '';
          _this.period = null;
        }
      };

      this.getMinTimeText = function () {
        return _this.minTime ? moment.tz(_this.minTime, _this.timeZone).format('h:mm A') : '';
      };

      this.getMaxTimeText = function () {
        return _this.maxTime ? moment.tz(_this.maxTime, _this.timeZone).format('h:mm A') : '';
      };

      this.onHourKeypress = function (event) {
        event.preventDefault();
        _this.submitOnEnter(event);
        _this.hour = getNewTimeValueFromEvent(event, 12);
      };

      this.onMinuteKeypress = function (event) {
        event.preventDefault();
        _this.submitOnEnter(event);
        _this.minute = getNewTimeValueFromEvent(event, 60);
      };

      this.submitOnEnter = function (event) {
        var code = event.keyCode || event.which;
        if (code === 13 && _this.isStateValid()) {
          event.preventDefault();
          _this.onSetTime();
        }
      };

      // When text is pasted into one of the inputs, we have to timeout
      // to wait to read the text and then revert it if it is invalid.

      this.onHourPaste = function () {
        var previousHour = _this.hour;

        $timeout(function () {
          if (isNaN(+_this.hour) || _this.hour > 12 || _this.hour < 0) {
            _this.hour = previousHour;
          }
        });
      };

      this.onMinutePaste = function () {
        var previousMinute = _this.minute;

        $timeout(function () {
          if (isNaN(+_this.minute) || _this.minute > 59 || _this.minute < 0) {
            _this.minute = previousMinute;
          }
        });
      };

      this.onSetTime = function () {
        // Call onChange with a new date object that has the updated
        // date and the same time as the original date object.
        _this.onChange({
          $cuValue: _this.getProposedTime()
        });

        _this.closePopover();
      };

      this.areInputsComplete = function () {
        return _this.hour !== undefined && _this.hour !== '' && _this.minute !== undefined && _this.minute !== '' && !!_this.period;
      };

      this.isStateValid = function () {
        return _this.areInputsComplete() && !_this.hasMinTimeError() && !_this.hasMaxTimeError();
      };

      this.hasMinTimeError = function () {
        return _this.minTime && _this.areInputsComplete() && _this.getProposedTime() < new Date(_this.minTime);
      };

      this.hasMaxTimeError = function () {
        return _this.maxTime && _this.areInputsComplete() && _this.getProposedTime() > new Date(_this.maxTime);
      };

      this.getProposedTime = function () {
        var momentValue = moment.tz(_this.value || new Date(), _this.timeZone);

        // Cheat for figuring out the right 0-23 hour from 1-12 and am/pm
        var hour = new Date('2000/1/1 ' + _this.hour + ':' + _this.minute + ' ' + _this.period).getHours();
        momentValue.hour(hour).minute(+_this.minute);

        return momentValue.toDate();
      };
    }]
  });
})(); //
// Copyright (c) 2011-2020 by Curalate, Inc.
//

/***/ }),

/***/ "./src/angularjs/components/time-picker/time-picker.html":
/*!***************************************************************!*\
  !*** ./src/angularjs/components/time-picker/time-picker.html ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "<cu-popover class=\"cu-d-inline-block\" opened=\"$ctrl.opened\" ng-disabled=\"$ctrl.disabled()\">\n  <cu-popover-target class=\"cu-d-block\">\n      <button class=\"cu-button-default\" ng-disabled=\"$ctrl.disabled()\" cu-button-popover-handle ct-time-picker-button>\n          <span ng-class=\"{ 'cu-text-ui-copy': !!$ctrl.getButtonText() }\"> {{ $ctrl.getButtonText() || 'Select a Time' }} </span>\n      </button>\n  </cu-popover-target>\n  <cu-popover-content>\n    <cu-time-picker-panel\n      value=\"$ctrl.value\"\n      time-zone=\"{{ $ctrl.timeZone }}\"\n      min-time=\"$ctrl.minTime\"\n      max-time=\"$ctrl.maxTime\"\n      min-time-error=\"{{ $ctrl.minTimeError }}\"\n      max-time-error=\"{{ $ctrl.maxTimeError }}\"\n      on-change=\"$ctrl.onChange({ $cuValue: $cuValue })\"\n      show-time-zone=\"$ctrl.showTimeZone\"\n      close-popover=\"$ctrl.close()\"\n    ></cu-time-picker-panel>\n  </cu-popover-content>\n</cu-popover>\n";

/***/ }),

/***/ "./src/angularjs/components/time-picker/time-picker.js":
/*!*************************************************************!*\
  !*** ./src/angularjs/components/time-picker/time-picker.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _timePicker = __webpack_require__(/*! ./time-picker.html */ "./src/angularjs/components/time-picker/time-picker.html");

var _timePicker2 = _interopRequireDefault(_timePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  angular.module('unison').component('cuTimePicker', {
    template: _timePicker2.default,
    bindings: {
      value: '<',
      timeZone: '@',
      minTime: '<?',
      minTimeError: '@?',
      maxTime: '<?',
      maxTimeError: '@?',
      onChange: '&',
      disabled: '&ngDisabled',
      showTimeZone: '<?'
    },
    controller: function controller() {
      var _this = this;

      this.$onChanges = function (changesObj) {
        if (changesObj.timeZone || changesObj.value) {
          _this.timeZoneLabel = moment.tz(_this.value, _this.timeZone).zoneAbbr();
        }
      };

      this.getButtonText = function () {
        return _this.value ? '' + moment.tz(_this.value, _this.timeZone).format('h:mm A') + (_this.showTimeZone ? ' ' + _this.timeZoneLabel : '') : '';
      };

      this.close = function () {
        _this.opened = false;
      };
    }
  });
})(); //
// Copyright (c) 2011-2020 by Curalate, Inc.
//

/***/ }),

/***/ "./src/angularjs/components/toggle/toggle.js":
/*!***************************************************!*\
  !*** ./src/angularjs/components/toggle/toggle.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  var unison = angular.module('unison');

  var template = '\n<cu-toggle-container \n    ng-click="$ctrl.onClick()" \n    ng-class="{ \'cu-toggle-on\': $ctrl.value }"\n    ng-disabled="$ctrl.disabled();"\n    tabindex="-1" \n    ct-toggle\n>\n  <cu-toggle-tray></cu-toggle-tray>\n  <cu-toggle-ball></cu-toggle-ball>\n</cu-toggle-container>\n  ';

  unison.component('cuToggle', {
    bindings: {
      value: '<',
      onChange: '&',
      disabled: '&ngDisabled'
    },
    template: template,
    controller: function controller() {
      var _this = this;

      this.$onInit = function () {
        _this.value = _this.value === undefined ? false : !!_this.value;
      };

      this.onClick = function () {
        if (!_this.disabled()) {
          _this.onChange({ $cuValue: !_this.value });
        }
      };
    }
  });
})();

/***/ }),

/***/ "./src/angularjs/components/tooltip/tooltip.js":
/*!*****************************************************!*\
  !*** ./src/angularjs/components/tooltip/tooltip.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  angular.module('unison').component('cuTooltip', {
    template: '<cu-popover \n                    positioning-strategy="$ctrl.positioningStrat" \n                    open-on-hover="::true"\n                    append-to-body="::true"\n                    close-on-scroll="::true"\n                    steal-focus="::false"\n                    ng-disabled="$ctrl.disabled()"\n                >\n                <cu-popover-target class="cu-d-inline-block">\n                    <ng-transclude ng-transclude-slot="target"></ng-transclude>\n                  </cu-popover-target>\n                <cu-popover-content><ng-transclude ng-transclude-slot="content"></ng-transclude></cu-popover-content>\n              </cu-popover>',
    bindings: {
      positioningStrategy: '<?',
      disabled: '&ngDisabled'
    },
    transclude: {
      target: 'cuTooltipTarget',
      content: 'cuTooltipContent'
    },
    controller: function TooltipCtrl() {
      this.$onInit = function TooltipOnInit() {
        this.positioningStrat = this.positioningStrategy || {};
        this.positioningStrat.align = this.positioningStrat.align || 'center';
      };
    }
  });
})();

/***/ }),

/***/ "./src/angularjs/directives/auto-focus/auto-focus.js":
/*!***********************************************************!*\
  !*** ./src/angularjs/directives/auto-focus/auto-focus.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  angular.module('unison').directive('cuAutoFocus', function () {
    return {
      restrict: 'A',
      link: function link(scope, element) {
        element[0].focus();
      }
    };
  });
})();

/***/ }),

/***/ "./src/angularjs/directives/button-popover-handle.js":
/*!***********************************************************!*\
  !*** ./src/angularjs/directives/button-popover-handle.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2017 by Curalate, Inc.
//


/*
This directive is used to hide an element that must retain focus when hidden.
Display: none or visibility hidden will cause the element to lose focus, which
could trigger undesired behavior, like closing a containing popover.
 */
(function () {
  angular.module('unison').directive('cuButtonPopoverHandle', ['$compile', function ($compile) {
    return {
      restrict: 'A',
      link: function link(scope, element) {
        element.addClass('cu-d-flex cu-justify-content-between cu-align-items-center cu-w-100').append($compile('<cu-icon name="chevron-down" class="cu-ml-2"></cu-icon>')(scope));
      }
    };
  }]);
})();

/***/ }),

/***/ "./src/angularjs/directives/events.js":
/*!********************************************!*\
  !*** ./src/angularjs/directives/events.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  ['focusout', 'load', 'error'].forEach(function (eventName) {
    var directiveName = 'cu' + eventName[0].toUpperCase() + eventName.slice(1, eventName.length);

    angular.module('unison').directive(directiveName, ['$parse', function UnisonEventDirective($parse) {
      return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
          element.on(eventName, function (event) {
            scope.$evalAsync(function () {
              $parse(attrs[directiveName])(scope, { $event: event });
            });
          });
        }
      };
    }]);
  });
})();

/***/ }),

/***/ "./src/angularjs/directives/hide-focusable.js":
/*!****************************************************!*\
  !*** ./src/angularjs/directives/hide-focusable.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2017 by Curalate, Inc.
//


/*
This directive is used to hide an element that must retain focus when hidden.
Display: none or visibility hidden will cause the element to lose focus, which
could trigger undesired behavior, like closing a containing popover.
 */
(function () {
  angular.module('unison').directive('cuHideFocusable', function () {
    return {
      restrict: 'A',
      link: function link(scope, element, attr) {
        scope.$watch(attr.cuHideFocusable, function (hide) {
          element.css({
            opacity: +!hide,
            'pointer-events': hide ? 'none' : ''
          });
        });
      }
    };
  });
})();

/***/ }),

/***/ "./src/angularjs/directives/page-scroll-to-top/page-scroll-to-top.js":
/*!***************************************************************************!*\
  !*** ./src/angularjs/directives/page-scroll-to-top/page-scroll-to-top.js ***!
  \***************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  angular.module('unison').directive('cuPageScrollToTop', function () {
    return {
      restrict: 'A',
      link: function link(scope, element) {
        var el = element[0];

        while (el && el.tagName) {
          if (el.tagName === 'CU-PAGE-FRAME-SCROLL-WRAP') {
            el.scrollTop = 0;
            break;
          }

          el = el.parentNode;
        }
      }
    };
  });
})();

/***/ }),

/***/ "./src/angularjs/directives/table-header-sort/table-header-sort.js":
/*!*************************************************************************!*\
  !*** ./src/angularjs/directives/table-header-sort/table-header-sort.js ***!
  \*************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  angular.module('unison').directive('cuTableHeaderSort', ['$compile', '$log', function ($compile, $log) {
    return {
      restrict: 'A',
      link: function link(scope, element) {
        if (element[0].tagName.toUpperCase() !== 'TH') {
          $log.error('cuTableHeaderSort directive must be placed on a TH element');
          return;
        }

        element.prepend($compile('<cu-icon name="chevron-down"></cu-icon>')(scope));
      }
    };
  }]);
})();

/***/ }),

/***/ "./src/angularjs/directives/visible.js":
/*!*********************************************!*\
  !*** ./src/angularjs/directives/visible.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  angular.module('unison').directive('cuVisible', function () {
    return {
      restrict: 'A',
      link: function link(scope, element, attr) {
        scope.$watch(attr.cuVisible, function (visible) {
          element.css('visibility', visible ? 'visible' : 'hidden');
        });
      }
    };
  });
})();

/***/ }),

/***/ "./src/angularjs/directives/with-unison/with-unison.js":
/*!*************************************************************!*\
  !*** ./src/angularjs/directives/with-unison/with-unison.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  var unison = angular.module('unison');

  unison.directive('withUnison', function () {
    return {
      restrict: 'AE',

      link: function link(scope, element) {
        element.addClass('unison-component');
      }
    };
  });
})();

/***/ }),

/***/ "./src/angularjs/factories/list-manager/list-manager.js":
/*!**************************************************************!*\
  !*** ./src/angularjs/factories/list-manager/list-manager.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _agnosticListManager = __webpack_require__(/*! ../../../common/agnostic-list-manager.ts */ "./src/common/agnostic-list-manager.ts");

(function () {
  angular.module('unison').factory('cuListManagerFactory', ['$timeout', function ListManager($timeout) {
    return function createListManager() {
      return new _agnosticListManager.AgnosticListManager($timeout);
    };
  }]);
})(); //
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/***/ }),

/***/ "./src/angularjs/index.js":
/*!********************************!*\
  !*** ./src/angularjs/index.js ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(/*! ./unison */ "./src/angularjs/unison.js");

__webpack_require__(/*! ./components/alert/alert */ "./src/angularjs/components/alert/alert.js");

__webpack_require__(/*! ./components/calendar/calendar */ "./src/angularjs/components/calendar/calendar.js");

__webpack_require__(/*! ./components/combo-button/combo-button-options */ "./src/angularjs/components/combo-button/combo-button-options.js");

__webpack_require__(/*! ./components/combo-button/combo-button */ "./src/angularjs/components/combo-button/combo-button.js");

__webpack_require__(/*! ./components/counter/counter */ "./src/angularjs/components/counter/counter.js");

__webpack_require__(/*! ./components/date-picker/date-picker-panel */ "./src/angularjs/components/date-picker/date-picker-panel.js");

__webpack_require__(/*! ./components/date-picker/date-picker */ "./src/angularjs/components/date-picker/date-picker.js");

__webpack_require__(/*! ./components/date-range-picker/date-range-picker-footnote */ "./src/angularjs/components/date-range-picker/date-range-picker-footnote.js");

__webpack_require__(/*! ./components/date-range-picker/date-range-picker-panel */ "./src/angularjs/components/date-range-picker/date-range-picker-panel.js");

__webpack_require__(/*! ./components/date-range-picker/date-range-picker */ "./src/angularjs/components/date-range-picker/date-range-picker.js");

__webpack_require__(/*! ./components/date-range-picker/date-restricted-input */ "./src/angularjs/components/date-range-picker/date-restricted-input.js");

__webpack_require__(/*! ./components/gravatar/gravatar */ "./src/angularjs/components/gravatar/gravatar.js");

__webpack_require__(/*! ./components/icon/icon */ "./src/angularjs/components/icon/icon.js");

__webpack_require__(/*! ./components/menu/menu-item */ "./src/angularjs/components/menu/menu-item.js");

__webpack_require__(/*! ./components/menu/menu-items */ "./src/angularjs/components/menu/menu-items.js");

__webpack_require__(/*! ./components/menu/menu-submenu-header */ "./src/angularjs/components/menu/menu-submenu-header.js");

__webpack_require__(/*! ./components/menu/menu-submenu-item */ "./src/angularjs/components/menu/menu-submenu-item.js");

__webpack_require__(/*! ./components/modal/modal */ "./src/angularjs/components/modal/modal.js");

__webpack_require__(/*! ./components/nav-tabs/nav-item */ "./src/angularjs/components/nav-tabs/nav-item.js");

__webpack_require__(/*! ./components/nav-tabs/nav-menu-item */ "./src/angularjs/components/nav-tabs/nav-menu-item.js");

__webpack_require__(/*! ./components/nav-tabs/nav-tabs */ "./src/angularjs/components/nav-tabs/nav-tabs.js");

__webpack_require__(/*! ./components/nav-tabs/nav-tabs-vertical */ "./src/angularjs/components/nav-tabs/nav-tabs-vertical.js");

__webpack_require__(/*! ./components/page-frame/page-frame */ "./src/angularjs/components/page-frame/page-frame.js");

__webpack_require__(/*! ./components/pagination-controls/pagination-controls */ "./src/angularjs/components/pagination-controls/pagination-controls.js");

__webpack_require__(/*! ./components/popover/popover */ "./src/angularjs/components/popover/popover.js");

__webpack_require__(/*! ./components/progress-bar/progress-bar */ "./src/angularjs/components/progress-bar/progress-bar.js");

__webpack_require__(/*! ./components/radio-button-group/radio-button-group */ "./src/angularjs/components/radio-button-group/radio-button-group.js");

__webpack_require__(/*! ./components/radio-button-group/radio-button-option */ "./src/angularjs/components/radio-button-group/radio-button-option.js");

__webpack_require__(/*! ./components/radio-group/radio-group */ "./src/angularjs/components/radio-group/radio-group.js");

__webpack_require__(/*! ./components/radio-group/radio-option */ "./src/angularjs/components/radio-group/radio-option.js");

__webpack_require__(/*! ./components/scrim/scrim */ "./src/angularjs/components/scrim/scrim.js");

__webpack_require__(/*! ./components/search-bar/search-bar */ "./src/angularjs/components/search-bar/search-bar.js");

__webpack_require__(/*! ./components/select/select-item */ "./src/angularjs/components/select/select-item.js");

__webpack_require__(/*! ./components/select/select */ "./src/angularjs/components/select/select.js");

__webpack_require__(/*! ./components/slider/slider */ "./src/angularjs/components/slider/slider.js");

__webpack_require__(/*! ./components/spinner/spinner.ts */ "./src/angularjs/components/spinner/spinner.ts");

__webpack_require__(/*! ./components/table-pagination-controls/table-pagination-controls */ "./src/angularjs/components/table-pagination-controls/table-pagination-controls.js");

__webpack_require__(/*! ./components/time-picker/time-picker */ "./src/angularjs/components/time-picker/time-picker.js");

__webpack_require__(/*! ./components/time-picker/time-picker-panel */ "./src/angularjs/components/time-picker/time-picker-panel.js");

__webpack_require__(/*! ./components/toggle/toggle */ "./src/angularjs/components/toggle/toggle.js");

__webpack_require__(/*! ./components/tooltip/tooltip */ "./src/angularjs/components/tooltip/tooltip.js");

__webpack_require__(/*! ./directives/auto-focus/auto-focus */ "./src/angularjs/directives/auto-focus/auto-focus.js");

__webpack_require__(/*! ./directives/button-popover-handle */ "./src/angularjs/directives/button-popover-handle.js");

__webpack_require__(/*! ./directives/events */ "./src/angularjs/directives/events.js");

__webpack_require__(/*! ./directives/hide-focusable */ "./src/angularjs/directives/hide-focusable.js");

__webpack_require__(/*! ./directives/page-scroll-to-top/page-scroll-to-top */ "./src/angularjs/directives/page-scroll-to-top/page-scroll-to-top.js");

__webpack_require__(/*! ./directives/table-header-sort/table-header-sort */ "./src/angularjs/directives/table-header-sort/table-header-sort.js");

__webpack_require__(/*! ./directives/visible */ "./src/angularjs/directives/visible.js");

__webpack_require__(/*! ./directives/with-unison/with-unison */ "./src/angularjs/directives/with-unison/with-unison.js");

__webpack_require__(/*! ./factories/list-manager/list-manager */ "./src/angularjs/factories/list-manager/list-manager.js");

__webpack_require__(/*! ./services/date-lite/date-lite.service */ "./src/angularjs/services/date-lite/date-lite.service.js");

/***/ }),

/***/ "./src/angularjs/services/date-lite/date-lite.service.js":
/*!***************************************************************!*\
  !*** ./src/angularjs/services/date-lite/date-lite.service.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _dateUtils = __webpack_require__(/*! ../../../common/date-utils/dateUtils.ts */ "./src/common/date-utils/dateUtils.ts");

var DateUtils = _interopRequireWildcard(_dateUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

angular.module('unison').service('cuDateLiteService', function () {
  return DateUtils;
}); //
// Copyright (c) 2011-2020 by Curalate, Inc.
//

/***/ }),

/***/ "./src/angularjs/unison.js":
/*!*********************************!*\
  !*** ./src/angularjs/unison.js ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  angular.module('unison', ['ngAnimate']);
})();

/***/ }),

/***/ "./src/common/agnostic-list-manager.ts":
/*!*********************************************!*\
  !*** ./src/common/agnostic-list-manager.ts ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
Object.defineProperty(exports, "__esModule", { value: true });
var typeaheadCancelKeyCodes = [13, 37, 38, 39, 40];
var AgnosticListManager = /** @class */ (function () {
    function AgnosticListManager($timeout) {
        var _this = this;
        this.$timeout = $timeout;
        this.items = [];
        this.itemsByValue = {};
        this.typeaheadValue = '';
        this.typeaheadTimeout = null;
        this.setItems = function (items) {
            _this.items = items;
            _this.itemsByValue = _this.createItemsByValue(items);
        };
    }
    AgnosticListManager.prototype.createItemsByValue = function (items, parent, itemsByValueAcc) {
        var itemsByValue = itemsByValueAcc || {};
        for (var i = 0; i < items.length; i += 1) {
            var item = items[i];
            item.index = i;
            item.typeaheadValue = item.typeaheadValue === undefined ? item.label : item.typeaheadValue;
            itemsByValue[item.value] = item;
            if (parent) {
                item.parent = parent;
            }
            if (i < items.length - 1) {
                item.next = items[i + 1];
            }
            if (i > 0) {
                item.prev = items[i - 1];
            }
            if (item.children) {
                this.createItemsByValue(item.children, item, itemsByValue);
            }
        }
        return itemsByValue;
    };
    AgnosticListManager.prototype.nextItem = function (itemOrValue) {
        var item = typeof itemOrValue !== 'object' ? this.itemsByValue[itemOrValue] : itemOrValue;
        return item ? item.next || item : this.items[0];
    };
    AgnosticListManager.prototype.prevItem = function (itemOrValue) {
        var item = typeof itemOrValue !== 'object' ? this.itemsByValue[itemOrValue] : itemOrValue;
        return item ? item.prev || item : this.items[this.items.length - 1];
    };
    AgnosticListManager.prototype.parent = function (itemOrValue) {
        var item = typeof itemOrValue !== 'object' ? this.itemsByValue[itemOrValue] : itemOrValue;
        return item.parent;
    };
    AgnosticListManager.prototype.children = function (itemOrValue) {
        var item = typeof itemOrValue !== 'object' ? this.itemsByValue[itemOrValue] : itemOrValue;
        return item.children;
    };
    AgnosticListManager.prototype.siblings = function (itemOrValue) {
        var item = typeof itemOrValue !== 'object' ? this.itemsByValue[itemOrValue] : itemOrValue;
        if (item && item.parent) {
            return item.parent.children;
        }
        return this.items;
    };
    AgnosticListManager.prototype.ancestors = function (itemOrValue) {
        var _a;
        var item = typeof itemOrValue !== 'object' ? this.itemsByValue[itemOrValue] : itemOrValue;
        var ancestors = [];
        var currItem = item;
        while ((_a = currItem) === null || _a === void 0 ? void 0 : _a.parent) {
            ancestors.push(currItem.parent);
            currItem = currItem.parent;
        }
        return ancestors;
    };
    AgnosticListManager.prototype.registerTypeaheadListener = function (element, fn) {
        var _this = this;
        element.on('keydown', function (event) {
            // Currently only the AngularJS version of the select uses a Timeout
            if (!_this.$timeout) {
                return;
            }
            if (_this.typeaheadTimeout) {
                _this.$timeout.cancel(_this.typeaheadTimeout);
            }
            if (typeaheadCancelKeyCodes.indexOf(event.keyCode) !== -1) {
                return;
            }
            _this.typeaheadValue += String.fromCharCode(event.keyCode).toLowerCase();
            _this.typeaheadTimeout = _this.$timeout(function () {
                _this.typeaheadValue = '';
                _this.typeaheadTimeout = null;
            }, 1000);
            fn(_this.typeaheadValue);
        });
    };
    return AgnosticListManager;
}());
exports.AgnosticListManager = AgnosticListManager;


/***/ }),

/***/ "./src/common/date-utils/dateUtils.ts":
/*!********************************************!*\
  !*** ./src/common/date-utils/dateUtils.ts ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//
// Copyright (c) 2011-2020 by Curalate, Inc.
//
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
function createDateLite() {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var date = new ((_a = Date).bind.apply(_a, __spreadArrays([void 0], args)))();
    date.setHours(0, 0, 0, 0);
    return date;
}
exports.createDateLite = createDateLite;
exports.MONTH_NAMES = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
/** Gets a date range object with the calculated start/end dates for the given alias. */
exports.getDateRangeFromAlias = function (alias) { return ({
    alias: alias,
    startDate: exports.ALIASES[alias].start(),
    endDate: exports.ALIASES[alias].end(),
}); };
exports.ALIASES = {
    today: {
        name: 'today',
        display: 'Today',
        start: function () { return exports.today(); },
        end: function () { return exports.today(); },
    },
    last24Hours: {
        name: 'last24Hours',
        display: 'Last 24 Hours',
        start: function () { return exports.today(); },
        end: function () { return exports.today(); },
    },
    last7Days: {
        name: 'last7Days',
        display: 'Last 7 Days',
        start: function () { return createDateLite(exports.todayYear(), exports.todayMonth(), exports.todayDate() - 6); },
        end: function () { return exports.today(); },
    },
    last30Days: {
        name: 'last30Days',
        display: 'Last 30 Days',
        start: function () { return createDateLite(exports.todayYear(), exports.todayMonth(), exports.todayDate() - 29); },
        end: function () { return exports.today(); },
    },
    last90Days: {
        name: 'last90Days',
        display: 'Last 90 Days',
        start: function () { return createDateLite(exports.todayYear(), exports.todayMonth(), exports.todayDate() - 89); },
        end: function () { return exports.today(); },
    },
    last3Months: {
        name: 'last3Months',
        display: 'Last 3 Months',
        start: function () { return createDateLite(exports.todayYear(), exports.todayMonth() - 3, exports.todayDate()); },
        end: function () { return exports.today(); },
    },
    last1Year: {
        name: 'last1Year',
        display: 'Last 1 Year',
        start: function () { return createDateLite(exports.todayYear() - 1, exports.todayMonth(), exports.todayDate()); },
        end: function () { return exports.today(); },
    },
    allTime: {
        name: 'allTime',
        display: 'All Time',
        start: function () { return createDateLite(0); },
        end: function () { return exports.today(); },
    },
    custom: {
        name: 'custom',
        display: 'Custom',
    },
};
exports.genesis = createDateLite(0);
exports.genesisYear = exports.genesis.getFullYear();
exports.maxDate = createDateLite('12/31/3000');
exports.today = function () { return createDateLite(); };
exports.todayYear = function () { return exports.today().getFullYear(); };
exports.todayMonth = function () { return exports.today().getMonth(); };
exports.todayDate = function () { return exports.today().getDate(); };
exports.getAbsoluteMonth = function (date) {
    return ((date.getFullYear() - exports.genesisYear) * 12) + date.getMonth();
};
/** Gets a MM/DD/YY string for the given Date object */
exports.dateToString = function (date) {
    var rawYear = date.getFullYear();
    var formattedYear = rawYear.toString().substr(2, 2);
    var rawMonth = date.getMonth() + 1;
    var formattedMonth = rawMonth < 10 ? "0" + rawMonth : rawMonth;
    var rawDay = date.getDate();
    var formattedDay = rawDay < 10 ? "0" + rawDay : rawDay;
    return formattedMonth + "/" + formattedDay + "/" + formattedYear;
};
exports.numDaysInMonth = function (month, year) { return new Date(year, month + 1, 0).getDate(); };
exports.isDateValid = function (date) { return +date === +date; };
exports.dateStringRegex = /([0-9]{1,2})\/([0-9]{1,2})\/([0-9]{4}|[0-9]{2})$/;
exports.isDateStringValid = function (str) {
    var match = str.match(exports.dateStringRegex);
    var date = createDateLite(str);
    if (!match || !exports.isDateValid(date)) {
        return false;
    }
    var monthNum = parseInt(match[1], 10);
    var yearNum = parseInt(match[3], 10);
    var numDays = exports.numDaysInMonth(monthNum - 1, yearNum);
    if (date.getDate() > numDays || monthNum - 1 !== date.getMonth()) {
        return false;
    }
    return true;
};
/** Checks if the given date falls between the a set of start and end dates */
exports.contains = function (date, start, end) { return +date >= +start && +date <= +end; };
exports.msPerDay = 1000 * 60 * 60 * 24;


/***/ }),

/***/ "./src/common/popover.ts":
/*!*******************************!*\
  !*** ./src/common/popover.ts ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.POPOVER_OFFSET = 12;
exports.POPOVER_NO_ARROW_OFFSET = 4;
exports.CUSTOM_POSITIONING_TARGET_SELECTOR = '[cu-popover-positioning-target]';
exports.DEFAULT_POSITIONING_STRATEGY = {
    align: ['left', 'right'],
    fixed: ['bottom', 'top'],
};
function invert(direction) {
    switch (direction) {
        case 'top': return 'bottom';
        case 'bottom': return 'top';
        case 'left': return 'right';
        case 'right': return 'left';
    }
}
exports.invert = invert;
function rotate(direction) {
    switch (direction) {
        case 'top': return 'left';
        case 'bottom': return 'right';
        case 'left': return 'bottom';
        case 'right': return 'top';
    }
}
exports.rotate = rotate;
function control(direction) {
    switch (direction) {
        case 'top':
        case 'bottom': return 'top';
        case 'left':
        case 'right': return 'left';
    }
}
exports.control = control;
function dimension(direction) {
    switch (direction) {
        case 'top':
        case 'bottom': return 'height';
        case 'left':
        case 'right': return 'width';
    }
}
exports.dimension = dimension;
function computeCushions(positionMetrics, fixedOffset) {
    var targetBox = positionMetrics.targetBox, contentDimensions = positionMetrics.contentDimensions, windowBox = positionMetrics.windowBox;
    // Fixed cushions represent the amount of free space remaining if the
    // popover content was to be opened in a certain direction.
    var fixedCushions = {
        bottom: windowBox.height - targetBox.bottom
            - contentDimensions.height - fixedOffset,
        left: targetBox.left - contentDimensions.width - fixedOffset,
        right: windowBox.width - targetBox.right
            - contentDimensions.width - fixedOffset,
        top: targetBox.top - contentDimensions.height - fixedOffset,
    };
    // Align cushions represent the amount of free space remaining if the
    // popover content was to have one of it's sides aligned with the corresponding
    // side of the target box. For example, the alignLeftCushion represents how much
    // free space would remain to the right if the left edge of the content was aligned
    // with the left edge of the target.
    var alignCushions = {
        bottom: fixedCushions.top + targetBox.height,
        left: fixedCushions.right + targetBox.width,
        right: fixedCushions.left + targetBox.width,
        top: fixedCushions.bottom + targetBox.height,
    };
    return {
        alignCushions: alignCushions,
        fixedCushions: fixedCushions,
    };
}
/**
 * Determine the final positioning strategy to be used for the popover, based on the available metrics.
 * @param positionMetrics Relevant metrics for positioning logic
 * @param positioningStrategies Positioning & alignment options to consider
 * @param fixedOffset How far the popover content must be offset from the popover target (default is arrow size)
 *
 * @returns Finalized positioning strategy to use for the popover content.
 */
function determinePositioningStrategies(positionMetrics, positioningStrategies, fixedOffset) {
    // Calculate how much free space we have remaining around the popover content if we open it in each direction
    var _a = computeCushions(positionMetrics, fixedOffset), fixedCushions = _a.fixedCushions, alignCushions = _a.alignCushions;
    // Determine which direction we'll use to pop the popover out
    var fixedDirection = (function () {
        var fixedDirectionStrategy = positioningStrategies.fixed;
        // Given an array of strategies to use...
        if (Array.isArray(fixedDirectionStrategy)) {
            // Pick the first one that "fits", e.g. more than 0 pixels of space available if used.
            var preferredFixedDirection = fixedDirectionStrategy
                .filter(function (_) { return fixedCushions[_] >= 0; })[0];
            // If we don't have one (if the window is undersized, e.g.), pick the roomiest direction.
            return preferredFixedDirection || fixedDirectionStrategy.sort(function (a, b) {
                return fixedCushions[b] - fixedCushions[a];
            })[0];
        }
        // If we were given a single direction strategy option, use that.
        return fixedDirectionStrategy;
    })();
    // Determine which side of the popover target we'll align the popover content to.
    var alignDirection = (function () {
        var alignStrategy = positioningStrategies.align;
        // Given an array of strategies to use...
        if (Array.isArray(alignStrategy)) {
            // Pick the first one that "fits", e.g. more than 0 pixels of space available if used.
            var validAlignDirections = alignStrategy
                .filter(function (_) { return alignCushions[_] >= 0; });
            // If none is available, default to screen-center;
            return validAlignDirections.length > 0 ? validAlignDirections[0] : 'screen-center';
        }
        // If we were given a single align strategy option, use that.
        return alignStrategy;
    })();
    return {
        align: alignDirection,
        fixed: fixedDirection,
    };
}
exports.determinePositioningStrategies = determinePositioningStrategies;
function calculatePositioning(metrics, options) {
    var windowBox = metrics.windowBox, targetBox = metrics.targetBox, contentDimensions = metrics.contentDimensions;
    var contentStyles = {};
    var arrowStyles = {};
    var fixedStyle = options.fixedDirection === 'top' || options.fixedDirection === 'left' ?
        (windowBox[invert(options.fixedDirection)] - targetBox[options.fixedDirection]) + options.fixedOffset + "px" :
        (windowBox[invert(options.fixedDirection)] + targetBox[options.fixedDirection]) + options.fixedOffset + "px";
    contentStyles[invert(options.fixedDirection)] = fixedStyle;
    arrowStyles[invert(options.fixedDirection)] = fixedStyle;
    switch (options.alignDirection) {
        case 'screen-center': {
            var alignDirection = control(rotate(options.fixedDirection));
            var alignDimension = dimension(rotate(options.fixedDirection));
            contentStyles[alignDirection] = (windowBox[alignDimension] - contentDimensions[alignDimension]) / 2 + "px";
            arrowStyles[alignDirection] = targetBox[alignDirection] + (targetBox[alignDimension] / 2) + "px";
            break;
        }
        case 'center': {
            var alignDirection = control(rotate(options.fixedDirection));
            var alignDimension = dimension(rotate(options.fixedDirection));
            var targetBoxCenter = targetBox[alignDirection] + (targetBox[alignDimension] / 2);
            arrowStyles[alignDirection] = targetBoxCenter + "px";
            contentStyles[alignDirection] = targetBoxCenter - (contentDimensions[alignDimension] / 2) + "px";
            break;
        }
        default: {
            contentStyles[options.alignDirection] = options.alignDirection === 'top' || options.alignDirection === 'left' ?
                windowBox[options.alignDirection] + targetBox[options.alignDirection] + "px" :
                windowBox[options.alignDirection] - targetBox[options.alignDirection] + "px";
            arrowStyles[options.alignDirection] = contentStyles[options.alignDirection];
            break;
        }
    }
    return {
        arrowStyles: arrowStyles,
        contentStyles: contentStyles,
    };
}
exports.calculatePositioning = calculatePositioning;


/***/ }),

/***/ "angular":
/*!**************************!*\
  !*** external "angular" ***!
  \**************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_angular__;

/***/ })

/******/ });
});
//# sourceMappingURL=unison.js.map